/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Component, createRef } from "react";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import PropTypes from "prop-types";
import axios from "axios";
import classNames from "classnames";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Actions from "@redux/app";
import { isCancelError } from "@utils/network";
import ProgressButton from "react-progress-button";
import MaskedInput from "react-text-mask";

import {
	StaffService,
	AssignmentRulesService,
	OfficerService,
	RegionSearchService,
	OrganizationService,
	AccountService,
	JurisdictionService,
	JurisdictionFeeService,
	GenericService,
	PaymentService,
	ClientService,
	InvoicingRuleService,
	TagService,
	OrganizationFavoriteGroupsService,
	OrganizationOfficerConstraintsService,
	PayCodesService,
	OfficerCallOffPenaltyRulesService,
} from "@services";
import {
	JURISDICTION_EXPIRES_OPTIONS,
	JURISDICTION_FEE_TYPES,
	BANK_ACCOUNT_STATUSES,
	CARD_ICONS,
	TIE_BREAKER_TYPES,
	INVOICING_RULE_CATEGORIES,
	MAX_WEEKLY_HOURS_TYPES,
	PITTSBURGH_ORGANIZATION_ID,
	ORGANIZATION_FEE_TYPES,
	LEA_JOB_RESTRICTION_TYPE_IDS,
} from "@constants";
import utils from "@utils";
import {
	SettingsMenu,
	AgencyRulesModal,
	BillingHistoryModal,
	PaycodesModal,
	OrganizationEmailModal,
	ManageAssignmentsModal,
	StaggeredRuleModal,
	AssignmentRulesModal,
	OfficerCallOffPenaltiesSection,
	InvoicingRulesModal,
	AuthenticationSection,
	OrganizationDepositAccountSelect,
	ManageVehiclesModal,
} from "./components";
import {
	AsyncSelect,
	ReactSelect,
	SelectBadges,
	ConfirmationModal,
	AddPaymentMethodModal,
	BankVerificationModal,
	EditImageModal,
	Loader,
	Image,
	Tooltip,
	DirectDepositAccountModal,
	RichTextEditor,
} from "../../components";
import YesNoRadioButton from "./ui/YesNoRadioButton";

import "./AgencyAccount.scss";
import OfficerCallOffSection from "./components/OfficerCallOffSection/OfficerCallOffSection";
import PayCodesTable from "./components/PayCodesTable/PayCodesTable";
import LandingPagePreview from "./LandingPagePreview";

class AgencyAccount extends Component {
	constructor(props) {
		super(props);

		const {
			user,
			flags: { departmentRulesConfig, onDutyHourlyLimits, strictLocationManagement, preventOfficerOffsiteClockIn },
		} = props;
		this.hasDeptRulesEnabled = !!departmentRulesConfig;
		this.hasPreventOfficerOffsiteClockInEnabled = !!preventOfficerOffsiteClockIn;
		this.isPittsburghOrg = user?.Organization.Id === PITTSBURGH_ORGANIZATION_ID;
		this.hasOnDutyHourlyLimitsEnabled = !!onDutyHourlyLimits;
		this.strictLocationManagementEnabled = !!strictLocationManagement;
		// Non-coordinator (both external and internal) users who are not admins for their org cannot see this page
		if (
			(!user.isCoordinator() && !user.IsInternalCoordinator && !user.IsStaffAdmin) ||
			(user.isCoordinator() && !user.IsStaffAdmin)
		) {
			window.location.href = "/";
		}

		this.uploadInput = null;

		this.state = {
			activeSection: "information",
			buttonState: "",
			validImageSelected: true,
			uploadingImage: false,
			OrganizationLogoId: null,
			loadingDeptRules: false,
			profilePicUrl: "",
			jurisdiction: "",
			contacts: [],
			jobTags: [],
			initialJobTags: [],
			paycodes: [],
			invoiceRules: [],
			ranks: [],
			agencyInfo: {
				Name: "",
				BillingContactId: "",
				OrganizationEmail: "",
				PaymentDetails: "",
				TimeZone: "",
				CustomPolicies: user.Organization.CustomPolicies || "",
				NameForDisplay: user.Organization.NameForDisplay || user.Organization.Name || "",
			},
			officerApproval: {
				SkipOfficerReVerification: false,
				PreventOfficerAssignmentOverride: false,
			},
			LockOfficerInfo: false,
			KeepJobsPosted: false,
			showAgencyRulesModal: false,
			assignmentRuleId: null,
			showAssignmentRulesModal: false,
			showManageAssignmentsModal: false,
			showStaggeredRulesModal: false,
			showManageVehiclesModal: false,
			staggeredRuleId: null,
			agencyAssignmentRules: {},
			assignmentRulesDetailed: [],
			staggeredRules: [
				{ Id: 11, Name: "Staggered rule 1" },
				{ Id: 12, Name: "Staggered rule 2" },
			],
			showInvoicingRulesModal: false,
			assignmentRules: [],
			jobPaycodes: [],
			officerGroups: [],
			JobCallOffType: "",
			JobCallOffReplacementTypes: [],
			clients: [],
			JobCallOffExpirationMinutes: "1440",
			JobCallOffGracePeriodMinutes: "1440",
			HasGracePeriod: false,
			JobCallOffInitialTime: null,
			GracePeriodInitalTime: null,
			IsJobLocationApprovalRequired: false,
			OfficerInsuranceOptIn: false,
			hourlyRestrictions: {
				_limitedHours: false,
				_dailyRestriction: false,
				_weeklyRestriction: false,
				_customRestriction: false,
				_monthlyRestriction: false,
				MaxWeeklyHours: "1",
				MaxWeeklyHoursType: 1,
				AllowOfficerOverrideWeekly: false,
				IncludeBothOnOffDutyHoursWeekly: false,
				_weeklyTypeEndDay: "",
				MaxDailyHours: "1",
				AllowOfficerOverrideDaily: false,
				IncludeBothOnOffDutyHoursDaily: false,
				MaxMonthlyHours: "1",
				AllowOfficerOverrideMonthly: false,
				IncludeBothOnOffDutyHoursMonthly: false,
				MaxCustomHours: "1",
				CustomStart: new Date().toISOString().split("T")[0],
				CustomRecurringDays: "1",
				AllowOfficerOverrideCuston: false,
				IncludeBothOnOffDutyHoursCustom: false,
			},
			jobRestrictions: {
				JobRestrictionType: 0,
				JobLocationRestrictedCities: [],
				JobLocationRestrictedCounties: [],
			},
			allowedLocations: [],
			OfficerCoordinatedJobsVisible: false,
			RestrictJobsToOfficers: false,
			AcknowledgeDeptRules: false,
			ExtraDutyApprovalRequired: false,
			officerFulfillment: {
				RequiredJurisdictions: [],
				ExcludedJurisdictions: [],
				AllJurisdictions: [],
			},
			paymentInvoiceSettings: {
				TransferPaymentToJurisdiction: false,
				TransferCoordinatorPaymentToJurisdiction: false,
				IsPayCodeMandatory: false,
				InvoiceDisclaimer: "",
				PayCodesEnabled: false,
			},
			fees: {
				JurisdictionFees: [],
				JurisdictionAssets: [],
				JurisdictionVehicleFees: [],
			},
			usePenalties: false,
			callOffPenaltyId: null,
			penaltyType: 2,
			selectedDayPenaltyTimeframe: null,
			selectedMonthPenaltyTimeframe: null,
			numDaysTimeframe: null,
			lockoutTimeframe: 1,
			callOffPenaltyRules: [],
			vehicleTypes: [],
			RestrictedJobLocationTypes: [],
			IsJobLocationTypeRestricted: false,
			UseZones: false,
			showBillingHistoryModal: false,
			currentPaycode: null,
			showPaycodesModal: false,
			showEditImageModal: false,
			clockInAcknowledgeCloudFileId: null,
			clockInAcknowledgeCloudFileSourceFileName: null,
			imageToEdit: "",
			timezones: [],
			billingHistory: [],
			paymentMethods: {
				loading: false,
				data: [],
			},
			scheduleIntegration: {
				UseOnDutyScheduleIntegrations: false,
				CoordinatorsCanOverrideOnDutyScheduleConflicts: false,
				OfficersCanOverrideOnDutyScheduleConflicts: false,
			},
			organizationPaymentInvoiceSettings: {
				IsOfficerInvoiceApprovalRequired: false,
			},
			OnlyAuthorizedClientsAreAllowedToUseVehicles: false,
			RequireInvoicingForVehicles: false,
			RequireVehicleNumber: false,
			RequireVehicleMiles: false,
			TieBreaker: 0,
			organizationDepositAccounts: [],
			generalFeeDepositAccountId: null,
			equipmentFeeDepositAccountId: null,
			vehicleFeeDepositAccountId: null,
			isLoadingOrganizationDepositAccounts: false,
			AgencyUsersCanOnlyCreateJobsWithApprovedLocations: false,
			organizationDepositAccount: {},
			authenticationSettings: {
				MFAEnforced: false,
				FederationEnabled: false,
				FederatedDomain: "",
				FederationEnforcedBy: null,
			},
			showPreview: false,
			customPolicies: user.Organization.CustomPolicies || "",
			nameForDisplay: user.Organization.NameForDisplay || user.Organization.Name || "",
			hasPendingChanges: false,
			PreventOfficerOffSiteClockIn: false,
		};

		// Variables to retain unused properties for updating the agency settings
		this.officerRules = {};
		this.agencyRules = {};
		this.paymentRules = {};

		// Cancel tokens
		this.locationCancelToken = undefined;

		this.abortController = new AbortController();

		// Section refs for IntersectionObserver
		this.sectionRefs = {
			agencyInfo: createRef(),
			approvalAssignment: createRef(),
			authentication: createRef(),
			callOff: createRef(),
			callOffPenalties: createRef(),
			location: createRef(),
			insurance: createRef(),
			hourlyRestrictions: createRef(),
			jobRestrictions: createRef(),
			coordinatorJobs: createRef(),
			supervisorApproval: createRef(),
			fulfillment: createRef(),
			paymentInvoicing: createRef(),
			subscriptions: createRef(),
			assetsEquipment: createRef(),
			paymentMethods: createRef(),
			jobTags: createRef(),
			scheduleIntegration: createRef(),
		};
		this.settingsMenuTitle = createRef();
		this.confirmationModal = createRef();
		this.confirmationModal2 = createRef();
		this.deleteOfficerAcknowledgeConfirmationModal = createRef();
		this.bankVerificationModal = createRef();
		this.addPaymentMethodModal = createRef();
		this.organizationEmailModal = createRef();
		this.locationTypes = [];
	}

	componentDidMount() {
		const { user, router, route } = this.props;
		const {
			location: { hash },
		} = router;
		const {
			Organization: {
				OrganizationLogo: profilePicUrl,
				JurisdictionName: jurisdiction,
				OrganizationLogoId,
				Name,
				BillingContactId,
				OrganizationEmail,
				PaymentDetails,
				JobAutoAssignType,
				JobAutoAssignHoursSpan,
				JobAutoAssignJobCountDaysSpan,
				JobAutoAssignQueueCycleMaxAssignments,
				MaxHoursAssignmentPerCycle,
				JobAutoAssignYearToDateSpan,
				JobCallOffType,
				JobCallOffReplacementTypes,
				JobCallOffExpirationMinutes,
				JobCallOffGracePeriodMinutes,
				StripeSubscriptionEnabled,
				InvoiceDisclaimer = "",
				UseZones,
				TimeZone,
				PayCodesEnabled,
				IsOfficerInvoiceApprovalRequired,
				TieBreaker,
				CustomPolicies,
				NameForDisplay,
			},
		} = user;
		let _hoursMultiplier = 1;
		let adjustedHoursSpan = JobAutoAssignHoursSpan ?? "";
		if (JobAutoAssignHoursSpan && JobAutoAssignHoursSpan % 24 === 0) {
			_hoursMultiplier = 24;
			adjustedHoursSpan = parseInt(JobAutoAssignHoursSpan, 10) / 24;
		}

		// Service calls to retrieve the appropriate data
		this.getContacts();
		this.getClients();
		this.getTimeZones();
		this.getAssignmentRules();
		this.getStaggeredRules();
		this.getJobTags();
		this.getAgencyRestrictions();
		this.getOfficerGroups();
		this.getOfficerRanks();
		if (user.isLEA() || user.isCoordinator()) {
			this.getPaycodes();
		}
		if (user.isLEA()) {
			this.getVehicleTypes();
			this.getOfficerRules();
			this.getAgencyRulesAndLocationTypes();
			this.getPaymentRules();
			this.getJurisdictionFees();
			this.getCallOffPenalties();
			if (user.IsStaffAdmin) {
				this.getBillingHistory();
				this.getAuthenticationSettings();
				this.getOrganizationDepositAccounts();
				if (StripeSubscriptionEnabled) this.getPaymentMethods();
			}
			this.getInvoiceRules();
		}

		this.setState(prevState => ({
			OrganizationLogoId,
			profilePicUrl,
			jurisdiction,
			TieBreaker,
			agencyInfo: {
				Name,
				OrganizationEmail,
				CustomPolicies: CustomPolicies || "",
				NameForDisplay: NameForDisplay || Name || "",
				BillingContactId: BillingContactId ?? "",
				PaymentDetails: PaymentDetails ?? "",
				TimeZone: TimeZone ?? "",
			},
			agencyAssignmentRules: {
				_hoursMultiplier,
				_limitToRoundsChecked: false,
				JobAutoAssignType: JobAutoAssignType ?? 1,
				JobAutoAssignHoursSpan: adjustedHoursSpan,
				JobAutoAssignJobCountDaysSpan: JobAutoAssignJobCountDaysSpan ?? "",
				JobAutoAssignQueueCycleMaxAssignments: JobAutoAssignQueueCycleMaxAssignments ?? "",
				MaxHoursAssignmentPerCycle: MaxHoursAssignmentPerCycle ?? "",
				JobAutoAssignYearToDateSpan: JobAutoAssignYearToDateSpan ?? "",
			},
			paymentInvoiceSettings: {
				...prevState.paymentInvoiceSettings,
				InvoiceDisclaimer,
				PayCodesEnabled,
			},
			JobCallOffType: JobCallOffType ?? "",
			JobCallOffReplacementTypes: JobCallOffReplacementTypes ?? [],
			JobCallOffExpirationMinutes: JobCallOffExpirationMinutes ?? "1440",
			JobCallOffInitialTime: JobCallOffExpirationMinutes ?? "0",
			GracePeriodInitalTime: JobCallOffGracePeriodMinutes ?? "0",
			JobCallOffGracePeriodMinutes: JobCallOffGracePeriodMinutes ?? "0",
			HasGracePeriod: JobCallOffGracePeriodMinutes != null,
			UseZones,
			organizationPaymentInvoiceSettings: { IsOfficerInvoiceApprovalRequired },
			nameForDisplay: NameForDisplay || Name || "",
			customPolicies: CustomPolicies || "",
			hasPendingChanges: false,
		}));

		// Set up an IntersectionObserver to fix the menu in place when needed
		this.menuObserver = new IntersectionObserver(
			([entry]) => {
				if (!entry.isIntersecting) {
					document.getElementById("settings-menu").classList.add("fixed");
				} else {
					document.getElementById("settings-menu").classList.remove("fixed");
				}
			},
			{ root: null, rootMargin: "0px", threshold: 0 },
		);
		if (this.settingsMenuTitle.current)
			this.menuObserver.observe(this.settingsMenuTitle.current);

		/** Set up an IntersectionObserver to detect when a section has been scrolled to
		 * Super admins only have 3 sections, which causes issues in highlighting the correct section when scrolling
		 * Therefore, an IntersectionObserver won't be initialized for super admin users
		 */
		if (!user.isSuperAdmin()) {
			this.sectionObserver = new IntersectionObserver(
				sections => {
					const pageOffset = window.pageYOffset;
					const firstSection = Object.values(this.sectionRefs).find(
						ref => ref.current,
					).current;
					if (pageOffset === 0 && firstSection) {
						this.setState({ activeSection: firstSection.id });
					} else {
						sections.forEach(section => {
							if (section.isIntersecting) {
								const { target } = section;
								/** We are first looking at the id of the target element since refs for Agency Information
								 * and Officer Approval & Assignment Rules are placed on the entire panel instead of the
								 * panel header. This is because one of these sections are the first that will appear for a user,
								 * so if the entire panel is not referenced the observer will never detect that they have been scrolled to
								 */
								this.setState({
									activeSection: target.id || target.parentElement.id,
								});
							}
						});
					}
				},
				{ root: null, rootMargin: "-15% 0px -84% 0px", threshold: 0.01 },
			);
			Object.values(this.sectionRefs).forEach(({ current }) => {
				if (current) {
					this.sectionObserver.observe(current);
				}
			});
		}

		// TODO: Figure out how to get this to scroll after data has been loaded so it goes to the right place
		if (hash) {
			const id = hash.replace("#", "");
			this.scrollToSection(id);
		}

		router.setRouteLeaveHook(route, this.handleBeforeUnload);
		window.addEventListener("beforeunload", this.handleBeforeUnload);
	}

	componentWillUnmount() {
		const { user } = this.props;

		// Cancel in progress requests
		this.abortController.abort();

		// Cancel all IntersectionObserver subscriptions
		this.menuObserver.disconnect();
		if (!user.isSuperAdmin()) {
			this.sectionObserver.disconnect();
		}

		window.removeEventListener("beforeunload", this.handleBeforeUnload);
	}

	handleBeforeUnload = event => {
		const { lang } = global;
		const { hasPendingChanges } = this.state;

		if (hasPendingChanges) {
			const message = lang.t(
				"You have unsaved changes_ Leaving this page will discard them_ Are you sure you want to leave_",
			);

			if (event) {
				// eslint-disable-next-line no-param-reassign
				event.returnValue = message;
			}

			return message;
		}

		return undefined;
	};

	/**
	 * Scrolls to the designated section clicked on by the user
	 * @param {Number} id The unique id of section being scrolled to
	 */
	scrollToSection = id => {
		const { activeSection } = this.state;
		// If no ID provided, scroll to the top of the page
		if (!id) {
			if (window.document.documentMode) {
				// Internet Explorer Check: documentMode only exists in IE
				document.documentElement.scrollTop = 0;
			} else {
				window.scrollTo({ top: 0, behavior: "smooth" });
			}
			const firstSection = Object.values(this.sectionRefs).find(ref => ref.current).current;
			this.setState({ activeSection: firstSection.id });
			return;
		}
		if (id === activeSection) return;

		const top = document.getElementById(id)?.offsetTop;
		if (!Number.isNaN(top)) {
			// Internet Explorer Check: documentMode only exists in IE
			if (window.document.documentMode) {
				document.documentElement.scrollTop = top;
			} else {
				window.scrollTo({ top, behavior: "smooth" });
			}

			this.setState({ activeSection: id });
		}
	};

	getOfficerRanks = () => {
		const { lang } = global;
		OfficerService.getRanks()
			.then(({ data }) => {
				const auxRanks = data.map(rank => ({
					value: parseInt(rank.Value, 10),
					label: rank.Text,
					name: "officerRankId",
				}));
				auxRanks.unshift({ value: -1, label: "All", name: "officerRankId" });
				this.setState({
					ranks: auxRanks,
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading officer ranks"),
				});
			});
	};

	getClients = (includeInactive = false) => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id: organizationId },
			},
		} = this.props;

		ClientService.getAll({ organizationId, includeInactive })
			.then(({ data }) => {
				const clients = data.map(({ Id: value, Name: label }) => ({
					value,
					label,
					name: "clientId",
				}));
				clients.unshift({ value: -1, label: "All", name: "clientId" });
				this.setState({ clients });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading clients"),
					timeOut: 1500,
				});
			});
	};

	cleanInvoicingRuleObject = rule => {
		const aux = { ...rule };
		if (aux.OfficerRankId == null) aux.OfficerRankId = -1;
		if (aux.ClientId == null) aux.ClientId = -1;
		if (aux.JobPaycodeId == null) aux.JobPaycodeId = -1;
		return aux;
	};

	getInvoiceRules = () => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id: organizationId, PayCodesEnabled },
			},
		} = this.props;

		InvoicingRuleService.getInvoiceRules(organizationId)
			.then(({ data }) => {
				let aux = [...data];
				if (!PayCodesEnabled) {
					aux = aux.filter(
						rule =>
							rule.InvoicingRuleCategoryId ===
							INVOICING_RULE_CATEGORIES.MINIMUMPAYRATES,
					);
				}
				for (let i = 0; i < aux.length; i++) {
					aux[i] = this.cleanInvoicingRuleObject(aux[i]);
				}
				this.setState({ invoiceRules: aux });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading invoice rules"),
					timeOut: 1500,
				});
			});
	};

	/* GET Service calls */

	/** Gets the list of contacts used in the contacts dropdown fields */
	getContacts = () => {
		const {
			user: {
				Organization: { Id: organizationId },
			},
		} = this.props;
		const { lang } = global;
		StaffService.getStaff({ organizationId })
			.then(({ data: { ItemList } }) => {
				const contacts = (ItemList ?? []).map(contact => ({
					label: contact.ContactName,
					value: contact.Id,
					userEnabled: contact.UserActivated,
				}));
				this.setState({ contacts });
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error Getting Organization Staff"),
					timeOut: 1500,
				}),
			);
	};

	getCallOffPenalties = () => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id: organizationId, JurisdictionId },
			},
		} = this.props;
		OfficerCallOffPenaltyRulesService.getPenalties(organizationId)
			.then(({ data }) => {
				const {
					EnforceOfficerPenalty,
					DaysToConsider,
					MonthToDate,
					YearToDate,
					SuspensionRules,
					Id,
				} = data;

				let lockoutTimeframe = 1;
				if (MonthToDate) {
					lockoutTimeframe = 2;
				} else if (YearToDate) {
					lockoutTimeframe = 3;
				}
				let auxSuspensionRules = [{ callOffs: "", suspentionDays: "" }];
				if (SuspensionRules.length > 0) {
					auxSuspensionRules = SuspensionRules.map(item => ({
						callOffs: item.NumberOfCallOffs,
						suspentionDays: item.SuspensionDays,
						isValid: true,
						isValidSuspention: true,
					}));
				}
				this.setState({
					callOffPenaltyId: Id,
					usePenalties: EnforceOfficerPenalty,
					penaltyType: 1,
					selectedDayPenaltyTimeframe: null,
					selectedMonthPenaltyTimeframe: null,
					numDaysTimeframe: Number(DaysToConsider ?? 0),
					lockoutTimeframe,
					callOffPenaltyRules: auxSuspensionRules,
				});
			})
			.catch((error) => {
				if(!error.response.data.Code) {
					const newData = {
						JurisdictionId,
						OrganizationID: organizationId,
						EnforceOfficerPenalty: false,
						DaysToConsider: null,
						MonthToDate: false,
						YearToDate: false,
						SuspensionRules: [],
					};
					OfficerCallOffPenaltyRulesService.postPenalties(newData).catch(() =>
						utils.notify({
							type: "error",
							message: lang.t("Error creating the Call Offs Penalty Rules"),
							timeOut: 1500,
						}),
					);
				} else {
					utils.notify({
						type: "error",
						message: lang.t("Error getting the Call Offs Penalty Rules"),
						timeOut: 1500,
					});
				}
			});
	};

	getJobTags = () => {
		const { lang } = global;
		TagService.getTags()
			.then(({ data }) => {
				const jobTags = data.map(item => ({
					Id: item.Id,
					Name: item.Name,
				}));
				this.setState({ jobTags, initialJobTags: jobTags });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading job tags"),
					timeOut: 1500,
				});
			});
	};

	/** Gets the list of available timeszones to be selected */
	getTimeZones = () => {
		const { lang } = global;
		GenericService.getTimeZonesForAgencySettings()
			.then(({ data }) => {
				const timezoneData = data.map(timezone => ({
					label: timezone.Description,
					value: timezone.Id,
				}));
				this.setState({ timezones: timezoneData });
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error Getting Organization Agency Settings Timezones"),
					timeOut: 1500,
				}),
			);
	};

	/** Gets the list of officer rules used for officer rule details */
	getOfficerRules = () => {
		const { lang } = global;
		OrganizationService.getJurisdictionOfficerRules()
			.then(({ data }) => {
				const {
					SkipOfficerReVerification,
					PreventOfficerAssignmentOverride,
					JobRestrictionType,
					JobLocationRestrictedCities,
					JobLocationRestrictedCounties,
					MaxWeeklyHours,
					MaxWeeklyHoursType,
					AllowOfficerOverrideWeekly,
					IncludeBothOnOffDutyHoursWeekly,
					IsOfficerClockInAcknowledgeRequired,
					DailyHourlyLimit,
					CustomHourlyLimit,
					MonthlyHourlyLimit,
					ExtraDutyApprovalRequired,
					UseOnDutyScheduleIntegrations,
					CoordinatorsCanOverrideOnDutyScheduleConflicts,
					OfficersCanOverrideOnDutyScheduleConflicts,
					ClockInAcknowledgeCloudFileId,
					ClockInAcknowledgeCloudFileSourceFileName,
					RequireVehicleNumber,
					RequireVehicleMiles,
					PreventOfficerOffSiteClockIn,
					...rest
				} = data;
				const allowedLocations = [];
				JobLocationRestrictedCities.forEach(loc =>
					allowedLocations.push({ value: loc, label: loc, type: lang.t("City") }),
				);
				JobLocationRestrictedCounties.forEach(loc =>
					allowedLocations.push({ value: loc, label: loc, type: lang.t("County") }),
				);
				this.setState({
					officerApproval: {
						SkipOfficerReVerification,
						PreventOfficerAssignmentOverride,
					},
					RestrictJobsToOfficers: JobRestrictionType !== 0 && JobRestrictionType !== null,
					AcknowledgeDeptRules: IsOfficerClockInAcknowledgeRequired ?? false,
					clockInAcknowledgeCloudFileId: ClockInAcknowledgeCloudFileId,
					clockInAcknowledgeCloudFileSourceFileName:
						ClockInAcknowledgeCloudFileSourceFileName,
					hourlyRestrictions: {
						_limitedHours:
							MaxWeeklyHours !== null ||
							!!DailyHourlyLimit ||
							!!CustomHourlyLimit ||
							!!MonthlyHourlyLimit,
						_dailyRestriction: !!DailyHourlyLimit,
						_weeklyRestriction: MaxWeeklyHours !== null,
						_customRestriction: !!CustomHourlyLimit,
						_monthlyRestriction: !!MonthlyHourlyLimit,
						MaxWeeklyHours: MaxWeeklyHours ?? "1",
						MaxWeeklyHoursType: MaxWeeklyHoursType ?? 1,
						AllowOfficerOverrideWeekly: AllowOfficerOverrideWeekly ?? false,
						IncludeBothOnOffDutyHoursWeekly: IncludeBothOnOffDutyHoursWeekly ?? false,
						_weeklyTypeEndDay: MAX_WEEKLY_HOURS_TYPES.find(
							type => type.value === (MaxWeeklyHoursType ?? 1),
						)?.endDayLabel,
						MaxDailyHours: DailyHourlyLimit?.MaxHours ?? "1",
						AllowOfficerOverrideDaily: DailyHourlyLimit?.AllowOfficerOverride ?? false,
						IncludeBothOnOffDutyHoursDaily:
							DailyHourlyLimit?.IncludeBothOnOffDutyHours ?? false,
						MaxMonthlyHours: MonthlyHourlyLimit?.MaxHours ?? "1",
						AllowOfficerOverrideMonthly:
							MonthlyHourlyLimit?.AllowOfficerOverride ?? false,
						IncludeBothOnOffDutyHoursMonthly:
							MonthlyHourlyLimit?.IncludeBothOnOffDutyHours ?? false,
						MaxCustomHours: CustomHourlyLimit?.MaxHours ?? "1",
						CustomStart: CustomHourlyLimit?.StartDate
							? new Date(CustomHourlyLimit?.StartDate).toISOString().split("T")[0]
							: "",
						CustomRecurringDays: CustomHourlyLimit?.RecurringDays ?? "1",
						AllowOfficerOverrideCustom:
							CustomHourlyLimit?.AllowOfficerOverride ?? false,
						IncludeBothOnOffDutyHoursCustom:
							CustomHourlyLimit?.IncludeBothOnOffDutyHours ?? false,
					},
					jobRestrictions: {
						JobRestrictionType,
						JobLocationRestrictedCities,
						JobLocationRestrictedCounties,
					},
					allowedLocations,
					ExtraDutyApprovalRequired,
					scheduleIntegration: {
						UseOnDutyScheduleIntegrations,
						CoordinatorsCanOverrideOnDutyScheduleConflicts,
						OfficersCanOverrideOnDutyScheduleConflicts,
					},
					RequireVehicleNumber,
					RequireVehicleMiles,
					PreventOfficerOffSiteClockIn,
				});
				this.officerRules = rest;
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error getting Jurisdiction Officer Rules"),
					timeOut: 1500,
				}),
			);
	};

	/** Gets a list of officer groups used in the assignment rules modal */
	getOfficerGroups = () => {
		OrganizationFavoriteGroupsService.getGroups()
			.then(({ data }) => {
				const officerGroups = data.map(({ Id: value, Name: label }) => ({ value, label }));
				officerGroups.unshift(
					{ value: -2, label: '"Entire department"' },
					{ value: -1, label: '"All officer groups"' },
				);
				this.setState({ officerGroups });
			})
			.catch(() => {});
	};

	/** Gets a list of assignment rules used in the assignment rules modal */
	getAssignmentRules = () => {
		const { lang } = global;
		this.getDetailedAssignmentRules();
		AssignmentRulesService.getAll()
			.then(({ data: assignmentRules }) => this.setState({ assignmentRules }))
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error loading Assignment Rules"),
					timeOut: 1500,
				}),
			);
	};

	getStaggeredRules = () => {
		const { lang } = global;
		AssignmentRulesService.getStaggeredRules()
			.then(({ data: staggeredRules }) => this.setState({ staggeredRules }))
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error loading staggered Rules"),
					timeOut: 1500,
				}),
			);
	};

	convertToStardardTime = val => {
		const time = val.split(":");
		const hours = Number(time[0]);
		const minutes = Number(time[1]);
		let timeValue = "";
		if (hours > 0 && hours <= 12) {
			timeValue = `${hours}`;
		} else if (hours > 12) {
			timeValue = `${hours - 12}`;
		} else if (hours === 0) {
			timeValue = "12";
		}
		timeValue += minutes < 10 ? `:0${minutes}` : `:${minutes}`;
		timeValue += hours >= 12 ? " PM" : " AM";
		return timeValue;
	};

	getDetailedAssignmentRules = () => {
		const { lang } = global;
		const { user } = this.props;
		const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
		const assignmentTypes = [
			"Assign Manually",
			"Based on first-come first-serve rule",
			"By hours",
			"By number of jobs",
			"By Seniority (Descending)",
			"By Seniority (Ascending)",
			"Randomly",
			"Seniority Draft",
		];
		AssignmentRulesService.getAllDetails()
			.then(({ data: assignmentRulesDetailed }) => {
				const auxList = assignmentRulesDetailed.map(obj => {
					let auxGroup = "no officer groups";
					if (obj.PostedType === 1) {
						auxGroup = "all officer groups";
					} else if (obj.PostedType === 2) {
						auxGroup = `"${obj.PostedGroupName}"`;
					}
					let auxPostTime = "immediately";
					let convertedTime = "";
					if (obj.PostTimeInMinutes || obj.PostTimeInMinutes === 0) {
						let hours = Math.floor(obj.PostTimeInMinutes / 60);
						let minutes = obj.PostTimeInMinutes % 60;
						hours = hours < 10 ? `0${hours}` : hours;
						minutes = minutes < 10 ? `0${minutes}` : minutes;
						convertedTime =
							user.UserPreferences === "useMilitaryTime"
								? `${hours}:${minutes}`
								: this.convertToStardardTime(`${hours}:${minutes}`);
					}
					let auxSignUp = 0;
					if (obj.JobAutoAssignHoursSpan) {
						auxSignUp = obj.JobAutoAssignHoursSpan;
					}
					if (obj.PostExactDateTime) {
						auxPostTime = `post on ${utils.formatDate(new Date(obj.PostExactDateTime), "en-US", user.TimeZoneId, user.UserPreferences === "useMilitaryTime" ? "dt-short-mil" : "dt-short")}`;
					} else if (obj.PostByMonthDay) {
						auxPostTime = `post on ${obj.PostByMonthDay} day of the month at ${convertedTime} all of next month jobs.`;
					} else if (obj.PostByWeekDay || obj.PostByWeekDay === 0) {
						auxPostTime = `post on ${days[obj.PostByWeekDay]} at ${convertedTime}, ${obj.PostPriorByDays} days prior to the job start.`;
					} else if (obj.PostTimeInMinutes || obj.PostTimeInMinutes === 0) {
						auxPostTime = `post at ${convertedTime}, ${obj.PostPriorByDays} days prior to the job start.`;
					}

					const auxRule = assignmentTypes[obj.JobAutoAssignType - 1];
					return {
						...obj,
						value: obj.Id,
						label: obj.Name,
						group: auxGroup,
						rule: auxRule,
						postTime: auxPostTime,
						signUpPeriod: auxSignUp * 60,
					};
				});
				this.setState({ assignmentRulesDetailed: auxList });
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error loading Assignment Rules"),
					timeOut: 1500,
				}),
			);
	};

	/** Gets the list of agency rules and location types */
	getAgencyRulesAndLocationTypes = () => {
		const { lang } = global;
		const promises = [
			OrganizationService.getJurisdictionAgencyRules(),
			GenericService.getLocationTypes(),
		];
		Promise.all(promises)
			.then(([{ data: agencyRules }, { data: locationTypes }]) => {
				// Set this.locationTypes before RestrictedJobLocationTypes to prevent errors with displaying the SelectBadges component
				const mappedLocationTypes = locationTypes.map(({ Id: value, Name: label }) => ({
					value,
					label,
				}));
				this.locationTypes = mappedLocationTypes;

				const {
					IsJobLocationApprovalRequired,
					OfficerInsuranceOptIn,
					OfficerCoordinatedJobsVisible,
					IsJobLocationTypeRestricted,
					RestrictedJobLocationTypes,
					LockOfficerInfo,
					KeepJobsPosted,
					OnlyAuthorizedClientsAreAllowedToUseVehicles,
					RequireInvoicingForVehicles,
					AgencyUsersCanOnlyCreateJobsWithApprovedLocations,
					...rest
				} = agencyRules;
				// Restructure RestrictedJobLocationTypes array into array of objects for consuption into SelectBadges component
				const formattedLocationTypes = RestrictedJobLocationTypes.map(value => {
					const locationObject = this.locationTypes.find(item => item.value === value);
					return {
						value: locationObject.value,
						label: locationObject.label,
					};
				});
				this.setState({
					IsJobLocationApprovalRequired,
					OfficerInsuranceOptIn,
					OfficerCoordinatedJobsVisible,
					IsJobLocationTypeRestricted,
					RestrictedJobLocationTypes: formattedLocationTypes,
					LockOfficerInfo,
					KeepJobsPosted,
					OnlyAuthorizedClientsAreAllowedToUseVehicles,
					RequireInvoicingForVehicles,
					AgencyUsersCanOnlyCreateJobsWithApprovedLocations,
				});
				this.agencyRules = rest;
			})
			.catch(([agencyRulesError, locationTypesError]) => {
				if (agencyRulesError) {
					utils.notify({
						type: "error",
						message: lang.t("Error getting Jurisdiction Agency Rules"),
						timeOut: 1500,
					});
				}
				if (locationTypesError) {
					utils.notify({
						type: "error",
						message: lang.t("Error loading location types"),
						timeOut: 1500,
					});
				}
			});
	};

	/** Gets a list of agency restrictions defined by the agency */
	getAgencyRestrictions = () => {
		const { lang } = global;
		const { user } = this.props;
		if (!user.isSuperAdmin()) {
			OrganizationOfficerConstraintsService.getAgencyRestrictions()
				.then(({ data }) => {
					// Replace anywhere that ExpiresBefore is null with 0 (Never Expires)
					const RequiredJurisdictions = data.RequiredJurisdictions.map(required => ({
						...required,
						ExpiresBefore: required.ExpiresBefore ?? 0,
						Visibility: "show",
					}));
					const ExcludedJurisdictions = data.ExcludedJurisdictions.map(excluded => ({
						...excluded,
						ExpiresBefore: excluded.ExpiresBefore ?? 0,
						Visibility: "hide",
					}));
					const AllJurisdictions = [...RequiredJurisdictions, ...ExcludedJurisdictions];
					this.setState({
						officerFulfillment: {
							RequiredJurisdictions,
							ExcludedJurisdictions,
							AllJurisdictions,
						},
					});
				})
				.catch(() =>
					utils.notify({
						type: "error",
						message: lang.t("Error getting Agency Restrictions"),
						timeOut: 1500,
					}),
				);
		}
	};

	/** Gets a list of payment rules used for the users payment settings */
	getPaymentRules = () => {
		const { lang } = global;
		const {
			user: {
				Organization: { IsPayCodeMandatory },
			},
		} = this.props;
		OrganizationService.getJurisdictionPaymentRules()
			.then(({ data }) => {
				const {
					TransferPaymentToJurisdiction,
					TransferCoordinatorPaymentToJurisdiction,
					...rest
				} = data;
				this.setState(prevState => ({
					paymentInvoiceSettings: {
						...prevState.paymentInvoiceSettings,
						TransferPaymentToJurisdiction,
						IsPayCodeMandatory,
						TransferCoordinatorPaymentToJurisdiction,
					},
				}));
				this.paymentRules = rest;
			})
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error getting Jurisdiction Payment Rules"),
					timeOut: 1500,
				}),
			);
	};

	/** Gets a list of the jurisdiction fees defined by the agency */
	getJurisdictionFees = () => {
		const { lang } = global;
		JurisdictionFeeService.getAll({ abortSignal: this.abortController.signal })
			.then(({ data: fees }) => this.setState({ fees }))
			.catch(error => {
				if (isCancelError(error)) return;

				utils.notify({
					type: "error",
					message: lang.t("Error getting Jurisdiction Fees"),
					timeOut: 1500,
				});
			});
	};

	/** Gets a list of the allowed vehilce types defined by the agency */
	getVehicleTypes = () => {
		const { lang } = global;
		GenericService.getVehicleTypes()
			.then(({ data: vehicleTypes }) => this.setState({ vehicleTypes }))
			.catch(() =>
				utils.notify({
					type: "error",
					message: lang.t("Error loading Vehicle Types"),
					timeOut: 1500,
				}),
			);
	};

	/** Gets a list of the agencies payment history which is displayed in the Billing History Modal */
	getBillingHistory = () => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id: organizationId },
			},
		} = this.props;
		OrganizationService.getInvoiceHistory(organizationId)
			.then(({ data }) => {
				this.setState({ billingHistory: data });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error getting Billing Details"),
					timeOut: 1500,
				});
			});
	};

	getOrganizationDepositAccounts = () => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id: organizationId },
			},
		} = this.props;

		this.setState({ isLoadingOrganizationDepositAccounts: true });

		PaymentService.getOrganizationDepositAccounts(organizationId)
			.then(({ data }) => {
				this.setState({ organizationDepositAccounts: data }, () =>
					this.setOrganizationFeesDepositAccounts(),
				);
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error loading Organization Deposit Accounts"),
					timeOut: 1500,
				});
			})
			.finally(() => this.setState({ isLoadingOrganizationDepositAccounts: false }));
	};

	getAuthenticationSettings = () => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id: organizationId },
			},
		} = this.props;
		OrganizationService.getAuthenticationSettings(organizationId)
			.then(({ data }) => {
				this.setState({ authenticationSettings: data });
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error getting Authentication Settings"),
					timeOut: 1500,
				});
			});
	};
	/* End GET service calls */

	/* Change handlers and toggle methods */

	/**
	 * Parses the image blob and confirms the file type is an image before uploading
	 * @param {Event} event HTML event to inspect for handling uploading of image files
	 */
	uploadImage = event => {
		const { target: input } = event;

		if (!input.files || !input.files[0]) {
			return;
		}
		const [{ type }] = input.files;
		this.setState({ validImageSelected: type.includes("image") }, () => {
			if (type.includes("image")) {
				const reader = new FileReader();
				reader.readAsDataURL(input.files[0]);
				reader.onload = e => {
					this.openEditImageModal(e.target.result);
					input.value = "";
				};
			}
		});
	};

	openEditImageModal = imageToEdit => this.setState({ showEditImageModal: true, imageToEdit });

	closeEditImageModal = () => this.setState({ showEditImageModal: false, imageToEdit: "" });

	/**
	 * Handles the uploading of an image by sending the image blob when calling the API
	 * @param {String} imageToUpload
	 */
	handleImageUpload = imageToUpload => {
		const { lang } = global;
		this.setState({ uploadingImage: true });
		OrganizationService.uploadImage(imageToUpload)
			.then(() => AccountService.me())
			.then(
				({
					data: {
						Organization: { OrganizationLogoId, OrganizationLogo: profilePicUrl },
					},
				}) => {
					this.setState({ OrganizationLogoId, profilePicUrl, uploadingImage: false });
					utils.notify({
						type: "success",
						message: lang.t("Agency Photo updated successfully"),
					});
				},
			)
			.catch(() => {
				this.setState({ uploadingImage: false });
				utils.notify({
					type: "error",
					message: lang.t("Error Uploading Agency Photo"),
					title: "Error",
					timeOut: 1500,
				});
			});
	};

	/**
	 * Handles all changes made secific to the agency information section
	 * @param {String} property The property which is being changed
	 */
	handleAgencyInfoChange = property => event => {
		let value;
		switch (property) {
			case "BillingContactId":
				value = event?.value || "";
				break;
			case "TimeZone":
				value = event?.value || "";
				break;
			default:
				({
					target: { value },
				} = event);
				break;
		}

		this.setState(prevState => ({
			agencyInfo: {
				...prevState.agencyInfo,
				[property]: value,
			},
		}));
	};

	/**
	 * Handles all changes made secific to the TieBreaker Assignment Rule
	 * @param {String} property The property which is being changed
	 */
	handleTieBreakerRuleChange = () => event => {
		this.setState({ TieBreaker: event?.value });
	};

	/**
	 * Handles all changes made secific to officer approvals section
	 * @param {String} property The property which is being changed
	 */
	handleOfficerApprovalChange = property => () => {
		this.setState(prevState => ({
			officerApproval: {
				...prevState.officerApproval,
				[property]: !prevState.officerApproval[property],
			},
		}));
	};

	handleLockOfficerChange = () => () => {
		this.setState(prevState => ({
			LockOfficerInfo: !prevState.LockOfficerInfo,
		}));
	};

	handleKeepJobsPostedChange = () => () => {
		this.setState(prevState => ({
			KeepJobsPosted: !prevState.KeepJobsPosted,
		}));
	};

	toggleAgencyRulesModal = () => {
		const { showAgencyRulesModal } = this.state;
		// In order to preserve the prev values when the modal is closed
		if (!showAgencyRulesModal) {
			this.setState(prevState => ({
				showAgencyRulesModal: !prevState.showAgencyRulesModal,
				_agencyModalRules: prevState.agencyAssignmentRules,
			}));
		} else {
			this.setState(prevState => ({
				showAgencyRulesModal: !prevState.showAgencyRulesModal,
				agencyAssignmentRules: prevState._agencyModalRules,
				_agencyModalRules: {},
			}));
		}
	};

	/**
	 * Handles changes made specific to the agency rules
	 * @param {String} property The agency rule being changed
	 * @param {String} value The value of the agency rule being changed
	 * @param {Function} callback A callback method used for any subsequent functionality
	 */
	handleAgencyRuleChange = (property, value, callback) => {
		this.setState(
			prevState => ({
				agencyAssignmentRules: {
					...prevState.agencyAssignmentRules,
					[property]: value,
				},
			}),
			() => {
				if (callback) callback();
			},
		);
	};

	openAssignmentRulesModal = (id = null) => {
		this.setState({ showAssignmentRulesModal: true, assignmentRuleId: id });
	};

	openStaggeredRulesModal = (id = null) => {
		this.setState({ showStaggeredRulesModal: true, staggeredRuleId: id });
	};

	openManageVehiclesModal = () => {
		this.setState({ showManageVehiclesModal: true });
	};

	openManageAssignmentsModal = () => {
		this.setState({ showManageAssignmentsModal: true });
	};

	closeStaggeredRulesModal = () =>
		this.setState({ showStaggeredRulesModal: false, staggeredRuleId: null });

	closeManageVehiclesModal = () => this.setState({ showManageVehiclesModal: false });

	closeManageAssignmentsModal = () => this.setState({ showManageAssignmentsModal: false });

	openInvoiceRulesModal = () => {
		this.setState({ showInvoicingRulesModal: true });
	};

	closeAssignmentRulesModal = () =>
		this.setState({ showAssignmentRulesModal: false, assignmentRuleId: null });

	closeInvoicingRulesModal = () => {
		this.setState({ showInvoicingRulesModal: false });
	};

	handleRuleDelete = id => {
		const { lang } = global;
		const deleteAssignmentRule = () => {
			AssignmentRulesService.delete(id)
				.then(() => {
					const {
						assignmentRules: [...oldRules],
					} = this.state;
					utils.notify({
						type: "success",
						message: lang.t("Assignment Rule deleted successfully"),
						title: lang.t("Success"),
					});
					this.setState({ assignmentRules: oldRules.filter(rule => rule.Id !== id) });
				})
				.catch(error => {
					const {
						response: { data, status },
					} = error;
					if (status === 409) {
						this.confirmationModal2.current.openModal({
							title: "Assignment Rules with jobs",
							message: data.Message,
							cancelButton: "Accept",
							hideConfirm: true,
						});
					} else {
						utils.notify({
							type: "error",
							message: lang.t("Error deleting Assignment Rule"),
							title: "Error",
						});
					}
				});
		};

		if (this.confirmationModal.current) {
			this.confirmationModal.current.openModal({
				title: lang.t("Delete Assignment Rule"),
				message: lang.t("Are you sure you want to delete these assigment rules_"),
				confirmButton: lang.t("Delete Rule"),
				hideConfirm: false,
				cancelButton: "Cancel",
				onConfirm: deleteAssignmentRule,
			});
		}
	};

	handleStaggeredRuleDelete = id => {
		const { lang } = global;
		const deleteAssignmentRule = () => {
			AssignmentRulesService.deleteStaggeredRule(id)
				.then(() => {
					const {
						staggeredRules: [...oldRules],
					} = this.state;
					utils.notify({
						type: "success",
						message: lang.t("Staggered Rule deleted successfully"),
						title: lang.t("Success"),
					});
					this.setState({ staggeredRules: oldRules.filter(rule => rule.Id !== id) });
				})
				.catch(error => {
					const {
						response: { data, status },
					} = error;
					if (status === 409) {
						this.confirmationModal2.current.openModal({
							title: "Staggered Rules with jobs",
							message: data.Message,
							cancelButton: "Accept",
							hideConfirm: true,
						});
					} else {
						utils.notify({
							type: "error",
							message: data.Message,
							timeOut: 1500,
						});
					}
				});
		};

		if (this.confirmationModal.current) {
			this.confirmationModal.current.openModal({
				title: lang.t("Delete Rule"),
				message: lang.t("Are you sure you want to delete this rule"),
				confirmButton: lang.t("Delete Rule"),
				hideConfirm: false,
				cancelButton: "Cancel",
				onConfirm: deleteAssignmentRule,
			});
		}
	};

	handleCallOffTypeChange = value => () => {
		this.setState(prevState => ({
			JobCallOffType: value,
			JobCallOffReplacementTypes: value === 2 ? prevState.JobCallOffReplacementTypes : [],
		}));
	};

	handleHasGracePeriodChange = value => this.setState({ HasGracePeriod: value });

	handleEnablePaycodesChange = value => {
		this.setState(prevState => ({
			paymentInvoiceSettings: {
				...prevState.paymentInvoiceSettings,
				IsPayCodeMandatory: value,
			},
		}));
	};

	handleCallOffExpirationChange = value => this.setState({ JobCallOffExpirationMinutes: value });

	handleGracePeriodChange = value => this.setState({ JobCallOffGracePeriodMinutes: value });

	handleLocationApprovalChange = () => {
		this.setState(prevState => ({
			IsJobLocationApprovalRequired: !prevState.IsJobLocationApprovalRequired,
			AgencyUsersCanOnlyCreateJobsWithApprovedLocations: false,
		}));
	};

	handleOnlyAuthorizedClientsAreAllowedToUseVehicles = () => () => {
		this.setState(prevState => ({
			OnlyAuthorizedClientsAreAllowedToUseVehicles:
				!prevState.OnlyAuthorizedClientsAreAllowedToUseVehicles,
		}));
	};

	handleRequireInvoicingForVehicles = () => () => {
		this.setState(prevState => ({
			RequireInvoicingForVehicles: !prevState.RequireInvoicingForVehicles,
		}));
	};

	handleVehicleNumberReqChange = () => () => {
		this.setState(prevState => ({
			RequireVehicleNumber: !prevState.RequireVehicleNumber,
		}));
	};

	handleVehicleMilesReqChange = () => () => {
		this.setState(prevState => ({
			RequireVehicleMiles: !prevState.RequireVehicleMiles,
		}));
	};

	handleAgencyUsersCanOnlyCreateJobsWithApprovedLocations = () => () => {
		this.setState(prevState => ({
			AgencyUsersCanOnlyCreateJobsWithApprovedLocations:
				!prevState.AgencyUsersCanOnlyCreateJobsWithApprovedLocations,
		}));
	};

	toggleInsuranceOptIn = () =>
		this.setState(prevState => ({ OfficerInsuranceOptIn: !prevState.OfficerInsuranceOptIn }));

	toggleHourlyRestrictions = () => {
		this.setState(prevState => ({
			hourlyRestrictions: {
				...prevState.hourlyRestrictions,
				_limitedHours: !prevState.hourlyRestrictions._limitedHours,
			},
		}));
	};

	toggleOnDutyScheduleIntegration = () => {
		this.setState(prevState => ({
			scheduleIntegration: {
				...prevState.scheduleIntegration,
				UseOnDutyScheduleIntegrations:
					!prevState.scheduleIntegration.UseOnDutyScheduleIntegrations,
			},
		}));
	};

	toggleHourlyOverrideRestrictions = property => {
		this.setState(prevState => ({
			hourlyRestrictions: {
				...prevState.hourlyRestrictions,
				[property]: !prevState.hourlyRestrictions[property],
			},
		}));
	};

	/**
	 * Handles all changes made specific to the hourly restrictions section
	 * @param {String} property The property which is being changed
	 * @param {String} selectedValue The value which is being captured when selecting option
	 */
	handleHourlyRestrictionsChange = (property, selectedValue) => event => {
		let value;
		if (selectedValue) value = selectedValue;
		else
			({
				target: { value },
			} = event);

		let shouldValueChange = true;

		if (!["CustomStart", "MaxWeeklyHoursType"].includes(property)) {
			shouldValueChange = value.match(/^\d*\.?\d{0,2}$/g);
		}

		if (!shouldValueChange) {
			return;
		}

		this.setState(prevState => ({
			hourlyRestrictions: {
				...prevState.hourlyRestrictions,
				[property]: value,
				_weeklyTypeEndDay:
					property === "MaxWeeklyHoursType"
						? MAX_WEEKLY_HOURS_TYPES.find(type => type.value === Number(value))
								?.endDayLabel
						: prevState.hourlyRestrictions._weeklyTypeEndDay,
			},
		}));
	};

	/**
	 * Handles updates for validations
	 */
	handleValidationChange = (property, value) => {
		this.setState(prevState => ({
			hourlyRestrictions: {
				...prevState.hourlyRestrictions,
				[property]: value,
			},
		}));
	};

	/**
	 * Handles hourly restrictions selected
	 * @param {Boolean} restrictionStatus The restriction status that will be assigned
	 * @param {String} selectedRestriction The restriction selected to add
	 */
	handleRestrictionChange = (restrictionStatus, selectedRestriction) => event => {
		let value;
		if (selectedRestriction) value = selectedRestriction;
		else
			({
				target: { value },
			} = event);

		if (value === "_empty") {
			return;
		}

		this.setState(prevState => ({
			hourlyRestrictions: {
				...prevState.hourlyRestrictions,
				[value]: restrictionStatus,
			},
		}));
	};

	/**
	 * Handles all changes made secific to the agency restrictions section
	 * @param {String} value The value which is being captured when toggling inputs
	 */
	handleJobRestrictionTypeChange = value => () => {
		this.setState(prevState => ({
			jobRestrictions: {
				...prevState.jobRestrictions,
				JobRestrictionType: value,
			},
		}));
	};

	handleLocationAdd = () => {
		const { allowedLocations: oldLocations } = this.state;
		const allowedLocations = [
			{ type: undefined, value: undefined, label: "" },
			...oldLocations,
		];
		this.setState({ allowedLocations });
	};

	/**
	 * Handles the searching of existing locations retrevied from the service call
	 * @param {String} name The name of the location being queried
	 * @param {Function} callback A callback method used for any subsequent functionality
	 */
	searchLocations = (name, callback) => {
		if (name.length < 3) {
			callback([]);
			return;
		}
		const {
			jobRestrictions: { JobLocationRestrictedCities, JobLocationRestrictedCounties },
		} = this.state;
		const {
			user: { StateAbbreviation: state },
		} = this.props;
		const { lang } = global;
		RegionSearchService.searchPlaces({ state, name }, c => {
			this.locationCancelToken = c;
		})
			.then(({ data }) => {
				this.locationCancelToken = undefined;
				const mappedData = data.map(({ name: value, type }) => ({
					label: value,
					value,
					type,
				}));
				const existingLocations = [
					...JobLocationRestrictedCities,
					...JobLocationRestrictedCounties,
				];
				// Only returning values that are not already selected to avoid duplication by the user
				callback(mappedData.filter(({ label }) => !existingLocations.includes(label)));
			})
			.catch(err => {
				if (!axios.isCancel(err)) {
					utils.notify({
						type: "error",
						message: lang.t("Error getting locations"),
					});
					callback([]);
				}
			});
	};

	/**
	 * Handles the adding and deleting of locatoins from the list
	 * @param {Number} index The index of the location being updated
	 * @param {Boolean} remove Determines if the location needs to be deleted
	 * @returns {Object} The new group of updated locations
	 */
	handleLocationUpdate =
		(index, remove = false) =>
		event => {
			const { lang } = global;
			const { allowedLocations } = this.state;
			let isCity;
			// If deleting a location that has not yet been added, simply remove it from allowedLocations
			if (remove && !allowedLocations[index].value) {
				this.setState(prevState => ({
					allowedLocations: prevState.allowedLocations.filter(
						(loc, idx) => idx !== index,
					),
				}));
				// If deleting an existing location, remove from allowedLocations and from the appropriate city/county array
			} else if (remove) {
				isCity = allowedLocations[index].type.toLowerCase() === "city";
				this.setState(prevState => {
					const prevCities = prevState.jobRestrictions.JobLocationRestrictedCities;
					const prevCounties = prevState.jobRestrictions.JobLocationRestrictedCounties;
					const JobLocationRestrictedCities = isCity
						? prevCities.filter(
								location =>
									location &&
									typeof location === "string" &&
									location !== allowedLocations[index].label,
							)
						: prevCities;
					const JobLocationRestrictedCounties = isCity
						? prevCounties
						: prevCounties.filter(
								location =>
									location &&
									typeof location === "string" &&
									location !== allowedLocations[index].label,
							);
					return {
						allowedLocations: prevState.allowedLocations.filter(
							(loc, idx) => idx !== index,
						),
						jobRestrictions: {
							...prevState.jobRestrictions,
							JobLocationRestrictedCities,
							JobLocationRestrictedCounties,
						},
					};
				});
				// Otherwise, just add the new city to allowedLocations and the appropriate city/county array
			} else {
				const { label, value, type } = event;
				isCity = type.toLowerCase() === "city";
				allowedLocations[index] = {
					label,
					value,
					type: lang.t(isCity ? "City" : "County"),
				};
				this.setState(prevState => {
					const prevCities = prevState.jobRestrictions.JobLocationRestrictedCities;
					const prevCounties = prevState.jobRestrictions.JobLocationRestrictedCounties;
					const JobLocationRestrictedCities = isCity
						? [...prevCities, allowedLocations[index].label].filter(
								location => location && typeof location === "string",
							)
						: prevCities;
					const JobLocationRestrictedCounties = isCity
						? prevCounties
						: [...prevCounties, allowedLocations[index].label].filter(
								location => location && typeof location === "string",
							);
					return {
						allowedLocations,
						jobRestrictions: {
							...prevState.jobRestrictions,
							JobLocationRestrictedCities,
							JobLocationRestrictedCounties,
						},
					};
				});
			}
		};

	toggleAcknowledgeRules = () => {
		this.setState(prevState => ({ AcknowledgeDeptRules: !prevState.AcknowledgeDeptRules }));
	};

	togglePreventOfficerOffSiteClockIn = () => {
		this.setState(prevState => ({ PreventOfficerOffSiteClockIn: !prevState.PreventOfficerOffSiteClockIn }));
	};

	toggleRestrictJobs = () => {
		this.setState(prevState => ({
			RestrictJobsToOfficers: !prevState.RestrictJobsToOfficers,
			jobRestrictions: {
				...prevState.jobRestrictions,
				JobRestrictionType: !prevState.RestrictJobsToOfficers
					? LEA_JOB_RESTRICTION_TYPE_IDS.AGENCY_JOBS_ONLY
					: LEA_JOB_RESTRICTION_TYPE_IDS.NO_RESTRICTION,
			},
		}));
	};

	toggleCoordinatorJobs = () => {
		this.setState(prevState => ({
			OfficerCoordinatedJobsVisible: !prevState.OfficerCoordinatedJobsVisible,
		}));
	};

	toggleSupervisorApproval = () => {
		this.setState(prevState => ({
			ExtraDutyApprovalRequired: !prevState.ExtraDutyApprovalRequired,
		}));
	};

	handleAddAgency = () => {
		const newAgency = {
			JurisdictionId: "",
			JurisdictionName: "",
			ExpiresBefore: "",
			Visibility: "show",
		};

		this.setState(prevState => {
			const prevAll = prevState.officerFulfillment.AllJurisdictions;
			return {
				officerFulfillment: {
					...prevState.officerFulfillment,
					AllJurisdictions: [...prevAll, newAgency],
				},
			};
		});
	};

	handleUpdateAgency = (type, index) => event => {
		const {
			officerFulfillment: { AllJurisdictions },
		} = this.state;
		let updates;

		switch (type) {
			case "all-agencies": {
				const { value: JurisdictionId, label: JurisdictionName } = event;
				updates = { JurisdictionId, JurisdictionName };
				break;
			}
			case "agency-visibility": {
				const {
					target: { value: Visibility },
				} = event;
				updates = { Visibility };
				break;
			}
			case "rule-expiry": {
				const {
					target: { value: ExpiresBefore },
				} = event;
				updates = { ExpiresBefore: Number(ExpiresBefore) };
				break;
			}
			default:
				break;
		}

		AllJurisdictions[index] = { ...AllJurisdictions[index], ...updates };

		this.setState(prevState => ({
			officerFulfillment: { ...prevState.officerFulfillment, AllJurisdictions },
		}));
	};

	handleDeleteAgency = index => {
		this.setState(prevState => {
			const prevAll = prevState.officerFulfillment.AllJurisdictions;
			return {
				officerFulfillment: {
					...prevState.officerFulfillment,
					AllJurisdictions: prevAll.filter((agency, idx) => idx !== index),
				},
			};
		});
	};

	/**
	 * Handles all changes made secific to the payments and invoice settings section
	 * @param {String} property The property which is being changed
	 * @param {String} value The value which is being captured whne toggling inputs
	 */
	handleOrganizationPaymentInvoiceChange = property => () => {
		this.setState(prevState => ({
			organizationPaymentInvoiceSettings: {
				...prevState.organizationPaymentInvoiceSettings,
				[property]: !prevState.organizationPaymentInvoiceSettings[property],
			},
		}));
	};

	/**
	 * Handles all changes made secific to the payments and invoice settings section
	 * @param {String} property The property which is being changed
	 * @param {String} value The value which is being captured whne toggling inputs
	 */
	handlePaymentInvoiceChange =
		property =>
		({ target: { value } }) => {
			this.setState(prevState => ({
				paymentInvoiceSettings: {
					...prevState.paymentInvoiceSettings,
					[property]:
						property === "InvoiceDisclaimer"
							? value
							: !prevState.paymentInvoiceSettings[property],
				},
			}));
		};

	/**
	 * Handles all changes made secific to the user schedule integration section
	 * @param {String} property The property which is being changed
	 * @param {String} value The value which is being captured whne toggling inputs
	 */
	handleUserScheduleChange = property => () => {
		this.setState(prevState => ({
			scheduleIntegration: {
				...prevState.scheduleIntegration,
				[property]: !prevState.scheduleIntegration[property],
			},
		}));
	};

	handleGeneralFeeAdd = () => {
		const newFee = { Description: "", Rate: "", JurisdictionFeeType: 1 };
		this.setState(prevState => ({
			fees: {
				...prevState.fees,
				JurisdictionFees: [...prevState.fees.JurisdictionFees, newFee],
			},
		}));
	};

	/**
	 * Handles all changes made secific to general fees
	 * @param {Number} index The index of the general fee being changed
	 * @param {String} property The property which is being changed\
	 */
	handleGeneralFeeChange = (index, property) => event => {
		const {
			target: { value },
		} = event;
		const {
			fees: {
				JurisdictionFees: [...JurisdictionFees],
			},
		} = this.state;
		// Limit rate input values to 2 decimal places
		const shouldValueChange =
			property !== "Rate" || (property === "Rate" && value.match(/^\d*\.?\d{0,2}$/g));
		JurisdictionFees[index] = {
			...JurisdictionFees[index],
			[property]: shouldValueChange ? value : JurisdictionFees[index][property],
		};

		this.setState(prevState => ({ fees: { ...prevState.fees, JurisdictionFees } }));
	};

	handleGeneralFeeDelete = index => {
		this.setState(prevState => ({
			fees: {
				...prevState.fees,
				JurisdictionFees: prevState.fees.JurisdictionFees.filter((f, idx) => idx !== index),
			},
		}));
	};

	handleAssetAdd = () => {
		const asset = { Description: "", Rate: "", JurisdictionFeeType: 1 };
		this.setState(prevState => ({
			fees: {
				...prevState.fees,
				JurisdictionAssets: [...prevState.fees.JurisdictionAssets, asset],
			},
		}));
	};

	handleTagAdd = () => {
		const {
			user: {
				Organization: { Id: organizationId },
			},
		} = this.props;
		const tag = { Name: "", OrganizationId: organizationId };
		this.setState(prevState => ({
			jobTags: [...prevState.jobTags, tag],
		}));
	};

	handleTagChange = (index, property) => event => {
		const {
			target: { value },
		} = event;
		const { jobTags } = this.state;
		const auxJobTags = [...jobTags];
		if (value === "") {
			auxJobTags[index] = {
				...auxJobTags[index],
				[property]: value,
			};
			this.setState({ jobTags: auxJobTags });
			return;
		}
		if (!value.match(/^[0-9a-z ]+$/i) || value.length > 50) {
			return;
		}
		auxJobTags[index] = {
			...auxJobTags[index],
			[property]: value,
		};

		this.setState({ jobTags: auxJobTags });
	};

	handleTagDelete = index => {
		this.setState(prevState => ({
			jobTags: prevState.jobTags.filter((a, idx) => idx !== index),
		}));
	};

	/**
	 * Handles all changes made secific to the assets section
	 * @param {Number} index The index of the asset being changed
	 * @param {String} property The property which is being changed
	 */
	handleAssetChange = (index, property) => event => {
		let value = null;
		if (event.target) {
			value = event.target.value;
		} else {
			value = event;
		}
		if (property === "JurisdictionFeeType") {
			value = value.value;
		}
		const {
			fees: {
				JurisdictionAssets: [...JurisdictionAssets],
			},
		} = this.state;
		// Limit rate input values to 2 decimal places
		const shouldValueChange =
			property !== "Rate" || (property === "Rate" && value.match(/^\d*\.?\d{0,2}$/g));
		JurisdictionAssets[index] = {
			...JurisdictionAssets[index],
			[property]: shouldValueChange ? value : JurisdictionAssets[index][property],
		};

		this.setState(prevState => ({ fees: { ...prevState.fees, JurisdictionAssets } }));
	};

	handleAssetDelete = index => {
		this.setState(prevState => ({
			fees: {
				...prevState.fees,
				JurisdictionAssets: prevState.fees.JurisdictionAssets.filter(
					(a, idx) => idx !== index,
				),
			},
		}));
	};

	handleVehicleFeeAdd = () => {
		const { lang } = global;
		const {
			fees: { JurisdictionVehicleFees },
			vehicleTypes,
		} = this.state;
		if (
			vehicleTypes.every(
				({ Id }) =>
					JurisdictionVehicleFees.filter(
						({ VehicleTypeId }) => VehicleTypeId.toString() === Id.toString(),
					).length === 1,
			)
		) {
			utils.notify({
				type: "error",
				message: lang.t("Each type of vehicle already has a fee defined"),
				timeOut: 1500,
			});
			return;
		}
		const vehicle = { VehicleTypeId: "", Rate: "", JurisdictionFeeType: 1 };
		this.setState(prevState => ({
			fees: {
				...prevState.fees,
				JurisdictionVehicleFees: [...prevState.fees.JurisdictionVehicleFees, vehicle],
			},
		}));
	};

	/**
	 * Handles all changes made secific to the vehicle fees section
	 * @param {Number} index The index of the vehicle fee being changed
	 * @param {String} property The property which is being changed
	 */
	handleVehicleFeeChange = (index, property) => event => {
		let value = null;
		if (event.target) {
			value = event.target.value;
		} else {
			value = event;
		}
		if (property === "VehicleTypeId" || property === "JurisdictionFeeType") {
			value = value.value;
		}
		const {
			fees: {
				JurisdictionVehicleFees: [...JurisdictionVehicleFees],
			},
		} = this.state;
		// Limit rate input values to 2 decimal places
		const shouldValueChange =
			property !== "Rate" || (property === "Rate" && value.match(/^\d*\.?\d{0,2}$/g));
		JurisdictionVehicleFees[index] = {
			...JurisdictionVehicleFees[index],
			[property]: shouldValueChange ? value : JurisdictionVehicleFees[index][property],
		};

		this.setState(prevState => ({ fees: { ...prevState.fees, JurisdictionVehicleFees } }));
	};

	handleVehicleFeeDelete = index => {
		this.setState(prevState => ({
			fees: {
				...prevState.fees,
				JurisdictionVehicleFees: prevState.fees.JurisdictionVehicleFees.filter(
					(v, idx) => idx !== index,
				),
			},
		}));
	};

	handleLocationTypeChange = e => {
		const { value } = e.target;
		if (value === "") {
			return;
		}
		const locationType = this.locationTypes.find(item => item.value.toString() === value);

		this.setState(prevState => ({
			RestrictedJobLocationTypes: [
				...prevState.RestrictedJobLocationTypes,
				{
					value: locationType.value,
					label: locationType.label,
				},
			],
		}));
	};

	handleRemoveLocationType = Id => {
		this.setState(prevState => ({
			RestrictedJobLocationTypes: prevState.RestrictedJobLocationTypes.filter(
				item => item.value !== Id,
			),
		}));
	};

	handleUseZonesChange = () => this.setState(prevState => ({ UseZones: !prevState.UseZones }));

	handleEnablePenalties = e => {
		this.setState({ usePenalties: e.target.checked });
	};

	handlePenaltyTypeChange = value => () => this.setState({ penaltyType: value });

	handleLockoutTimeframeChange = value => () => this.setState({ lockoutTimeframe: value });

	handleOnChangeMonthPenaltyTimeframe = value =>
		this.setState({ selectedMonthPenaltyTimeframe: value });

	handleOnChangeDayPenaltyTimeframe = value =>
		this.setState({ selectedDayPenaltyTimeframe: value });

	handleNumDayTimeframeChange = value => this.setState({ numDaysTimeframe: value });

	handleOnChangePenaltyRules = value => this.setState({ callOffPenaltyRules: value });

	/**
	 * Handles all changes made secific to location types
	 * @param {Event} e HTML event to inspect for handling uploading location type changes
	 * @param {String} value The value captured when changes are made to the input
	 */
	handleJobLocationTypeChange = e => {
		const {
			target: { name },
		} = e;
		this.setState(prevState => ({
			IsJobLocationTypeRestricted: !prevState.IsJobLocationTypeRestricted,
			RestrictedJobLocationTypes:
				name === "IsJobLocationTypeRestricted" && !prevState.IsJobLocationTypeRestricted
					? []
					: prevState.RestrictedJobLocationTypes,
		}));
	};

	/**
	 * Handles all changes made secific to call off replacement types
	 * @param {Event} e HTML event to inspect for handling updates to call off replacement type changes
	 */
	handleReplacementTypeChange = e => {
		const {
			target: { value },
		} = e;
		this.setState(prevState => {
			const prevReplacementTypes = prevState.JobCallOffReplacementTypes;
			if (prevState.JobCallOffReplacementTypes.includes(parseInt(value, 10))) {
				return {
					JobCallOffReplacementTypes: prevReplacementTypes.filter(
						type => type !== parseInt(value, 10),
					),
				};
			}
			return {
				JobCallOffReplacementTypes: [...prevReplacementTypes, parseInt(value, 10)],
			};
		});
	};

	handleSetOrganizationFeeToDepositAccount = (event, feeType) => {
		const { value } = event;
		if (value !== null) {
			if (value === -1) {
				this.setState({
					showDirectDepositModal: true,
					organizationDepositAccount: {},
				});
				return;
			}

			this.setOrganizationFeeToDepositAccount(value === 0 ? null : value, feeType);
		}
	};

	setOrganizationFeeToDepositAccount = (depositAccountId, feeType) => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id: organizationId },
			},
		} = this.props;

		const body = {
			OrganizationDepositAccountId: depositAccountId,
			OrganizationFeeTypeId: feeType,
			UseDefault: depositAccountId == null,
		};

		PaymentService.setOrganizationFeeToDepositAccount(organizationId, body)
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Deposit account set successfully for organization fee"),
				});
				this.getOrganizationDepositAccounts();
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error trying to set deposit account for fee"),
					timeOut: 1500,
				});
			});
	};

	handleFederationEnforcementDateChange = newDate => {
		this.setState(prevState => ({
			authenticationSettings: {
				...prevState.authenticationSettings,
				...{
					FederationEnforcedBy: newDate,
				},
			},
		}));
	};

	openPreview = () => {
		this.setState({ showPreview: true });
		document.body.style.overflow = "hidden";
	};

	closePreview = () => {
		this.setState({ showPreview: false });
		document.body.style.overflow = "";
	};

	/* END Change handlers and toggle methods */

	/**
	 * Validates changes made to the input values and determines if the changes can be saved
	 * @returns {Boolean} Determines if all changed input values are valid
	 */
	validateForm = () => {
		const { lang } = global;
		const {
			agencyInfo: { Name },
			hourlyRestrictions: {
				_limitedHours,
				_dailyRestriction,
				_weeklyRestriction,
				_customRestriction,
				_monthlyRestriction,
				MaxWeeklyHours,
				MaxDailyHours,
				MaxMonthlyHours,
				MaxCustomHours,
				CustomStart,
				CustomRecurringDays,
			},
			IsJobLocationTypeRestricted,
			RestrictJobsToOfficers,
			RestrictedJobLocationTypes,
			jobRestrictions: { JobRestrictionType },
			allowedLocations,
			JobCallOffType,
			HasGracePeriod,
			JobCallOffExpirationMinutes,
			JobCallOffGracePeriodMinutes,
			JobCallOffReplacementTypes,
			nameForDisplay,
		} = this.state;
		const {
			flags: { newClientSignUp },
		} = this.props;
		let isValid = true;
		let errorMessage = "";

		// Name is always required
		if (Name.trim() === "") {
			isValid = false;
			errorMessage += `${lang.t("Agency name cannot be empty_")} `;
		}
		if (
			HasGracePeriod &&
			JobCallOffType === 2 &&
			JobCallOffExpirationMinutes > JobCallOffGracePeriodMinutes
		) {
			isValid = false;
			errorMessage += `${lang.t("The grace period has to be longer than the call off time limit_")} `;
		}

		const nameForDisplayTrimmed = (nameForDisplay || "").trim();
		// eslint-disable-next-line no-useless-escape
		const regex = /^[a-zA-Z0-9\-\'\.\s_,&()*@]+$/;

		if (newClientSignUp && nameForDisplayTrimmed !== "") {
			if (!regex.test(nameForDisplayTrimmed)) {
				isValid = false;
				// eslint-disable-next-line max-len
				errorMessage += `${lang.t("Name for display can only includes alphanumeric characters, spaces, and the following permitted special characters_")} -, ', ., _, ,, &, (, ), *, @.`;
			}

			if (nameForDisplayTrimmed.length > 60) {
				isValid = false;
				errorMessage += lang.t("Name for display cannot be longer than 60 characters");
			}
		}

		if (this.isPittsburghOrg) {
			// MaxWeeklyHours is required if _limitedHours is true and should be at least 1
			if (_limitedHours && !this.validateHourlyInput(MaxWeeklyHours)) {
				isValid = false;
				errorMessage += `${lang.t("The number of hours officers are limited to work per week cannot be less than 1_")} `;
			} else if (!_limitedHours && !this.validateHourlyInput(MaxWeeklyHours)) {
				// MaxWeeklyHours should be at least 0 if specified when _limitedHours is false
				// This scenario is highly unlikely to ever occur, but we are covering our bases in case it does
				isValid = false;
				errorMessage += `${lang.t("If officer working hours are not restricted, the value must be at least 0_")} `;
			}
		} else if (_limitedHours) {
			if (
				!_dailyRestriction &&
				!_weeklyRestriction &&
				!_monthlyRestriction &&
				!_customRestriction
			) {
				// At least one restriction type should exist
				isValid = false;
				errorMessage += `${lang.t("Hourly limits section needs at least one restriction_")} `;
			}
			if (_dailyRestriction && !this.validateHourlyInput(MaxDailyHours)) {
				isValid = false;
				errorMessage += `${lang.t("The number of hours officers are limited to work per day cannot be less than 1_")} `;
			}
			if (_weeklyRestriction && !this.validateHourlyInput(MaxWeeklyHours)) {
				isValid = false;
				errorMessage += `${lang.t("The number of hours officers are limited to work per week cannot be less than 1_")} `;
			}
			if (_monthlyRestriction && !this.validateHourlyInput(MaxMonthlyHours)) {
				isValid = false;
				errorMessage += `${lang.t("The number of hours officers are limited to work per month cannot be less than 1_")} `;
			}
			if (_customRestriction) {
				if (!this.validateHourlyInput(MaxCustomHours)) {
					isValid = false;
					errorMessage += `${lang.t("The number of hours officers are limited to work per date range cannot be less than 1_")} `;
				}
				if (!this.validateHourlyInput(CustomRecurringDays)) {
					isValid = false;
					errorMessage += `${lang.t("The number of recurring days cannot be less than 1_")} `;
				}
				if (CustomStart === "") {
					isValid = false;
					errorMessage += `${lang.t("The start date should be a valid date_")} `;
				}
			}
		}
		// if RestrictJobsToOfficers is true JobRestrictionType needs to have an option selected
		if (RestrictJobsToOfficers && JobRestrictionType !== 20 && JobRestrictionType !== 30) {
			isValid = false;
			errorMessage += `${lang.t("Select a Job Restriction option in the Agency restrictions section")} `;
		}
		// if IsJobLocationTypeRestricted is true one value is required inside of RestrictedJobLocationTypes
		if (IsJobLocationTypeRestricted && RestrictedJobLocationTypes.length === 0) {
			isValid = false;
			errorMessage += `${lang.t("At least one venue type that officers are not permitted to work must be selected_")} `;
		}
		if (JobRestrictionType === 20 && allowedLocations.length === 0) {
			isValid = false;
			errorMessage += `${lang.t("At least one city or county where jobs are allowed must be specified_")} `;
		}
		// if JobCallOffType is set to 2, JobCallOffReplacementTypes cannot be empty in order to be valid
		if (JobCallOffType === 2 && JobCallOffReplacementTypes.length === 0) {
			isValid = false;
			errorMessage += `${lang.t("At least one option for officer replacements must be specified_")} `;
		}
		if (!isValid) utils.notify({ type: "error", message: errorMessage });
		return isValid;
	};

	/**
	 * Validates input is a valid hourly limiy
	 * @param {String} inputData
	 * @returns {Boolean} Determines if input is valid
	 */
	validateHourlyInput = inputData => !(inputData === "" || parseInt(inputData, 10) < 1);

	/**
	 * Validates changes made to any fees values and determines if the changes can be saved
	 * @param {Array} fees
	 * @param {String} feeType
	 * @returns {Boolean} Determines if all changed fee values are valid
	 */
	validateFees = (fees, feeType) => {
		const { lang } = global;
		let isValid = true;
		let errorMessage = "";
		fees.forEach(fee => {
			const type = parseInt(fee.JurisdictionFeeType, 10);
			const rate = parseFloat(fee.Rate, 10);
			if (fee.JurisdictionFeeType && Number.isNaN(type)) {
				// Should never occur, but it doesn't hurt to be safe
				isValid = false;
			}
			if (isValid && type === 3) {
				// Percentage-based fees must be within the range of 0-100
				if (rate <= 0 || rate > 100) {
					errorMessage += lang.t("Percentage based fees must be between 0 and 100");
					isValid = false;
				}
			} else if (isValid && rate < 0) {
				errorMessage += lang.t("Per job and per hour rates cannot be less than 0");
				isValid = false;
			}
			if (isValid && feeType !== "vehicle" && fee.Description.trim() === "") {
				isValid = false;
				errorMessage += lang.t("Non-vehicle fees must have an associated description");
			}
			if (isValid && feeType !== "asset" && Number.isNaN(rate)) {
				isValid = false;
				errorMessage += lang.t("Invalid value supplied for a fee");
			}
			if (isValid && feeType === "vehicle" && Number.isNaN(parseInt(fee.VehicleTypeId, 10))) {
				isValid = false;
				errorMessage += lang.t("Vehicle type not selected for a vehicle fee");
			}
			if (
				isValid &&
				feeType === "vehicle" &&
				fees.filter(item => fee.VehicleTypeId === item.VehicleTypeId).length > 1
			) {
				isValid = false;
				errorMessage += lang.t("Vehicle fees cannot be duplicated");
			}
		});

		if (!isValid) utils.notify({ type: "error", message: errorMessage });
		return isValid;
	};

	validateAgencyRestrictions = () => {
		const { AcknowledgeDeptRules, clockInAcknowledgeCloudFileId } = this.state;
		if (AcknowledgeDeptRules) {
			if (!clockInAcknowledgeCloudFileId) {
				utils.notify({
					type: "error",
					message:
						"A PDF file with the department rules is required in the Agency Restrictions section",
				});
				return false;
			}
		}
		return true;
	};

	validatePenaltySection = (
		usePenalties,
		selectedDayPenaltyTimeframe,
		selectedMonthPenaltyTimeframe,
		callOffPenaltyRules,
		numDaysTimeframe,
		lockoutTimeframe,
	) => {
		const { lang } = global;
		if (!usePenalties) {
			return true;
		}
		if (lockoutTimeframe === 1 && (numDaysTimeframe === 0 || numDaysTimeframe == null)) {
			utils.notify({
				type: "error",
				message: lang.t(
					"Fields not completed, please make sure all options are filled out correctly before saving",
				),
				timeOut: 2000,
			});
			return false;
		}
		if (
			lockoutTimeframe === 4 &&
			(!selectedDayPenaltyTimeframe || !selectedMonthPenaltyTimeframe)
		) {
			return false;
		}
		if (callOffPenaltyRules.length === 0) {
			utils.notify({
				type: "error",
				message: lang.t("Lockout rules are not defined"),
				timeOut: 2000,
			});
			return false;
		}
		const auxLockoutRules = [...callOffPenaltyRules];
		let emptyRule = null;
		const idx = callOffPenaltyRules.findIndex(
			item =>
				item.suspentionDays === "" ||
				item.suspentionDays == null ||
				item.suspentionDays === 0 ||
				item.callOffs === "" ||
				item.callOffs == null ||
				item.callOffs === 0,
		);
		if (idx !== -1) {
			emptyRule = auxLockoutRules[idx];
			if (
				emptyRule.suspentionDays === "" ||
				emptyRule.suspentionDays == null ||
				emptyRule.suspentionDays === 0
			) {
				emptyRule.isValidSuspention = false;
			}
			if (
				emptyRule.callOffs === "" ||
				emptyRule.callOffs == null ||
				emptyRule.callOffs === 0
			) {
				emptyRule.isValid = false;
			}
		}
		if (emptyRule) {
			this.setState({
				callOffPenaltyRules: auxLockoutRules,
			});
			utils.notify({
				type: "error",
				message: lang.t(
					"Fields not completed, please make sure all options are filled out correctly before saving",
				),
				timeOut: 2000,
			});
			return false;
		}
		if (
			callOffPenaltyRules.find(
				item =>
					!item.isValid ||
					item.suspentionDays === "" ||
					item.suspentionDays == null ||
					!item.isValidSuspention,
			)
		) {
			utils.notify({
				type: "error",
				message: lang.t("Lockout rules must have a unique number of calloffs"),
				timeOut: 2000,
			});
			return false;
		}
		return true;
	};

	validateTags = tags => {
		const { lang } = global;
		let isValid = true;
		let errorMessage = "";
		let duplicate = "";
		const namesArr = tags.map(item => item.Name.toLowerCase().trim());
		const isDuplicate = namesArr.some((item, idx) => {
			if (item !== idx) {
				duplicate = item;
			}
			return namesArr.indexOf(item) !== idx;
		});
		if (isDuplicate) {
			isValid = false;
			errorMessage = `Tag "${duplicate}" has already been created`;
		}
		tags.forEach(tag => {
			if (tag.Name === "") {
				isValid = false;
				errorMessage = lang.t("Tag name cannot be empty");
			}
		});

		if (!isValid) utils.notify({ type: "error", message: errorMessage });
		return isValid;
	};

	/**
	 * Validates changes made to the agency restrictions and expects each value to not be empty/null
	 * @returns {Boolean} Determines if changes to the agency restrctions are valie
	 */
	validateRestrictions = () => {
		const { lang } = global;
		const {
			officerFulfillment: { AllJurisdictions },
		} = this.state;
		let isValid = true;
		let errorMessage = "";

		AllJurisdictions.every((jur, i, arr) => {
			if (
				jur.JurisdictionName === "" &&
				jur.ExpiresBefore === "" &&
				jur.Visibility === "show"
			) {
				if (i > -1) {
					this.setState(prevState => ({
						officerFulfillment: {
							...prevState.officerFulfillment,
							AllJurisdictions: arr.filter((item, idx) => idx !== i),
						},
					}));
				}
				isValid = true;
			} else if (jur.ExpiresBefore === "") {
				isValid = false;
				errorMessage = "Agency restriction time must be selected";
			} else if (jur.JurisdictionName === "" || jur.JurisdictionId === "") {
				isValid = false;
				errorMessage = "Agency name cannot be empty";
			}
			return isValid;
		});

		if (!isValid) {
			utils.notify({
				type: "error",
				message: lang.t(errorMessage),
			});
		}
		return isValid;
	};

	loadUpdatedJurisdictions = (inputValue, callback) => {
		const { lang } = global;

		let cancelJurisdictions;
		if (inputValue.length < 3) {
			callback([]);
			return;
		}
		if (cancelJurisdictions) cancelJurisdictions();

		JurisdictionService.getAll({
			scope: "Name",
			search: inputValue,
			getCancelToken: c => {
				cancelJurisdictions = c;
			},
		})
			.then(response => {
				cancelJurisdictions = undefined;
				callback(
					response.data.map(option => ({
						value: option.Id,
						label: `${option.Name}, ${option.County} County ${option.StateName}`,
					})),
				);
			})
			.catch(error => {
				if (!axios.isCancel(error)) {
					utils.notify({
						type: "error",
						message: lang.t("Error loading jurisdictions"),
					});
					callback([]);
				}
			});
	};

	/**
	 * Updates the state of the progress button which visually indidcate a success or failure
	 * @param {String} buttonState Determines the styles that will apply to the progress button ('success' or 'error')
	 */
	updateButtonState = buttonState => {
		this.setState({ buttonState }, () => {
			setTimeout(() => {
				this.setState({ buttonState: "" });
				clearTimeout();
			}, 1000);
		});
	};

	/**
	 * Gathers all required data needed by the API to successfully update the users agency settings
	 * Validation occurs within this method to determine if changes made to the input values are valid before saving/calling the API
	 */
	updateAgencySettings = () => {
		const {
			user,
			flags: { federation: federationFlag },
		} = this.props;
		const { lang } = global;
		const autoAssignData = {};
		const {
			agencyInfo: { Name, BillingContactId, OrganizationEmail, PaymentDetails, TimeZone },
			agencyAssignmentRules: {
				_hoursMultiplier,
				JobAutoAssignType,
				JobAutoAssignHoursSpan,
				JobAutoAssignJobCountDaysSpan,
				JobAutoAssignYearToDateSpan,
				JobAutoAssignQueueCycleMaxAssignments,
			},
			officerApproval: { SkipOfficerReVerification, PreventOfficerAssignmentOverride },
			hourlyRestrictions: {
				_limitedHours,
				_dailyRestriction,
				_weeklyRestriction,
				_customRestriction,
				_monthlyRestriction,
				MaxWeeklyHours,
				MaxWeeklyHoursType,
				AllowOfficerOverrideWeekly,
				IncludeBothOnOffDutyHoursWeekly,
				MaxDailyHours,
				AllowOfficerOverrideDaily,
				IncludeBothOnOffDutyHoursDaily,
				MaxMonthlyHours,
				AllowOfficerOverrideMonthly,
				IncludeBothOnOffDutyHoursMonthly,
				MaxCustomHours,
				CustomStart,
				CustomRecurringDays,
				AllowOfficerOverrideCustom,
				IncludeBothOnOffDutyHoursCustom,
			},
			jobRestrictions: {
				JobRestrictionType,
				JobLocationRestrictedCities,
				JobLocationRestrictedCounties,
			},
			officerFulfillment: { AllJurisdictions },
			paymentInvoiceSettings: {
				TransferPaymentToJurisdiction,
				IsPayCodeMandatory,
				TransferCoordinatorPaymentToJurisdiction,
				InvoiceDisclaimer,
			},
			fees: { JurisdictionFees, JurisdictionAssets, JurisdictionVehicleFees },
			LockOfficerInfo,
			KeepJobsPosted,
			OrganizationLogoId,
			profilePicUrl,
			jurisdiction,
			ExtraDutyApprovalRequired,
			JobCallOffType,
			JobCallOffReplacementTypes,
			JobCallOffExpirationMinutes,
			HasGracePeriod,
			JobCallOffGracePeriodMinutes,
			IsJobLocationApprovalRequired,
			IsJobLocationTypeRestricted,
			UseZones,
			usePenalties,
			penaltyType,
			selectedDayPenaltyTimeframe,
			numDaysTimeframe,
			selectedMonthPenaltyTimeframe,
			lockoutTimeframe,
			callOffPenaltyId,
			RestrictedJobLocationTypes,
			OfficerInsuranceOptIn,
			OfficerCoordinatedJobsVisible,
			RestrictJobsToOfficers,
			AcknowledgeDeptRules,
			showAgencyRulesModal,
			callOffPenaltyRules,
			jobTags,
			initialJobTags,
			scheduleIntegration: {
				UseOnDutyScheduleIntegrations,
				CoordinatorsCanOverrideOnDutyScheduleConflicts,
				OfficersCanOverrideOnDutyScheduleConflicts,
			},
			organizationPaymentInvoiceSettings: { IsOfficerInvoiceApprovalRequired },
			OnlyAuthorizedClientsAreAllowedToUseVehicles,
			RequireInvoicingForVehicles,
			RequireVehicleMiles,
			RequireVehicleNumber,
			AgencyUsersCanOnlyCreateJobsWithApprovedLocations,
			TieBreaker,
			authenticationSettings,
			nameForDisplay,
			customPolicies,
			PreventOfficerOffSiteClockIn,
		} = this.state;
		const jurisdictionValidation = this.validateRestrictions();
		const RequiredJurisdictions = AllJurisdictions.filter(item => item.Visibility === "show");
		const ExcludedJurisdictions = AllJurisdictions.filter(item => item.Visibility === "hide");

		const isFormValid = this.validateForm();

		const areAgencyRestrictionsValid = this.validateAgencyRestrictions();
		const areGeneralFeesValid = this.validateFees(JurisdictionFees, "general");
		const areVehicleFeesValid = this.validateFees(JurisdictionVehicleFees, "vehicle");
		const areAssetFeesValid = this.validateFees(JurisdictionAssets, "asset");
		const isPenaltySectionValid = this.validatePenaltySection(
			usePenalties,
			selectedDayPenaltyTimeframe,
			selectedMonthPenaltyTimeframe,
			callOffPenaltyRules,
			numDaysTimeframe,
			lockoutTimeframe,
		);
		const areTagsValid = this.validateTags(jobTags);
		if (
			isFormValid &&
			areGeneralFeesValid &&
			areVehicleFeesValid &&
			areAgencyRestrictionsValid &&
			areAssetFeesValid &&
			jurisdictionValidation &&
			areTagsValid &&
			isPenaltySectionValid
		) {
			autoAssignData.JobAutoAssignType = parseInt(JobAutoAssignType, 10);
			autoAssignData.JobAutoAssignYearToDateSpan = JobAutoAssignYearToDateSpan ? true : null;
			if (JobAutoAssignHoursSpan !== "") {
				autoAssignData.JobAutoAssignHoursSpan =
					parseInt(JobAutoAssignHoursSpan, 10) * parseInt(_hoursMultiplier, 10);
			}
			if (JobAutoAssignJobCountDaysSpan !== "") {
				autoAssignData.JobAutoAssignJobCountDaysSpan = parseInt(
					JobAutoAssignJobCountDaysSpan,
					10,
				);
			}
			if (JobAutoAssignQueueCycleMaxAssignments) {
				autoAssignData.JobAutoAssignQueueCycleMaxAssignments = parseInt(
					JobAutoAssignQueueCycleMaxAssignments,
					10,
				);
			}
			const callOffType = parseInt(JobCallOffType, 10);
			const updatePromises = [
				OrganizationService.saveAgency({
					id: user.Organization.Id,
					data: {
						...user.Organization,
						IsOfficerInvoiceApprovalRequired,
						...autoAssignData,
						Name,
						BillingContactId,
						OrganizationEmail,
						PaymentDetails,
						OrganizationLogoId,
						JobCallOffExpirationMinutes: !Number.isNaN(callOffType)
							? JobCallOffExpirationMinutes
							: null,
						JobCallOffGracePeriodMinutes:
							HasGracePeriod && (callOffType === 2 || Number.isNaN(callOffType))
								? JobCallOffGracePeriodMinutes
								: null,
						OrganizationLogo: profilePicUrl,
						JurisdictionName: jurisdiction,
						JobCallOffType: Number.isNaN(callOffType) ? null : callOffType,
						JurisdictionId: user.isLEA() ? user.Organization.JurisdictionId : undefined,
						JobCallOffReplacementTypes,
						InvoiceDisclaimer,
						UseZones,
						usePenalties,
						penaltyType,
						selectedDayPenaltyTimeframe,
						numDaysTimeframe,
						selectedMonthPenaltyTimeframe,
						lockoutTimeframe,
						callOffPenaltyRules,
						IsPayCodeMandatory,
						TimeZone,
						TieBreaker,
						CustomPolicies: customPolicies,
						NameForDisplay: nameForDisplay,
					},
				}),
			];
			for (let i = 0; i < jobTags.length; i++) {
				const auxInitialTag = initialJobTags.find(item => item.Id === jobTags[i].Id);
				if (auxInitialTag) {
					if (auxInitialTag.Name !== jobTags[i].Name) {
						updatePromises.push(TagService.updateTag(jobTags[i]));
					}
				} else {
					updatePromises.push(TagService.addTag(jobTags[i]));
				}
			}
			for (let i = 0; i < initialJobTags.length; i++) {
				if (jobTags.find(item => item.Id === initialJobTags[i].Id) == null) {
					updatePromises.push(TagService.deleteTag(initialJobTags[i]));
				}
			}
			if (!user.isSuperAdmin()) {
				updatePromises.push(
					OrganizationOfficerConstraintsService.saveAgencyRestrictions({
						RequiredJurisdictions,
						ExcludedJurisdictions,
					}),
				);
			}
			if (user.isLEA()) {
				const formattedJobRestrictions = RestrictedJobLocationTypes.map(
					({ value }) => value,
				);
				let NoOfDaysToReview = 0;
				let ReviewFullCalendarMonth = false;
				let ReviewFullCalendarYear = false;
				if (lockoutTimeframe === 1) {
					NoOfDaysToReview = numDaysTimeframe;
				} else if (lockoutTimeframe === 2) {
					ReviewFullCalendarMonth = true;
				} else if (lockoutTimeframe === 3) {
					ReviewFullCalendarYear = true;
				}
				const auxCancellationRules = callOffPenaltyRules.map(item => ({
					NumberOfCallOffs: item.callOffs,
					SuspensionDays: item.suspentionDays,
				}));

				const dailyRestriction =
					!this.isPittsburghOrg && _limitedHours && _dailyRestriction
						? {
								MaxHours: MaxDailyHours,
								AllowOfficerOverride: AllowOfficerOverrideDaily,
								IncludeBothOnOffDutyHours: IncludeBothOnOffDutyHoursDaily,
							}
						: null;
				const monthlyRestriction =
					!this.isPittsburghOrg && _limitedHours && _monthlyRestriction
						? {
								MaxHours: MaxMonthlyHours,
								AllowOfficerOverride: AllowOfficerOverrideMonthly,
								IncludeBothOnOffDutyHours: IncludeBothOnOffDutyHoursMonthly,
							}
						: null;
				const customRestriction =
					!this.isPittsburghOrg && _limitedHours && _customRestriction
						? {
								MaxHours: MaxCustomHours,
								RecurringDays: CustomRecurringDays,
								StartDate: CustomStart,
								AllowOfficerOverride: AllowOfficerOverrideCustom,
								IncludeBothOnOffDutyHours: IncludeBothOnOffDutyHoursCustom,
							}
						: null;
				let weekHoursRestriction = _limitedHours ? MaxWeeklyHours : null;

				if (!this.isPittsburghOrg) {
					weekHoursRestriction =
						_limitedHours && _weeklyRestriction ? MaxWeeklyHours : null;
				}

				updatePromises.push(
					[
						JurisdictionFeeService.save({
							JurisdictionFees,
							JurisdictionVehicleFees,
							JurisdictionAssets,
						}),
					],
					[
						OrganizationService.saveJurisdictionAgencyRules({
							...this.agencyRules,
							IsJobLocationApprovalRequired,
							LockOfficerInfo,
							KeepJobsPosted,
							OfficerInsuranceOptIn,
							OfficerCoordinatedJobsVisible,
							IsJobLocationTypeRestricted,
							RestrictedJobLocationTypes: formattedJobRestrictions,
							OnlyAuthorizedClientsAreAllowedToUseVehicles,
							RequireInvoicingForVehicles,
							AgencyUsersCanOnlyCreateJobsWithApprovedLocations,
						}),
					],
					[
						OrganizationService.saveJurisdictionPaymentRules({
							...this.paymentRules,
							TransferPaymentToJurisdiction,
							// TODO: PAYM-347 Once the setting has been deleted from the JurisdictionRule table, stop sending IsOfficerInvoiceApprovalRequired parameter
							IsOfficerInvoiceApprovalRequired,
							TransferCoordinatorPaymentToJurisdiction,
						}),
					],
					[
						OrganizationService.saveJurisdictionOfficerRules({
							...this.officerRules,
							MaxWeeklyHours: weekHoursRestriction,
							MaxWeeklyHoursType,
							AllowOfficerOverrideWeekly,
							PreventOfficerOffSiteClockIn,
							IncludeBothOnOffDutyHoursWeekly,
							DailyHourlyLimit: dailyRestriction,
							MonthlyHourlyLimit: monthlyRestriction,
							CustomHourlyLimit: customRestriction,
							JobRestrictionType: RestrictJobsToOfficers ? JobRestrictionType : 0,
							IsOfficerClockInAcknowledgeRequired: AcknowledgeDeptRules,
							SkipOfficerReVerification,
							PreventOfficerAssignmentOverride,
							JobLocationRestrictedCities,
							JobLocationRestrictedCounties,
							ExtraDutyApprovalRequired,
							UseOnDutyScheduleIntegrations,
							CoordinatorsCanOverrideOnDutyScheduleConflicts:
								UseOnDutyScheduleIntegrations
									? CoordinatorsCanOverrideOnDutyScheduleConflicts
									: false,
							OfficersCanOverrideOnDutyScheduleConflicts:
								UseOnDutyScheduleIntegrations
									? OfficersCanOverrideOnDutyScheduleConflicts
									: false,
							RequireVehicleNumber,
							RequireVehicleMiles,
						}),
					],
					[
						OfficerCallOffPenaltyRulesService.updatePenalties({
							Id: callOffPenaltyId,
							OrganizationId: user.Organization.Id,
							JurisdictionId: user.Organization.JurisdictionId,
							EnforceOfficerPenalty: usePenalties,
							DaysToConsider:
								usePenalties && Number(lockoutTimeframe) === 1
									? NoOfDaysToReview
									: null,
							MonthToDate: usePenalties ? ReviewFullCalendarMonth : false,
							YearToDate: usePenalties ? ReviewFullCalendarYear : false,
							SuspensionRules: usePenalties ? auxCancellationRules : null,
						}),
					],
				);

				if (federationFlag && user.IsStaffAdmin) {
					updatePromises.push([
						OrganizationService.updateAuthenticationSettings(user.Organization.Id, {
							FederationEnforcedBy: authenticationSettings.FederationEnforcedBy,
						}),
					]);
				}
			}

			Promise.all(updatePromises)
				.then(() => AccountService.me())
				.then(({ data }) => {
					// Update user object in the redux store
					const { receiveUser } = this.props;
					receiveUser(data);
					this.getJobTags();
					if (showAgencyRulesModal) {
						this.setState({ showAgencyRulesModal: false });
						utils.notify({
							type: "success",
							message: lang.t("Assignment rule updated successfully"),
							timeOut: 2000,
						});
					} else {
						this.updateButtonState("success");
						setTimeout(() => {
							clearTimeout();
							this.scrollToSection();
						}, 500);
					}
				})
				.then(() => {
					this.setState({ hasPendingChanges: false });
				})
				.catch(errors => {
					if (showAgencyRulesModal) {
						utils.notify({
							type: "error",
							message: lang.t("Error updating assignment rule"),
							timeOut: 2500,
						});
					} else {
						// const firstError = errors.find((e) => e.Message);
						utils.notify({
							type: "error",
							message: errors.Message || lang.t("Error updating agency settings"),
						});
						this.updateButtonState("error");
					}
				});
		} else {
			this.updateButtonState("error");
		}
	};

	/* Payment Methods */

	/** Gets a list of the agencys' payment methods */
	getPaymentMethods = () => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id },
			},
		} = this.props;

		this.setState(({ paymentMethods }) => ({
			paymentMethods: { ...paymentMethods, loading: true },
		}));

		PaymentService.getOrganizationPaymentMethods(Id)
			.then(({ data }) => {
				this.setState({ paymentMethods: { data: data ?? [], loading: false } });
			})
			.catch(({ response }) => {
				this.setState(({ paymentMethods }) => ({
					paymentMethods: { ...paymentMethods, loading: false },
				}));

				utils.notify({
					type: "error",
					message: response?.data?.Message ?? lang.t("Error loading Payment Methods"),
				});
			});
	};

	getPaycodes = () => {
		const { lang } = global;

		PayCodesService.getPaycodes()
			.then(({ data }) => {
				this.setState({ paycodes: data });
				this.buildJobPaycodes();
			})
			.catch(({ response }) => {
				this.setState({ paycodes: [] });

				utils.notify({
					type: "error",
					message: response?.data?.Message ?? lang.t("Error loading paycodes"),
				});
			});
	};

	buildJobPaycodes = () => {
		const { paycodes } = this.state;

		const auxPaycodes = paycodes.map(({ Id: value, Name: label }) => ({
			value,
			label,
			name: "jobPaycodeId",
		}));
		auxPaycodes.unshift({ value: -1, label: "All", name: "jobPaycodeId" });
		this.setState({ jobPaycodes: auxPaycodes });
	};

	/**
	 * Gathers the agencys payment information and calls the API to save the newly added payment method
	 * @param {Object} obj
	 * @param {String} obj.type The type of payment method (credit card, bank account, etc.)
	 * @param {Sttring} obj.token The payment token received from the Stripe or Plaid request
	 */
	savePaymentMethod = ({ type, token }) => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id },
			},
		} = this.props;

		this.setState(({ paymentMethods }) => ({
			paymentMethods: { ...paymentMethods, loading: true },
		}));

		PaymentService.saveOrganizationPaymentMethod(Id, {
			Id: token.id,
			DefaultInvoicePaymentMethod: false,
			PaymentMethodType: type === "creditCard" ? 1 : 2, // 1 = Card, 2 = Bank Account
			DefaultSubscriptionPaymentMethod: [],
		})
			.then(({ data }) => {
				utils.notify({
					type: "success",
					message: lang.t("Payment Method added successfully"),
				});

				this.setState(({ paymentMethods }) => ({
					paymentMethods: { data: [...paymentMethods.data, data], loading: false },
				}));
			})
			.catch(({ response }) => {
				this.setState(({ paymentMethods }) => ({
					paymentMethods: { ...paymentMethods, loading: false },
				}));

				utils.notify({
					type: "error",
					message: response?.data.Message ?? lang.t("Error adding Payment Method"),
				});
			});
	};

	/**
	 * Deletes the selected payment method from the list
	 * @param {Number} id The id of the payment method selected for deletion
	 */
	deletePaymentMethod = id => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id },
			},
		} = this.props;

		this.setState(({ paymentMethods }) => ({
			paymentMethods: { ...paymentMethods, loading: true },
		}));

		PaymentService.deleteOrganizationPaymentMethod(Id, id)
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Payment method successfully deleted"),
				});

				this.setState(({ paymentMethods }) => ({
					paymentMethods: {
						data: paymentMethods.data.filter(item => item.Id !== id),
						loading: false,
					},
				}));
			})
			.catch(({ response }) => {
				this.setState(({ paymentMethods }) => ({
					paymentMethods: { ...paymentMethods, loading: false },
				}));

				utils.notify({
					type: "error",
					message: response?.data.Message ?? lang.t("Error deleting Payment Method"),
				});
			});
	};

	/**
	 * Opnes a modal asking for confrimation before deleting the paynent method
	 * @param {Number} id The id of the payment method selected for deletion
	 */
	onDeletePaymentMethod = id => () => {
		const { lang } = global;

		this.confirmationModal.current.openModal({
			title: lang.t("Confirm"),
			message: lang.t("Are you sure you want to remove this payment method_"),
			confirmButton: `${lang.t("Yes")}, ${lang.t("Remove")}`,
			hideConfirm: false,
			cancelButton: "Cancel",
			onConfirm: () => this.deletePaymentMethod(id),
		});
	};

	/**
	 * Sets the new preferred payment method
	 * @param {Number} id The id of the payment method selected to be the new preferred payment method
	 */
	onSetPreferredMethod = id => () => {
		const { lang } = global;
		const {
			user: {
				Organization: { Id },
			},
		} = this.props;

		this.setState(({ paymentMethods }) => ({
			paymentMethods: { ...paymentMethods, loading: true },
		}));

		PaymentService.setOrganizationPaymentMethodStatus(Id, {
			Id: id,
			DefaultInvoicePaymentMethod: true,
			DefaultSubscriptionPaymentMethod: [],
		})
			.then(({ data }) => {
				utils.notify({
					type: "success",
					message: lang.t("Default card updated successfully"),
				});

				this.setState(({ paymentMethods }) => ({
					paymentMethods: {
						data: paymentMethods.data.map(item =>
							item.Id === id ? data : { ...item, DefaultInvoicePaymentMethod: false },
						),
						loading: false,
					},
				}));
			})
			.catch(({ response }) => {
				this.setState(({ paymentMethods }) => ({
					paymentMethods: { ...paymentMethods, loading: false },
				}));

				utils.notify({
					type: "error",
					message: response?.data.Message ?? lang.t("Error setting Preferred Card"),
				});
			});
	};

	onBankAccountVerification = id => () => {
		this.bankVerificationModal.current.openModal(id);
	};

	/**
	 * Displays the bank accounts status
	 * @param {Number} id The unique id used to indetify each bank account
	 * @param {String} status The status of the backaccount as determined by valules in BANK_ACCOUNT_STATUSES
	 * @returns {HTMLElement} UI which will represent the status of the bank account
	 */
	getBankAccountBadge = (id, status) => {
		const bankAccount =
			Object.values(BANK_ACCOUNT_STATUSES).find(item => item.value === status) ??
			BANK_ACCOUNT_STATUSES.DEFAULT;

		return (
			<span
				key={`pm_status_${id}`}
				className={`label label-${bankAccount.color} agency-account-badge`}
			>
				{bankAccount.label}
			</span>
		);
	};

	handleUploadClick = () => this.uploadInput.click();

	handleViewOfficerAcknowledgeFileClick = () => {
		const { clockInAcknowledgeCloudFileId } = this.state;
		if (clockInAcknowledgeCloudFileId) {
			OrganizationService.getClockInOfficerAcknowledgementFile()
				.then(({ data }) => {
					window.open(data.URL, "_blank", "noopener,noreferrer");
				})
				.catch(() => {
					utils.notify({
						message: "Error loading clock-in acknowledgement file",
						type: "error",
					});
				});
		}
	};

	handleDeleteOfficerAcknowledgeFileClick = () => {
		const { lang } = global;
		const { clockInAcknowledgeCloudFileId } = this.state;
		if (clockInAcknowledgeCloudFileId) {
			if (this.deleteOfficerAcknowledgeConfirmationModal.current) {
				this.deleteOfficerAcknowledgeConfirmationModal.current.openModal({
					title: lang.t("Delete Officer Acknowledgement File"),
					message: lang.t(
						"Are you sure you want to delete this officer acknowledgement file_",
					),
					confirmButton: lang.t("Delete"),
					hideConfirm: false,
					cancelButton: "Cancel",
					onConfirm: this.handleOnConfirmDeleteOfficerAcknowledgeFile,
				});
			}
		}
	};

	handleOnConfirmDeleteOfficerAcknowledgeFile = () => {
		this.setState({ loadingDeptRules: true });
		OrganizationService.deleteClockInOfficerAcknowledgementFile()
			.then(() => {
				this.setState({ clockInAcknowledgeCloudFileId: null, loadingDeptRules: false });
			})
			.catch(() => {
				utils.notify({
					message: "Error deleting clock-in acknowledgement file",
					type: "error",
				});
			});
	};

	openAddPaymentMethodModal = () => {
		const { user } = this.props;

		const organizationEmail = user?.Organization?.OrganizationEmail;

		if (organizationEmail && organizationEmail !== "") {
			this.addPaymentMethodModal.current.openModal();
		} else {
			this.organizationEmailModal.current.openModal();
		}
	};

	toggleBillingHistoryModal = () =>
		this.setState(prevState => ({
			showBillingHistoryModal: !prevState.showBillingHistoryModal,
		}));

	togglePaycodesModal = id => {
		let currentPaycode = null;
		const { paycodes } = this.state;
		if (id) {
			currentPaycode = paycodes.find(item => item.Id === id);
		}
		this.setState(prevState => ({
			currentPaycode,
			showPaycodesModal: !prevState.showPaycodesModal,
		}));
	};

	deletePaycodes = pc => {
		const { lang } = global;
		const { paycodes } = this.state;
		const auxPc = [...pc];
		const initialPaycodes = [...paycodes];
		for (let i = 0; i < pc.length; i++) {
			PayCodesService.deletePaycode(pc[i].Id)
				.then(() => {
					utils.notify({
						type: "success",
						message: lang.t("Paycode deleted successfully"),
					});
				})
				.catch(({ response }) => {
					const index = auxPc.findIndex(item => item.Id === pc[i].Id);
					auxPc.splice(index, 1);
					this.setState({
						paycodes: initialPaycodes.filter(
							item => auxPc.find(item2 => item2.Id === item.Id) == null,
						),
					});
					utils.notify({
						type: "error",
						message: response?.data.Message ?? lang.t("Error deleting paycode"),
					});
				});
		}
		const auxPaycodes = paycodes.filter(item => pc.find(item2 => item2.Id === item.Id) == null);
		this.setState({ paycodes: auxPaycodes });
	};

	savePaycode = paycode => {
		const { lang } = global;
		const { paycodes } = this.state;
		if (paycode.Id != null) {
			PayCodesService.updatePaycode(paycode)
				.then(() => {
					utils.notify({
						type: "success",
						message: lang.t("Paycode updated successfully"),
					});
					const auxPaycodes = [...paycodes];
					const auxIndex = auxPaycodes.findIndex(obj => obj.Id === paycode.Id);
					auxPaycodes[auxIndex] = paycode;
					this.setState({ paycodes: auxPaycodes });
					this.buildJobPaycodes();
				})
				.catch(({ response }) => {
					utils.notify({
						type: "error",
						message: response?.data.Message ?? lang.t("Error updating paycode"),
					});
				});
		} else {
			PayCodesService.addPaycode(paycode)
				.then(({ data }) => {
					utils.notify({
						type: "success",
						message: lang.t("Paycode created successfully"),
					});
					const auxPaycode = { ...paycode, Id: data.Id };
					const auxPaycodes = [...paycodes];
					auxPaycodes.push(auxPaycode);
					this.setState({ paycodes: auxPaycodes });
					this.buildJobPaycodes();
				})
				.catch(({ response }) => {
					utils.notify({
						type: "error",
						message: response?.data.Message ?? lang.t("Error creating new paycode"),
					});
				});
		}
		this.togglePaycodesModal();
	};

	areDifferent = (rule1, rule2) => {
		if (JSON.stringify(rule1) === JSON.stringify(rule2)) {
			return false;
		}
		return true;
	};

	uploadDocument = event => {
		const file = event?.target?.files[0] ?? null;
		if (!file) return;
		if (!file.name.includes(".pdf") && !file.name.includes(".PDF")) return;
		const reader = new FileReader();
		reader.readAsDataURL(file);
		this.setState({ loadingDeptRules: true });
		reader.onload = () => {
			OrganizationService.uploadFileOfficerRules(file)
				.then(({ data: { Id, Message, SourceFileName } }) => {
					this.setState({
						clockInAcknowledgeCloudFileId: Id,
						clockInAcknowledgeCloudFileSourceFileName: SourceFileName,
						loadingDeptRules: false,
					});
					utils.notify({
						message: Message,
						type: "success",
						title: "Upload Successful",
					});
				})
				.catch(() => {
					utils.notify({
						message: "Error uploading document",
						type: "error",
					});
				});
		};
	};

	createInvoiceRule = (rule, callback) => {
		const { lang } = global;
		const { invoiceRules } = this.state;
		InvoicingRuleService.create(rule)
			.then(({ data }) => {
				utils.notify({
					type: "success",
					message: lang.t("Invoice rule created successfully"),
				});
				const invoiceRulesAux = [...invoiceRules];
				invoiceRulesAux.push(this.cleanInvoicingRuleObject(data));
				this.setState({ invoiceRules: invoiceRulesAux }, () => {
					if (callback) callback();
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error creating invoice rules"),
				});
			});
	};

	updateInvoiceRule = (rule, callback) => {
		const { lang } = global;
		const { invoiceRules } = this.state;
		InvoicingRuleService.update(rule)
			.then(({ data }) => {
				utils.notify({
					type: "success",
					message: lang.t("Invoice rule updated successfully"),
				});
				const invoiceRulesAux = [...invoiceRules];
				const ruleIndex = invoiceRulesAux.findIndex(r => r.Id === rule.Id);
				if (ruleIndex !== -1) {
					invoiceRulesAux[ruleIndex] = this.cleanInvoicingRuleObject(data);
				}
				this.setState({ invoiceRules: invoiceRulesAux }, () => {
					if (callback) callback();
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error updating invoice rules"),
				});
			});
	};

	deleteInvoiceRule = (id, callback) => {
		const { lang } = global;
		const { invoiceRules } = this.state;
		InvoicingRuleService.delete(id)
			.then(() => {
				utils.notify({
					type: "success",
					message: lang.t("Invoice rule deleted successfully"),
				});
				const invoiceRulesAux = invoiceRules.filter(r => r.Id !== id);
				this.setState({ invoiceRules: invoiceRulesAux }, () => {
					if (callback) callback();
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error deleting invoice rules"),
				});
			});
	};

	invoicingRuleBulkUpdate = (ids, criterias, callback) => {
		const { lang } = global;
		const { invoiceRules } = this.state;
		InvoicingRuleService.bulkCriteriaUpdate({
			ids,
			effectiveDateStart: criterias.effectiveDateStart,
			effectiveDateEnd: criterias.effectiveDateEnd,
		})
			.then(({ data }) => {
				utils.notify({
					type: "success",
					message: lang.t("Invoice rules updated successfully"),
				});
				const invoiceRulesAux = [...invoiceRules];
				data.forEach(rule => {
					const ruleIndex = invoiceRulesAux.findIndex(r => r.Id === rule.Id);
					if (ruleIndex !== -1) {
						invoiceRulesAux[ruleIndex] = this.cleanInvoicingRuleObject(rule);
					}
				});
				this.setState({ invoiceRules: invoiceRulesAux }, () => {
					if (callback) callback();
				});
			})
			.catch(() => {
				utils.notify({
					type: "error",
					message: lang.t("Error updating invoice rules"),
				});
			});
	};

	invoicingRuleBulkCreate = (rules, callback) => {
		const { lang } = global;
		const { invoiceRules } = this.state;
		InvoicingRuleService.bulkCreate(rules)
			.then(({ data }) => {
				utils.notify({
					type: "success",
					message: lang.t("Invoice rules created successfully"),
				});
				const invoiceRulesAux = [...invoiceRules];
				data.forEach(r => {
					invoiceRulesAux.push(this.cleanInvoicingRuleObject(r));
				});
				this.setState({ invoiceRules: invoiceRulesAux }, () => {
					if (callback) callback();
				});
			})
			.catch(({ response }) => {
				utils.notify({
					type: "error",
					message: response?.data?.Message ?? lang.t("Error creating invoice rules"),
				});
			});
	};

	/** Callback method used to update agency settings with an organizatoin email if one is not present after attempting to add a payment method */
	organizationEmailCallback = () => {
		AccountService.me().then(({ data }) => {
			// Update user object in the redux store
			const { receiveUser } = this.props;
			receiveUser(data);

			// Update organization email in the local state
			this.setState(
				state => ({
					agencyInfo: {
						...state.agencyInfo,
						OrganizationEmail: data.Organization.OrganizationEmail,
					},
				}),
				this.openAddPaymentMethodModal,
			);
		});
	};

	saveDepositAccountCallback = () => {
		this.setState({ showDirectDepositModal: false });
		this.getOrganizationDepositAccounts();
	};

	setOrganizationFeesDepositAccounts = () => {
		const { organizationDepositAccounts } = this.state;

		const generalFeeDepositAccount = organizationDepositAccounts.find(acc =>
			acc.Fees.find(fee => fee.OrganizationFeeTypeId === ORGANIZATION_FEE_TYPES.GENERAL_FEES),
		);

		const equipmentFeeDepositAccount = organizationDepositAccounts.find(acc =>
			acc.Fees.find(
				fee => fee.OrganizationFeeTypeId === ORGANIZATION_FEE_TYPES.EQUIPMENT_FEES,
			),
		);

		const vehicleFeeDepositAccount = organizationDepositAccounts.find(acc =>
			acc.Fees.find(fee => fee.OrganizationFeeTypeId === ORGANIZATION_FEE_TYPES.VEHICLE_FEES),
		);

		this.setState({
			generalFeeDepositAccountId: generalFeeDepositAccount ? generalFeeDepositAccount.Id : 0,
			equipmentFeeDepositAccountId: equipmentFeeDepositAccount
				? equipmentFeeDepositAccount.Id
				: 0,
			vehicleFeeDepositAccountId: vehicleFeeDepositAccount ? vehicleFeeDepositAccount.Id : 0,
		});
	};

	onEditDepositAccount = value => {
		const { organizationDepositAccounts } = this.state;
		const orgDepositAccount = organizationDepositAccounts.find(acc => acc.Id === value);

		this.setState({
			organizationDepositAccount: orgDepositAccount,
			showDirectDepositModal: true,
		});
	};

	render() {
		const { lang } = global;
		const {
			activeSection,
			buttonState,
			validImageSelected,
			uploadingImage,
			profilePicUrl,
			jurisdiction,
			contacts,
			agencyInfo,
			officerApproval,
			showAgencyRulesModal,
			showAssignmentRulesModal,
			showManageAssignmentsModal,
			showStaggeredRulesModal,
			showManageVehiclesModal,
			staggeredRuleId,
			showInvoicingRulesModal,
			assignmentRuleId,
			agencyAssignmentRules,
			jobPaycodes,
			assignmentRules,
			assignmentRulesDetailed,
			staggeredRules,
			officerGroups,
			JobCallOffType,
			ranks,
			JobCallOffInitialTime,
			GracePeriodInitalTime,
			clients,
			JobCallOffReplacementTypes,
			HasGracePeriod,
			IsJobLocationApprovalRequired,
			OfficerInsuranceOptIn,
			hourlyRestrictions,
			jobRestrictions,
			allowedLocations,
			invoiceRules,
			LockOfficerInfo,
			KeepJobsPosted,
			OfficerCoordinatedJobsVisible,
			RestrictJobsToOfficers,
			AcknowledgeDeptRules,
			ExtraDutyApprovalRequired,
			officerFulfillment: { AllJurisdictions },
			paymentInvoiceSettings: {
				TransferPaymentToJurisdiction,
				IsPayCodeMandatory,
				TransferCoordinatorPaymentToJurisdiction,
				InvoiceDisclaimer,
				PayCodesEnabled,
			},
			fees,
			vehicleTypes,
			RestrictedJobLocationTypes,
			IsJobLocationTypeRestricted,
			UseZones,
			usePenalties,
			penaltyType,
			selectedDayPenaltyTimeframe,
			numDaysTimeframe,
			selectedMonthPenaltyTimeframe,
			lockoutTimeframe,
			callOffPenaltyRules,
			showBillingHistoryModal,
			showPaycodesModal,
			currentPaycode,
			billingHistory,
			paymentMethods,
			showEditImageModal,
			imageToEdit,
			timezones,
			scheduleIntegration,
			loadingDeptRules,
			jobTags,
			paycodes,
			clockInAcknowledgeCloudFileId,
			clockInAcknowledgeCloudFileSourceFileName,
			organizationPaymentInvoiceSettings: { IsOfficerInvoiceApprovalRequired },
			OnlyAuthorizedClientsAreAllowedToUseVehicles,
			RequireInvoicingForVehicles,
			RequireVehicleNumber,
			RequireVehicleMiles,
			showDirectDepositModal,
			AgencyUsersCanOnlyCreateJobsWithApprovedLocations,
			TieBreaker,
			organizationDepositAccounts,
			generalFeeDepositAccountId,
			equipmentFeeDepositAccountId,
			vehicleFeeDepositAccountId,
			isLoadingOrganizationDepositAccounts,
			organizationDepositAccount,
			authenticationSettings,
			showPreview,
			nameForDisplay,
			customPolicies,
			PreventOfficerOffSiteClockIn,
		} = this.state;
		const {
			user,
			user: { TimeZoneId },
			flags: { newClientSignUp },
		} = this.props;
		const onDutyUserScheduleEnabled = user.Organization.OnDutyUserScheduleEnabled;

		const agencyVisibility = [
			{ value: "show", label: "Show only to" },
			{ value: "hide", label: "Hide from" },
		];

		const orgDepositAccountsOptions = organizationDepositAccounts.map(acc => {
			const {
				BankAccount: { AccountNumber },
			} = acc;
			return { value: acc.Id, label: `Account Number ${AccountNumber}` };
		});

		const orgDepositAccounts = [
			{ value: -1, label: "Add Account" },
			{ value: 0, label: "Default Deposit Account" },
			...orgDepositAccountsOptions,
		];

		const hourlyRestrictionsOptions = [
			{ value: "_empty", label: "", exist: false },
			{
				value: "_dailyRestriction",
				label: "Daily",
				exist: hourlyRestrictions._dailyRestriction,
			},
			{
				value: "_weeklyRestriction",
				label: "Weekly",
				exist: hourlyRestrictions._weeklyRestriction,
			},
			{
				value: "_monthlyRestriction",
				label: "Monthly",
				exist: hourlyRestrictions._monthlyRestriction,
			},
			{
				value: "_customRestriction",
				label: "Custom Date Range",
				exist: hourlyRestrictions._customRestriction,
			},
		];

		const dateMask = [/[0-1]/, /[0-9]/, "/", /[0-3]/, /[0-9]/, "/", /2/, /0/, /[2-9]/, /[0-9]/];

		const bankAccounts = paymentMethods.data.filter(item => item.Ach);
		const creditCards = paymentMethods.data
			.filter(item => item.Card)
			.sort((a, b) =>
				a.DefaultInvoicePaymentMethod && !b.DefaultInvoicePaymentMethod ? -1 : 1,
			);

		return (
			<div
				id="agency-account"
				className="container"
			>
				<div className={`row ${showBillingHistoryModal ? "hidden-print" : ""}`}>
					<div className="col-md-8">
						<Choose>
							<When condition={user.IsInternalCoordinator && !user.IsStaffAdmin}>
								<div
									id="assignment"
									className="panel panel-default ic-rules"
									ref={this.sectionRefs.approvalAssignment}
								>
									<div className="panel-heading row">
										<h3 className="panel-title col-xs-8">
											{lang.t("Posting Rules and Staggered Posting")}
										</h3>
									</div>
									<div className="panel-body container-fluid">
										<div className="row">
											<button
												type="button"
												className="btn manage-assignments-btn"
												onClick={() => this.openManageAssignmentsModal()}
											>
												<span>{lang.t("Manage Posting")}</span>
											</button>
										</div>
									</div>
								</div>
							</When>
							<Otherwise>
								<If condition={!user.isCoordinator()}>
									{/* Agency Information */}
									<div
										id="information"
										className="panel panel-default"
										ref={this.sectionRefs.agencyInfo}
									>
										<div className="panel-heading">
											<h3 className="panel-title">
												{lang.t("Agency Information")}
											</h3>
											<small className="text-muted">
												{lang.t(
													"Change agency name, profile picture, billing contact, email, and payment details_",
												)}
											</small>
										</div>
										<div className="panel-body container-fluid">
											<div className="row">
												<div className="col-xs-8 col-xs-offset-2 text-center form-group image-uploader">
													<label htmlFor="image-uploader">
														<Image
															src={profilePicUrl}
															fallbackSrc="avatar"
														/>
														<div className="blur">
															{lang.t("Update Image")}
														</div>
														<Loader active={uploadingImage} />
													</label>
													<input
														type="file"
														accept=".jpeg,.jpg,.png,.tif,.tiff"
														id="image-uploader"
														name="image-uploader"
														onChange={event => this.uploadImage(event)}
														className="hidden"
													/>
													<If condition={!validImageSelected}>
														<div className="text-danger text-center">
															{lang.t(
																"Please ensure the selected image has one of the following file extensions:",
															)}
															<br />
															{lang.t("jpeg, jpg, png, tif, tiff")}
														</div>
													</If>
												</div>
												<div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 form-group">
													<label htmlFor="agency-name">
														{lang.t("Name")}
													</label>
													<input
														id="agency-name"
														name="agency-name"
														className="form-control"
														value={agencyInfo.Name}
														onChange={this.handleAgencyInfoChange(
															"Name",
														)}
													/>
												</div>
												<If condition={user.isLEA()}>
													<div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 form-group">
														<label htmlFor="jurisdiction-name">
															{lang.t("Jurisdiction")}
														</label>
														<input
															id="jurisdiction-name"
															name="jurisdiction-name"
															className="form-control"
															value={jurisdiction}
															disabled
														/>
													</div>
												</If>
												<div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 form-group">
													<label htmlFor="timezone">
														{lang.t("Time Zone")}
													</label>
													<ReactSelect
														id="timezone"
														name="timezone"
														options={timezones}
														value={agencyInfo.TimeZone}
														onChange={this.handleAgencyInfoChange(
															"TimeZone",
														)}
													/>
												</div>
												<If condition={!user.isSuperAdmin()}>
													<div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 form-group">
														<label htmlFor="billing-contact">
															{lang.t("Billing Contact")}
														</label>
														<ReactSelect
															id="billing-contact"
															name="billing-contact"
															options={contacts}
															value={agencyInfo.BillingContactId}
															onChange={this.handleAgencyInfoChange(
																"BillingContactId",
															)}
														/>
													</div>
												</If>
												<div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 form-group">
													<label htmlFor="agency-email">
														{lang.t("EMail")}
													</label>
													<input
														id="agency-email"
														name="agency-email"
														className="form-control"
														value={agencyInfo.OrganizationEmail}
														onChange={this.handleAgencyInfoChange(
															"OrganizationEmail",
														)}
													/>
												</div>
												<div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 form-group">
													<label htmlFor="payment-details">
														{lang.t("Payment Details")}
													</label>
													<textarea
														id="payment-details"
														name="payment-details"
														className="form-control"
														value={agencyInfo.PaymentDetails}
														onChange={this.handleAgencyInfoChange(
															"PaymentDetails",
														)}
														rows={5}
													/>
												</div>
												<If condition={newClientSignUp && user.isLEA()}>
													<div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 form-group position-relative">
														<button
															type="button"
															className="preview-link"
															onClick={this.openPreview}
														>
															<i className="glyphicon glyphicon-eye-open" />{" "}
															{lang.t("Preview")}
														</button>

														<label htmlFor="payment-details">
															{lang.t("Client")} /{" "}
															{lang.t("Vendor Policies")}
														</label>
														<RichTextEditor
															value={customPolicies}
															onChange={value =>
																this.setState({
																	customPolicies: value,
																	hasPendingChanges: true,
																})
															}
														/>
													</div>
													<div className="col-xs-10 col-xs-offset-1 col-sm-8 col-sm-offset-2 form-group">
														<label htmlFor="agency-name-for-display">
															{lang.t("Department Name for Display")}
														</label>
														<input
															id="agency-name-for-display"
															name="agency-name-for-display"
															className="form-control"
															value={nameForDisplay}
															onChange={e =>
																this.setState({
																	nameForDisplay: e.target.value,
																	hasPendingChanges: true,
																})
															}
															maxLength={60}
														/>
													</div>
												</If>
											</div>
										</div>
									</div>
								</If>
								{/* Officer Approval & Assignment Rules */}
								<div
									id="assignment"
									className="panel panel-default"
									ref={this.sectionRefs.approvalAssignment}
								>
									<div className="panel-heading">
										<h3 className="panel-title">
											{lang.t("Officer Approval & Posting Rules")}
										</h3>
									</div>
									<div className="panel-body container-fluid">
										<If condition={user.isLEA()}>
											<div className="standard-padding row lea-option">
												<div className="col-xs-12 form-group">
													<label htmlFor="officer-reverification">
														<input
															type="checkbox"
															name="officer-reverification"
															id="officer-reverification"
															checked={
																officerApproval.SkipOfficerReVerification ===
																false
															}
															onChange={this.handleOfficerApprovalChange(
																"SkipOfficerReVerification",
															)}
														/>
														{lang.t(
															"Require Annual Verification Process",
														)}
													</label>
												</div>
											</div>
											<div className="standard-padding row lea-option">
												<div className="col-xs-12 form-group">
													<label htmlFor="preventOfficerAssignmentOverride">
														<input
															type="checkbox"
															name="preventOfficerAssignmentOverride"
															id="preventOfficerAssignmentOverride"
															checked={
																officerApproval.PreventOfficerAssignmentOverride
															}
															onChange={this.handleOfficerApprovalChange(
																"PreventOfficerAssignmentOverride",
															)}
														/>
														{lang.t(
															"Prevent officer assignment override",
														)}
														<Tooltip
															content={lang.t(
																"When selected, this will prevent coordinators from reassigning officers from other coordinator's jobs.",
															)}
														>
															<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</label>
												</div>
											</div>
											<div className="standard-padding row lea-option">
												<div className="col-xs-12 form-group">
													<label htmlFor="officer-lock-profile">
														<input
															type="checkbox"
															name="officer-lock-profile"
															id="officer-lock-profile"
															checked={LockOfficerInfo}
															onChange={this.handleLockOfficerChange()}
														/>
														{lang.t("Lock all officer profiles")}
													</label>
												</div>
											</div>
											<div className="standard-padding row lea-option">
												<div className="col-xs-12 form-group">
													<label htmlFor="keep-jobs-posted">
														<input
															type="checkbox"
															name="keep-jobs-posted"
															id="keep-jobs-posted"
															checked={KeepJobsPosted}
															onChange={this.handleKeepJobsPostedChange()}
														/>
														{lang.t(
															"Allow jobs to stay posted when they have already started",
														)}
													</label>
												</div>
											</div>
										</If>
										<If
											condition={
												(user.isLEA() && user.isStaffAdmin) ||
												user.isAgencyAdmin() ||
												user.isCoordinator
											}
										>
											<div className="row tie-breaker-section">
												<div className="col-xs-4 col-sm-4">
													{lang.t("Assignment Tie Breaker")}:
												</div>
												<div className="col-xs-4 col-sm-4 col-sm-offset-4">
													<ReactSelect
														id="tiebreaker"
														name="tiebreaker"
														options={TIE_BREAKER_TYPES}
														value={TieBreaker}
														onChange={this.handleTieBreakerRuleChange()}
													/>
												</div>
											</div>
										</If>
										<div className="row settings-title">
											<h4 className="panel-title col-xs-10">
												{lang.t("Posting Rules and Staggered Posting")}
											</h4>
										</div>
										<div className="row">
											<button
												type="button"
												className="btn manage-assignments-btn"
												onClick={() => this.openManageAssignmentsModal()}
											>
												<span>{lang.t("Manage Posting")}</span>
											</button>
										</div>
										<div className="hidden container-fluid settings-panel">
											<div className="row">
												<div className="col-xs-8 col-sm-9">
													<strong>
														{lang.t("Agency Assignment Rules")}
													</strong>
												</div>
												<div className="col-xs-2 col-sm-1 col-sm-offset-1 text-center">
													<button
														type="button"
														className="btn btn-link"
														onClick={() =>
															this.toggleAgencyRulesModal()
														}
													>
														<i className="rkf rkf-pencil" />
													</button>
												</div>
											</div>
											<If condition={assignmentRules.length === 0}>
												<div className="row">
													<div className="col-xs-12 text-muted text-center">
														{lang.t("No assignment rules")}
													</div>
												</div>
											</If>
											<For
												each="rule"
												of={assignmentRules}
											>
												<div
													className="row"
													key={`assignment-group-${rule.Id}`}
												>
													<div className="col-xs-8 col-sm-9">
														{rule.Name}
													</div>
													<div className="col-xs-2 col-sm-1 col-sm-offset-1 text-center">
														<button
															type="button"
															className="btn btn-link"
															onClick={() =>
																this.openAssignmentRulesModal(
																	rule.Id,
																)
															}
														>
															<i className="rkf rkf-pencil" />
														</button>
													</div>
													<div className="col-xs-2 col-sm-1 text-center">
														<button
															type="button"
															className="btn btn-link"
															onClick={() =>
																this.handleRuleDelete(rule.Id)
															}
														>
															<i className="rkf rkf-trash text-danger" />
														</button>
													</div>
												</div>
											</For>
										</div>
									</div>
								</div>
								<AuthenticationSection
									id="authentication"
									sectionRef={this.sectionRefs.authentication}
									title={lang.t("Authentication Menu Title")}
									subtitle={lang.t("Authentication Menu Subtitle")}
									mfaEnforced={authenticationSettings.MFAEnforced}
									federationEnabled={authenticationSettings.FederationEnabled}
									federatedDomain={authenticationSettings.FederatedDomain}
									federationEnforcedBy={
										authenticationSettings.FederationEnforcedBy
									}
									handleFederationEnforcementDateChange={
										this.handleFederationEnforcementDateChange
									}
								/>
								{/* Officer Call Off */}
								<OfficerCallOffSection
									id="calloff"
									sectionRef={this.sectionRefs.callOff}
									title={lang.t("Officer Call Off and Replacement")}
									subtitle={lang.t(
										"Set up how officers can call off of upcoming jobs_",
									)}
									handleTypeChange={this.handleCallOffTypeChange}
									jobCallOffType={JobCallOffType}
									handleExpirationChange={this.handleCallOffExpirationChange}
									handleGracePeriodChange={this.handleGracePeriodChange}
									handleHasGracePeriodChange={this.handleHasGracePeriodChange}
									jobCallOffInitialTime={JobCallOffInitialTime}
									gracePeriodInitialTime={GracePeriodInitalTime}
									jobCallOffReplacementTypes={JobCallOffReplacementTypes}
									handleReplacementTypeChange={this.handleReplacementTypeChange}
									hasGracePeriod={HasGracePeriod}
								/>
								{/* Officer Call Off Penalties */}
								<If condition={user.isLEA()}>
									<OfficerCallOffPenaltiesSection
										id="calloffpenalties"
										sectionRef={this.sectionRefs.callOffPenalties}
										title={lang.t("Officer Penalties")}
										subtitle={lang.t("Customize officer penalties_")}
										usePenalties={usePenalties}
										handleUsePenaltiesChange={this.handleEnablePenalties}
										penaltyType={penaltyType}
										handlePenaltyTypeChange={this.handlePenaltyTypeChange}
										lockoutTimeframe={lockoutTimeframe}
										handleLockoutTimeframeChange={
											this.handleLockoutTimeframeChange
										}
										selectedDayPenaltyTimeframe={selectedDayPenaltyTimeframe}
										selectedMonthPenaltyTimeframe={
											selectedMonthPenaltyTimeframe
										}
										handleOnChangeMonthPenaltyTimeframe={
											this.handleOnChangeMonthPenaltyTimeframe
										}
										handleOnChangeDayPenaltyTimeframe={
											this.handleOnChangeDayPenaltyTimeframe
										}
										callOffPenaltyRules={callOffPenaltyRules}
										handleOnChangePenaltyRules={this.handleOnChangePenaltyRules}
										numDaysTimeframe={numDaysTimeframe}
										handleNumDayTimeframeChange={
											this.handleNumDayTimeframeChange
										}
									/>
								</If>
								<If condition={user.isLEA()}>
									{/* Agency Restrictions */}
									<div
										id="jobrestrictions"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.jobRestrictions}
										>
											<h3 className="panel-title">
												{lang.t("Agency Restrictions")}
											</h3>
											<small className="text-muted">
												{lang.t(
													"Set up what jobs your officers can work in the platform_",
												)}
											</small>
										</div>
										<div className="panel-body container-fluid">
											<div className="panel-body container-fluid">
												<div className="standard-padding row">
													<If condition={this.hasDeptRulesEnabled}>
														<div
															className="col-xs-12"
															style={{ marginTop: "10px" }}
														>
															<label htmlFor="other-dept-rule">
																<input
																	type="checkbox"
																	name="other-dept-rule"
																	id="other-dept-rule"
																	checked={AcknowledgeDeptRules}
																	onChange={() =>
																		this.toggleAcknowledgeRules()
																	}
																/>
																{lang.t(
																	"My Officers have to acknowledge department rules before clocking into a job",
																)}
															</label>
															<If condition={AcknowledgeDeptRules}>
																<div className="officer-acknowledge-container">
																	<If
																		condition={
																			!clockInAcknowledgeCloudFileId
																		}
																	>
																		<div>
																			<small>
																				{lang.t(
																					"PDF only*",
																				)}
																			</small>
																		</div>
																		<input
																			name="tax-exemption-document"
																			type="file"
																			accept=".pdf"
																			ref={ref => {
																				this.uploadInput =
																					ref;
																			}}
																			onChange={
																				this.uploadDocument
																			}
																			className="hidden"
																		/>
																		<button
																			type="button"
																			id="tax-exemption-btn"
																			className="btn btn-default"
																			onClick={
																				this
																					.handleUploadClick
																			}
																		>
																			{lang.t(
																				"Upload Department Rules",
																			)}
																		</button>
																	</If>
																	<If
																		condition={
																			clockInAcknowledgeCloudFileId
																		}
																	>
																		<span>
																			{
																				clockInAcknowledgeCloudFileSourceFileName
																			}
																		</span>
																		<button
																			type="button"
																			id="tax-exemption-btn"
																			className="btn btn-link"
																			onClick={
																				this
																					.handleViewOfficerAcknowledgeFileClick
																			}
																		>
																			<i className="rkf rkf-file" />
																			{lang.t("View File")}
																		</button>
																		<button
																			type="button"
																			className="btn btn-link"
																			onClick={
																				this
																					.handleDeleteOfficerAcknowledgeFileClick
																			}
																		>
																			<i className="rkf rkf-trash text-danger" />
																			{lang.t("Delete File")}
																		</button>
																	</If>
																	<Loader
																		active={loadingDeptRules}
																	/>
																</div>
															</If>
														</div>
													</If>
													<div className="col-xs-12">
														<label htmlFor="restrict-jobs">
															<input
																type="checkbox"
																name="restrict-jobs"
																id="restrict-jobs"
																checked={RestrictJobsToOfficers}
																onChange={() =>
																	this.toggleRestrictJobs()
																}
															/>
															{lang.t(
																"Restrict what jobs my officers can work on the platform",
															)}
														</label>
													</div>
													<If condition={RestrictJobsToOfficers}>
														<div
															className="standard-padding row"
															style={{ marginLeft: "11px" }}
														>
															<div className="col-xs-12 radio">
																<label htmlFor="job-restriction-20">
																	<input
																		type="radio"
																		name="job-restriction-options"
																		id="job-restriction-20"
																		onChange={this.handleJobRestrictionTypeChange(
																			20,
																		)}
																		checked={
																			jobRestrictions.JobRestrictionType ===
																			20
																		}
																	/>
																	{lang.t(
																		"Only allow jobs in these cities/counties",
																	)}
																	<Tooltip
																		content={lang.t(
																			"The officer will only see jobs on allowed locations",
																		)}
																	>
																		<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
																	</Tooltip>
																</label>
															</div>
															<div className="col-xs-12 radio">
																<label htmlFor="job-restriction-30">
																	<input
																		type="radio"
																		name="job-restriction-options"
																		id="job-restriction-30"
																		onChange={this.handleJobRestrictionTypeChange(
																			30,
																		)}
																		checked={
																			jobRestrictions.JobRestrictionType ===
																			30
																		}
																	/>
																	{lang.t(
																		"Only allow jobs created by my agency",
																	)}
																	<Tooltip
																		content={lang.t(
																			"The officer will only see and apply to jobs created by your agency",
																		)}
																	>
																		<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
																	</Tooltip>
																</label>
															</div>
														</div>
														<If
															condition={
																jobRestrictions.JobRestrictionType ===
																20
															}
														>
															<div className="row settings-title">
																<h4 className="panel-title col-xs-10">
																	{lang.t("Allowed Locations")}
																</h4>
																<div className="col-xs-2 text-right">
																	<If
																		condition={
																			user.StateAbbreviation
																		}
																	>
																		<button
																			type="button"
																			className="btn btn-link"
																			onClick={() =>
																				this.handleLocationAdd()
																			}
																		>
																			<span className="visible-xs">{`+ ${lang.t("Add")}`}</span>
																			<span className="hidden-xs">{`+ ${lang.t("Add Location")}`}</span>
																		</button>
																	</If>
																</div>
															</div>
															<div
																className="container-fluid settings-panel"
																style={{ marginBottom: "15px" }}
															>
																<If
																	condition={
																		allowedLocations.length ===
																		0
																	}
																>
																	<div className="row">
																		<div className="col-xs-12 text-muted text-center">
																			<Choose>
																				<When
																					condition={
																						user.StateAbbreviation
																					}
																				>
																					{lang.t(
																						"You have not specified any restricted locations",
																					)}
																				</When>
																				<Otherwise>
																					{lang.t(
																						"Please update your address in account settings to modify restricted location restrictions",
																					)}
																				</Otherwise>
																			</Choose>
																		</div>
																	</div>
																</If>
																<For
																	each="loc"
																	of={allowedLocations}
																	index="index"
																>
																	<div
																		className="row"
																		key={`location-restriction-${loc.label}`}
																	>
																		<div className="col-xs-2">
																			<span className="badge">
																				{loc.type}
																			</span>
																		</div>
																		<div className="col-xs-8">
																			<AsyncSelect
																				id={`location-restriction-${loc.label}`}
																				placeholder={lang.t(
																					"Search Location",
																				)}
																				cacheOptions
																				loadOptions={
																					this
																						.searchLocations
																				}
																				value={
																					loc.label !== ""
																						? loc
																						: undefined
																				}
																				onChange={this.handleLocationUpdate(
																					index,
																				)}
																				noOptionsMessage={({
																					inputValue,
																				}) =>
																					inputValue
																						? lang.t(
																								"Location not found",
																							)
																						: lang.t(
																								"Please type a location name in order to see options",
																							)
																				}
																			/>
																		</div>
																		<div className="col-xs-2 text-center">
																			<button
																				type="button"
																				className="btn btn-link"
																				onClick={this.handleLocationUpdate(
																					index,
																					true,
																				)}
																			>
																				<i className="rkf rkf-trash text-danger" />
																			</button>
																		</div>
																	</div>
																</For>
															</div>
														</If>
													</If>
													{/* Only display the option for V3 enabled LEAs */}
													<If condition={this.hasPreventOfficerOffsiteClockInEnabled && (user.isInvoicingV3() || user.isInvoicingV2())}>
														<div className="col-xs-12">
															<label htmlFor="prevent-officers-offsite-clock-in">
																<input
																	type="checkbox"
																	checked={PreventOfficerOffSiteClockIn}
																	id="prevent-officers-offsite-clock-in"
																	name="prevent-officers-offsite-clock-in"
																	onChange={() => this.togglePreventOfficerOffSiteClockIn()}
																/>
																{lang.t("Prevent officers from clocking-in into a job if they are offsite at the time of clocking-in")}
																<Tooltip
																	content={lang.t("DenyOfficerFromClockingInTooltipMessage")}
																>
																	<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
																</Tooltip>
															</label>
														</div>
													</If>
												</div>
											</div>
										</div>
									</div>
									{/* On duty Schedule Integration */}
									<If condition={user?.Organization?.OnDutyUserScheduleEnabled}>
										<div
											id="ondutyscheduleintegration"
											className="panel panel-default"
										>
											<div
												className="panel-heading"
												ref={this.sectionRefs.scheduleIntegration}
											>
												<h3 className="panel-title">
													{lang.t("On duty Schedule Integration")}
												</h3>
											</div>
											<div className="panel-body container-fluid">
												<div className="standard-padding row">
													<div className="col-xs-12">
														<label htmlFor="schedule-integration-check">
															<input
																type="checkbox"
																name="schedule-integration-check"
																id="schedule-integration-check"
																checked={
																	scheduleIntegration.UseOnDutyScheduleIntegrations
																}
																onChange={() =>
																	this.toggleOnDutyScheduleIntegration()
																}
															/>
															{lang.t(
																"Use on-duty schedule to prevent overlapping shifts",
															)}
														</label>
													</div>
												</div>
												<If
													condition={
														scheduleIntegration.UseOnDutyScheduleIntegrations
													}
												>
													<div className="schedule-integration-container">
														<div className="standard-padding row">
															<div className="col-xs-12">
																<label htmlFor="job-supervisor-schedule-conflict-override">
																	<input
																		type="checkbox"
																		name="job-supervisor-schedule-conflict-override"
																		id="job-supervisor-schedule-conflict-override"
																		checked={
																			scheduleIntegration.CoordinatorsCanOverrideOnDutyScheduleConflicts
																		}
																		onChange={this.handleUserScheduleChange(
																			"CoordinatorsCanOverrideOnDutyScheduleConflicts",
																		)}
																	/>
																	{lang.t(
																		"Coordinators can override on-duty scheduling conflicts",
																	)}
																</label>
															</div>
														</div>
														<div className="standard-padding row">
															<div className="col-xs-12">
																<label htmlFor="apply-schedule-conflict">
																	<input
																		type="checkbox"
																		name="apply-schedule-conflict"
																		id="apply-schedule-conflict"
																		checked={
																			scheduleIntegration.OfficersCanOverrideOnDutyScheduleConflicts
																		}
																		onChange={this.handleUserScheduleChange(
																			"OfficersCanOverrideOnDutyScheduleConflicts",
																		)}
																	/>
																	{lang.t(
																		"Personnel can override on-duty scheduling conflicts",
																	)}
																</label>
															</div>
														</div>
													</div>
												</If>
											</div>
										</div>
									</If>
									<If condition={!this.isPittsburghOrg}>
										{/* Hourly Restrictions */}
										<div
											id="hourlyrestrictions"
											className="panel panel-default"
										>
											<div
												className="panel-heading"
												ref={this.sectionRefs.hourlyRestrictions}
											>
												<h3 className="panel-title">
													{lang.t("Hourly Limits")}
												</h3>
											</div>
											<div className="panel-body container-fluid">
												<div className="standard-padding row">
													<div className="col-xs-12">
														<label htmlFor="hourly-restrictions-check">
															<input
																type="checkbox"
																name="hourly-restrictions-check"
																id="hourly-restrictions-check"
																checked={
																	hourlyRestrictions._limitedHours
																}
																onChange={() =>
																	this.toggleHourlyRestrictions()
																}
															/>
															{lang.t(
																"Enforce hourly restrictions of department",
															)}
														</label>
													</div>
												</div>
												<If condition={hourlyRestrictions._limitedHours}>
													<div className="hourly-restrictions-container">
														<If
															condition={
																!hourlyRestrictions._dailyRestriction ||
																!hourlyRestrictions._weeklyRestriction ||
																!hourlyRestrictions._monthlyRestriction ||
																!hourlyRestrictions._customRestriction
															}
														>
															<div className="row restriction-selector-container">
																<div className="col-xs-12">
																	<label htmlFor="add-restriction-select">
																		{lang.t("Add restriction")}
																		<select
																			id="add-restriction-select"
																			name="add-restriction-select"
																			title="Visibility"
																			className="custom-select form-control"
																			onChange={this.handleRestrictionChange(
																				true,
																			)}
																		>
																			<For
																				each="item"
																				of={
																					hourlyRestrictionsOptions
																				}
																			>
																				<option
																					key={`${item.label}-${item.value}`}
																					value={
																						item.value
																					}
																					disabled={
																						item.exist
																					}
																				>
																					{item.label}
																				</option>
																			</For>
																		</select>
																	</label>
																</div>
															</div>
														</If>
														<If
															condition={
																hourlyRestrictions._dailyRestriction
															}
														>
															{/* Daily Restriction */}
															<div className="restriction-container">
																<div className="row">
																	<div className="col-xs-12">
																		<span
																			className={classNames(
																				"header",
																				{
																					"invalid-input-header":
																						!this.validateHourlyInput(
																							hourlyRestrictions.MaxDailyHours,
																						),
																				},
																			)}
																		>
																			{lang.t("Daily")}
																		</span>
																	</div>
																</div>
																<div className="row">
																	<div className="col-xs-12 form-group">
																		<span>
																			{lang.t(
																				"Officers are restricted from working more than",
																			)}
																		</span>
																		<input
																			type="tel"
																			min="1"
																			name="daily-hourly-limit"
																			id="daily-hourly-limit"
																			className={classNames(
																				"hour-input",
																				{
																					"invalid-input":
																						!this.validateHourlyInput(
																							hourlyRestrictions.MaxDailyHours,
																						),
																				},
																			)}
																			value={
																				hourlyRestrictions.MaxDailyHours
																			}
																			onChange={this.handleHourlyRestrictionsChange(
																				"MaxDailyHours",
																			)}
																		/>
																		<span>
																			{lang.t(
																				"hours per day",
																			)}
																		</span>
																		<button
																			type="button"
																			className="btn btn-link remove-button"
																			onClick={this.handleRestrictionChange(
																				false,
																				"_dailyRestriction",
																			)}
																		>
																			<span className="text-danger">
																				{lang.t("Remove")}
																			</span>
																		</button>
																	</div>
																</div>
																<div className="row">
																	<If
																		condition={
																			onDutyUserScheduleEnabled &&
																			this
																				.hasOnDutyHourlyLimitsEnabled
																		}
																	>
																		<div className="col-xs-12 restriction-options-container">
																			<label htmlFor="daily-hour-on-off-duty">
																				<input
																					type="checkbox"
																					name="daily-hour-on-off-duty"
																					id="daily-hour-on-off-duty"
																					checked={
																						hourlyRestrictions.IncludeBothOnOffDutyHoursDaily
																					}
																					onChange={() =>
																						this.toggleHourlyOverrideRestrictions(
																							"IncludeBothOnOffDutyHoursDaily",
																						)
																					}
																				/>
																				{lang.t(
																					"Include both on and off duty hours",
																				)}
																			</label>
																		</div>
																	</If>
																	<div className="col-xs-12 restriction-options-container">
																		<label htmlFor="daily-hour-override">
																			<input
																				type="checkbox"
																				name="daily-hour-override"
																				id="daily-hour-override"
																				checked={
																					hourlyRestrictions.AllowOfficerOverrideDaily
																				}
																				onChange={() =>
																					this.toggleHourlyOverrideRestrictions(
																						"AllowOfficerOverrideDaily",
																					)
																				}
																			/>
																			{lang.t(
																				"Allow personnel to override this rule",
																			)}
																		</label>
																	</div>
																</div>
															</div>
														</If>
														<If
															condition={
																hourlyRestrictions._weeklyRestriction
															}
														>
															{/* Weekly Restriction */}
															<div className="restriction-container">
																<div className="row">
																	<div className="col-xs-12">
																		<span
																			className={classNames(
																				"header",
																				{
																					"invalid-input-header":
																						!this.validateHourlyInput(
																							hourlyRestrictions.MaxWeeklyHours,
																						),
																				},
																			)}
																		>
																			{lang.t("Weekly")}
																		</span>
																	</div>
																</div>
																<div className="row">
																	<div className="col-xs-12 form-group">
																		<span>
																			{lang.t(
																				"Officers are restricted from working more than",
																			)}
																		</span>
																		<input
																			type="tel"
																			min="1"
																			name="weekly-hourly-limit"
																			id="weekly-hourly-limit"
																			className={classNames(
																				"hour-input",
																				{
																					"invalid-input":
																						!this.validateHourlyInput(
																							hourlyRestrictions.MaxWeeklyHours,
																						),
																				},
																			)}
																			value={
																				hourlyRestrictions.MaxWeeklyHours
																			}
																			onChange={this.handleHourlyRestrictionsChange(
																				"MaxWeeklyHours",
																			)}
																		/>
																		<span>
																			{lang.t(
																				"hours per week",
																			)}
																		</span>
																		<button
																			type="button"
																			className="btn btn-link remove-button"
																			onClick={this.handleRestrictionChange(
																				false,
																				"_weeklyRestriction",
																			)}
																		>
																			<span className="text-danger">
																				{lang.t("Remove")}
																			</span>
																		</button>
																	</div>
																</div>
																<div className="row">
																	<div className="col-xs-12">
																		<span>
																			{lang.t("From")}
																		</span>
																	</div>
																</div>
																<div className="row">
																	<div className="col-xs-12 weekly-type-container">
																		<select
																			id="weekly-hourly-restriction"
																			name="weekly-hourly-restriction"
																			className="custom-select form-control"
																			value={
																				hourlyRestrictions.MaxWeeklyHoursType
																			}
																			onChange={this.handleHourlyRestrictionsChange(
																				"MaxWeeklyHoursType",
																			)}
																		>
																			<For
																				each="item"
																				of={
																					MAX_WEEKLY_HOURS_TYPES
																				}
																			>
																				<option
																					key={`${item.startDayLabel}-${item.value}`}
																					value={
																						item.value
																					}
																				>
																					{lang.t(
																						item.startDayLabel,
																					)}
																				</option>
																			</For>
																		</select>
																		<span>
																			{lang.t(
																				hourlyRestrictions._weeklyTypeEndDay,
																			)}
																		</span>
																	</div>
																</div>
																<div className="row">
																	<If
																		condition={
																			onDutyUserScheduleEnabled &&
																			this
																				.hasOnDutyHourlyLimitsEnabled
																		}
																	>
																		<div className="col-xs-12 restriction-options-container">
																			<label htmlFor="weekly-hour-on-off-duty">
																				<input
																					type="checkbox"
																					name="weekly-hour-on-off-duty"
																					id="weekly-hour-on-off-duty"
																					checked={
																						hourlyRestrictions.IncludeBothOnOffDutyHoursWeekly
																					}
																					onChange={() =>
																						this.toggleHourlyOverrideRestrictions(
																							"IncludeBothOnOffDutyHoursWeekly",
																						)
																					}
																				/>
																				{lang.t(
																					"Include both on and off duty hours",
																				)}
																			</label>
																		</div>
																	</If>
																	<div className="col-xs-12 restriction-options-container">
																		<label htmlFor="weekly-hour-override">
																			<input
																				type="checkbox"
																				name="weekly-hour-override"
																				id="weekly-hour-override"
																				checked={
																					hourlyRestrictions.AllowOfficerOverrideWeekly
																				}
																				onChange={() =>
																					this.toggleHourlyOverrideRestrictions(
																						"AllowOfficerOverrideWeekly",
																					)
																				}
																			/>
																			{lang.t(
																				"Allow personnel to override this rule",
																			)}
																		</label>
																	</div>
																</div>
															</div>
														</If>
														<If
															condition={
																hourlyRestrictions._customRestriction
															}
														>
															{/* Custom Restriction */}
															<div className="restriction-container">
																<div className="row">
																	<div className="col-xs-12">
																		<span
																			className={classNames(
																				"header",
																				{
																					"invalid-input-header":
																						!this.validateHourlyInput(
																							hourlyRestrictions.MaxCustomHours,
																						) ||
																						!this.validateHourlyInput(
																							hourlyRestrictions.CustomRecurringDays,
																						) ||
																						!this.validateHourlyInput(
																							hourlyRestrictions.CustomStart,
																						),
																				},
																			)}
																		>
																			{lang.t(
																				"Custom Date Range",
																			)}
																		</span>
																	</div>
																</div>
																<div className="row">
																	<div className="col-xs-12 form-group">
																		<span>
																			{lang.t(
																				"Officers are restricted from working more than",
																			)}
																		</span>
																		<input
																			type="tel"
																			min="1"
																			name="custom-hourly-limit"
																			id="custom-hourly-limit"
																			className={classNames(
																				"hour-input",
																				{
																					"invalid-input":
																						!this.validateHourlyInput(
																							hourlyRestrictions.MaxCustomHours,
																						),
																				},
																			)}
																			value={
																				hourlyRestrictions.MaxCustomHours
																			}
																			onChange={this.handleHourlyRestrictionsChange(
																				"MaxCustomHours",
																			)}
																		/>
																		<span>
																			{lang.t(
																				"hours, recurring every",
																			)}
																		</span>
																		<input
																			type="tel"
																			min="1"
																			name="custom-recurring-days"
																			id="custom-recurring-days"
																			className={classNames(
																				"hour-input",
																				{
																					"invalid-input":
																						!this.validateHourlyInput(
																							hourlyRestrictions.CustomRecurringDays,
																						),
																				},
																			)}
																			value={
																				hourlyRestrictions.CustomRecurringDays
																			}
																			onChange={this.handleHourlyRestrictionsChange(
																				"CustomRecurringDays",
																			)}
																		/>
																		<span>
																			{lang.t(
																				"days, starting",
																			)}
																		</span>
																		<Choose>
																			<When
																				condition={
																					utils.isDesktopSafari ||
																					utils.isIE
																				}
																			>
																				<MaskedInput
																					name="custom-start-date"
																					id="custom-start-date"
																					type="text"
																					mask={dateMask}
																					placeholder="mm/dd/yyyy"
																					className={classNames(
																						{
																							"invalid-input":
																								hourlyRestrictions.CustomStart ===
																								"",
																						},
																					)}
																					value={
																						hourlyRestrictions.CustomStart
																					}
																					onChange={this.handleHourlyRestrictionsChange(
																						"CustomStart",
																					)}
																				/>
																			</When>
																			<Otherwise>
																				<input
																					name="custom-start-date"
																					id="custom-start-date"
																					type="date"
																					className={classNames(
																						{
																							"invalid-input":
																								hourlyRestrictions.CustomStart ===
																								"",
																						},
																					)}
																					value={
																						hourlyRestrictions.CustomStart
																					}
																					onChange={this.handleHourlyRestrictionsChange(
																						"CustomStart",
																					)}
																				/>
																			</Otherwise>
																		</Choose>
																		<button
																			type="button"
																			className="btn btn-link remove-button"
																			onClick={this.handleRestrictionChange(
																				false,
																				"_customRestriction",
																			)}
																		>
																			<span className="text-danger">
																				{lang.t("Remove")}
																			</span>
																		</button>
																	</div>
																</div>
																<div className="row">
																	<If
																		condition={
																			onDutyUserScheduleEnabled &&
																			this
																				.hasOnDutyHourlyLimitsEnabled
																		}
																	>
																		<div className="col-xs-12 restriction-options-container">
																			<label htmlFor="custom-hour-on-off-duty">
																				<input
																					type="checkbox"
																					name="custom-hour-on-off-duty"
																					id="custom-hour-on-off-duty"
																					checked={
																						hourlyRestrictions.IncludeBothOnOffDutyHoursCustom
																					}
																					onChange={() =>
																						this.toggleHourlyOverrideRestrictions(
																							"IncludeBothOnOffDutyHoursCustom",
																						)
																					}
																				/>
																				{lang.t(
																					"Include both on and off duty hours",
																				)}
																			</label>
																		</div>
																	</If>
																	<div className="col-xs-12 restriction-options-container">
																		<label htmlFor="custom-hour-override">
																			<input
																				type="checkbox"
																				name="custom-hour-override"
																				id="custom-hour-override"
																				checked={
																					hourlyRestrictions.AllowOfficerOverrideCustom
																				}
																				onChange={() =>
																					this.toggleHourlyOverrideRestrictions(
																						"AllowOfficerOverrideCustom",
																					)
																				}
																			/>
																			{lang.t(
																				"Allow personnel to override this rule",
																			)}
																		</label>
																	</div>
																</div>
															</div>
														</If>
														<If
															condition={
																hourlyRestrictions._monthlyRestriction
															}
														>
															{/* Monthly Restriction */}
															<div className="restriction-container">
																<div className="row">
																	<div className="col-xs-12">
																		<span
																			className={classNames(
																				"header",
																				{
																					"invalid-input-header":
																						!this.validateHourlyInput(
																							hourlyRestrictions.MaxMonthlyHours,
																						),
																				},
																			)}
																		>
																			{lang.t("Monthly")}
																		</span>
																	</div>
																</div>
																<div className="row">
																	<div className="col-xs-12 form-group">
																		<span>
																			{lang.t(
																				"Officers are restricted from working more than",
																			)}
																		</span>
																		<input
																			type="tel"
																			min="1"
																			name="monthly-hourly-limit"
																			id="monthly-hourly-limit"
																			className={classNames(
																				"hour-input",
																				{
																					"invalid-input":
																						!this.validateHourlyInput(
																							hourlyRestrictions.MaxMonthlyHours,
																						),
																				},
																			)}
																			value={
																				hourlyRestrictions.MaxMonthlyHours
																			}
																			onChange={this.handleHourlyRestrictionsChange(
																				"MaxMonthlyHours",
																			)}
																		/>
																		<span>
																			{lang.t(
																				"hours per month",
																			)}
																		</span>
																		<button
																			type="button"
																			className="btn btn-link remove-button"
																			onClick={this.handleRestrictionChange(
																				false,
																				"_monthlyRestriction",
																			)}
																		>
																			<span className="text-danger">
																				{lang.t("Remove")}
																			</span>
																		</button>
																	</div>
																</div>
																<div className="row">
																	<If
																		condition={
																			onDutyUserScheduleEnabled &&
																			this
																				.hasOnDutyHourlyLimitsEnabled
																		}
																	>
																		<div className="col-xs-12 restriction-options-container">
																			<label htmlFor="monthly-hour-on-off-duty">
																				<input
																					type="checkbox"
																					name="monthly-hour-on-off-duty"
																					id="monthly-hour-on-off-duty"
																					checked={
																						hourlyRestrictions.IncludeBothOnOffDutyHoursMonthly
																					}
																					onChange={() =>
																						this.toggleHourlyOverrideRestrictions(
																							"IncludeBothOnOffDutyHoursMonthly",
																						)
																					}
																				/>
																				{lang.t(
																					"Include both on and off duty hours",
																				)}
																			</label>
																		</div>
																	</If>
																	<div className="col-xs-12 restriction-options-container">
																		<label htmlFor="monthly-hour-override">
																			<input
																				type="checkbox"
																				name="monthly-hour-override"
																				id="monthly-hour-override"
																				checked={
																					hourlyRestrictions.AllowOfficerOverrideMonthly
																				}
																				onChange={() =>
																					this.toggleHourlyOverrideRestrictions(
																						"AllowOfficerOverrideMonthly",
																					)
																				}
																			/>
																			{lang.t(
																				"Allow personnel to override this rule",
																			)}
																		</label>
																	</div>
																</div>
															</div>
														</If>
													</div>
												</If>
											</div>
										</div>
									</If>
									<If condition={this.isPittsburghOrg}>
										<div
											id="hourlyrestrictions"
											className="panel panel-default"
										>
											<div
												className="panel-heading"
												ref={this.sectionRefs.hourlyRestrictions}
											>
												<h3 className="panel-title">
													{lang.t("Hourly Limits")}
												</h3>
											</div>
											<div className="panel-body container-fluid">
												<div className="row">
													<div className="col-xs-12">
														{lang.t(
															"Do you limit the number of hours your officers can work_",
														)}
													</div>
												</div>
												<div className="row">
													<div className="col-xs-2 col-sm-1">
														<div className="radio">
															<label htmlFor="hourly-restrictions-no">
																<input
																	type="radio"
																	name="hourly-restrictions"
																	id="hourly-restrictions-no"
																	onChange={() =>
																		this.toggleHourlyRestrictions()
																	}
																	checked={
																		!hourlyRestrictions._limitedHours
																	}
																/>
																{lang.t("No")}
															</label>
														</div>
													</div>
													<div className="col-xs-2 col-xs-offset-1 col-sm-1 col-sm-offset-0">
														<div className="radio">
															<label htmlFor="hourly-restrictions-yes">
																<input
																	type="radio"
																	name="hourly-restrictions"
																	id="hourly-restrictions-yes"
																	onChange={() =>
																		this.toggleHourlyRestrictions()
																	}
																	checked={
																		hourlyRestrictions._limitedHours
																	}
																/>
																{lang.t("Yes")}
															</label>
														</div>
													</div>
												</div>
												<If condition={hourlyRestrictions._limitedHours}>
													<div className="row">
														<div className="col-xs-10 col-xs-offset-2 col-sm-11 col-sm-offset-1 radio">
															<label htmlFor="hourly-restriction-1">
																<input
																	type="radio"
																	name="hourly-restriction-type"
																	id="hourly-restriction-1"
																	onChange={this.handleHourlyRestrictionsChange(
																		"MaxWeeklyHoursType",
																		1,
																	)}
																	checked={
																		hourlyRestrictions.MaxWeeklyHoursType ===
																		1
																	}
																/>
																{lang.t("Monday to Sunday")}
															</label>
														</div>
														<div className="col-xs-10 col-xs-offset-2 col-sm-11 col-sm-offset-1 radio">
															<label htmlFor="hourly-restriction-2">
																<input
																	type="radio"
																	name="hourly-restriction-type"
																	id="hourly-restriction-2"
																	onChange={this.handleHourlyRestrictionsChange(
																		"MaxWeeklyHoursType",
																		2,
																	)}
																	checked={
																		hourlyRestrictions.MaxWeeklyHoursType ===
																		2
																	}
																/>
																{lang.t("Sunday to Saturday")}
															</label>
														</div>
													</div>
													<div className="row">
														<div className="col-xs-10 col-xs-offset-2 col-sm-6 col-sm-offset-1 form-group">
															<label htmlFor="hourly-limit">
																{lang.t(
																	"How many hours do you limit your officers to per week_",
																)}
															</label>
															<input
																type="tel"
																min="1"
																name="hourly-limit"
																id="hourly-limit"
																className={classNames(
																	"form-control",
																	{
																		"invalid-input":
																			!this.validateHourlyInput(
																				hourlyRestrictions.MaxWeeklyHours,
																			),
																	},
																)}
																value={
																	hourlyRestrictions.MaxWeeklyHours
																}
																onChange={this.handleHourlyRestrictionsChange(
																	"MaxWeeklyHours",
																)}
															/>
														</div>
													</div>
												</If>
											</div>
										</div>
									</If>
									{/* Location Restrictions */}
									<div
										id="locationrestrictions"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.location}
										>
											<h3 className="panel-title">
												{lang.t("Location Restrictions")}
											</h3>
										</div>
										<div className="panel-body container-fluid">
											<div className="standard-padding row">
												<div className="col-xs-12">
													<label htmlFor="UseZones">
														<input
															type="checkbox"
															name="UseZones"
															id="UseZones"
															checked={UseZones}
															onChange={this.handleUseZonesChange}
														/>
														{lang.t("Enable Zones for Locations")}
													</label>
												</div>
											</div>
											<div className="standard-padding row">
												<div className="col-xs-12">
													<label htmlFor="location-approval">
														<input
															type="checkbox"
															name="location-approval"
															id="location-approval"
															checked={IsJobLocationApprovalRequired}
															onChange={
																this.handleLocationApprovalChange
															}
														/>
														{lang.t(
															"Personnel are not allowed to work at denied addresses or locations",
														)}
													</label>
												</div>
											</div>
											<If
												condition={
													IsJobLocationApprovalRequired &&
													this.strictLocationManagementEnabled
												}
											>
												<div className="agency-user-location-restrictions">
													<div className="standard-padding row">
														<div className="col-xs-12">
															<label htmlFor="agency-users-create-jobs-with-approved-locations">
																<input
																	type="checkbox"
																	name="agency-users-create-jobs-with-approved-locations"
																	id="agency-users-create-jobs-with-approved-locations"
																	checked={
																		AgencyUsersCanOnlyCreateJobsWithApprovedLocations
																	}
																	onChange={this.handleAgencyUsersCanOnlyCreateJobsWithApprovedLocations(
																		"AgencyUsersCanOnlyCreateJobsWithApprovedLocations",
																	)}
																/>
																{lang.t(
																	"Agency users can not create jobs with locations pending approval",
																)}
															</label>
														</div>
													</div>
												</div>
											</If>
											<div className="standard-padding row">
												<div className="col-xs-12">
													<label htmlFor="IsJobLocationTypeRestricted">
														<input
															type="checkbox"
															name="IsJobLocationTypeRestricted"
															id="IsJobLocationTypeRestricted"
															onChange={
																this.handleJobLocationTypeChange
															}
															checked={IsJobLocationTypeRestricted}
														/>
														{lang.t(
															"Personnel are not allowed to work at specific venue types",
														)}
													</label>
												</div>
											</div>
											<If condition={IsJobLocationTypeRestricted === true}>
												<SelectBadges
													id="select-badges-account-settings"
													labelText={lang.t(
														"Please select all the categories of establishments that apply",
													)}
													defaultOption={lang.t(
														"Select the restricted locations",
													)}
													optionList={this.locationTypes}
													storedOptionList={RestrictedJobLocationTypes}
													handleOnChange={this.handleLocationTypeChange}
													handleOnDelete={this.handleRemoveLocationType}
												/>
											</If>
										</div>
									</div>
								</If>
								<If condition={!user.isSuperAdmin()}>
									{/* Officer Fulfillment/Applicant Restrictions */}
									<div
										id="officerfulfillment"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.fulfillment}
										>
											<h3 className="panel-title">
												{lang.t("Applicant Restrictions")}
											</h3>
											<small className="subtitle">
												{lang.t(
													"Set up when specific agency’s officers can apply to your jobs_",
												)}
											</small>
										</div>
										<div className="panel-body">
											<If condition={AllJurisdictions.length > 0}>
												<div className="standard-padding row hidden-xs restrictions-header">
													<div className="col-sm-3">
														{lang.t("Visibility")}
													</div>
													<div className="col-sm-4">
														{lang.t("Agency")}
													</div>
													<div className="col-sm-3 col-sm-offset-1">
														{lang.t("Time")}
													</div>
												</div>
												<div className="container-fluid settings-panel">
													<For
														each="agency"
														of={AllJurisdictions}
														index="index"
													>
														<div
															key={`agencyJurisdiction-${agency.JurisdictionId}`}
															className="row agency-restriction"
														>
															<div className="col-sm-3">
																<select
																	name={`JurisdictionVisibility-${agency.JurisdictionId}`}
																	title="Visibility"
																	className="custom-select form-control"
																	value={agency.Visibility}
																	onChange={this.handleUpdateAgency(
																		"agency-visibility",
																		index,
																	)}
																>
																	<For
																		each="item"
																		of={agencyVisibility}
																	>
																		<option
																			key={`${item.label}-${item.value}-${agency.JurisdictionId}`}
																			value={item.value}
																		>
																			{item.label}
																		</option>
																	</For>
																</select>
															</div>
															<div
																className="col-sm-4"
																style={{ minWidth: "200px" }}
															>
																<AsyncSelect
																	name={`jurisdiction-${agency.JurisdictionId || index}`}
																	title="Agency"
																	placeholder={lang.t(
																		"Agency Name",
																	)}
																	cacheOptions
																	loadOptions={
																		this
																			.loadUpdatedJurisdictions
																	}
																	value={
																		agency.JurisdictionName !==
																		""
																			? {
																					value: agency.JurisdictionId,
																					label: agency.JurisdictionName,
																				}
																			: ""
																	}
																	onChange={this.handleUpdateAgency(
																		"all-agencies",
																		index,
																	)}
																/>
															</div>
															<div
																className={`col-xs-2 ${agency.ExpiresBefore === 0 ? "hidden" : "col-sm-1"}`}
															>
																<div className="until">
																	{lang.t("Until")}
																</div>
															</div>
															<div
																className={
																	agency.ExpiresBefore === 0
																		? "col-xs-10 col-sm-4"
																		: "col-xs-8 col-sm-3"
																}
															>
																<select
																	title="Time"
																	style={{ paddingRight: "30px" }}
																	className="custom-select form-control"
																	value={agency.ExpiresBefore}
																	onChange={this.handleUpdateAgency(
																		"rule-expiry",
																		index,
																	)}
																>
																	<If
																		condition={
																			agency.ExpiresBefore ===
																			""
																		}
																	>
																		<option value="">
																			Select a time
																		</option>
																	</If>
																	<For
																		each="option"
																		of={
																			JURISDICTION_EXPIRES_OPTIONS
																		}
																	>
																		<option
																			key={`${option.label}-${option.value}-${agency.JurisdictionId}`}
																			value={option.value}
																		>
																			{option.label}
																		</option>
																	</For>
																</select>
															</div>
															<div className="col-xs-2 col-sm-1 text-center">
																<button
																	type="button"
																	className="btn btn-link"
																	onClick={() =>
																		this.handleDeleteAgency(
																			index,
																		)
																	}
																>
																	<i className="rkf rkf-trash text-danger" />
																</button>
															</div>
														</div>
													</For>
												</div>
											</If>
											<div className="standard-padding row restrictions-footer">
												<div className="col-xs-12 text-left">
													<button
														type="button"
														className="btn btn-link"
														title={lang.t("Add Agency")}
														onClick={() => this.handleAddAgency()}
													>
														{`+ ${lang.t("Add Agency")}`}
													</button>
												</div>
											</div>
										</div>
									</div>
								</If>
								<If condition={user.isLEA()}>
									{/* Supervisor Approvals */}
									<div
										id="supervisorapprovals"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.supervisorApproval}
										>
											<h3 className="panel-title">
												{lang.t("Supervisor Approvals")}
											</h3>
										</div>
										<div className="panel-body container-fluid">
											<div className="standard-padding row">
												<div className="col-xs-12">
													<label htmlFor="supervisor-approval">
														<input
															type="checkbox"
															name="supervisor-approval"
															id="supervisor-approval"
															checked={ExtraDutyApprovalRequired}
															onChange={() =>
																this.toggleSupervisorApproval()
															}
														/>
														{lang.t(
															"Allow supervisors to deny and approve jobs officers work_",
														)}
													</label>
												</div>
											</div>
										</div>
									</div>
									{/* Coordinator Jobs */}
									<div
										id="coordinatorjobs"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.coordinatorJobs}
										>
											<h3 className="panel-title">
												{lang.t("Coordinator Jobs")}
											</h3>
										</div>
										<div className="panel-body container-fluid">
											<div className="standard-padding row">
												<div className="col-xs-12">
													<label htmlFor="coord-jobs">
														<input
															type="checkbox"
															name="coord-jobs"
															id="coord-jobs"
															checked={OfficerCoordinatedJobsVisible}
															onChange={() =>
																this.toggleCoordinatorJobs()
															}
														/>
														{lang.t("View Coordinator Jobs")}
													</label>
												</div>
											</div>
										</div>
									</div>
									{/* Officer Insurance */}
									<div
										id="insurancesettings"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.insurance}
										>
											<h3 className="panel-title">
												{lang.t("Officer Insurance")}
											</h3>
										</div>
										<div className="panel-body container-fluid">
											<div className="standard-padding row">
												<div className="col-xs-12">
													<label htmlFor="insurance-optin">
														<input
															type="checkbox"
															name="insurance-optin"
															id="insurance-optin"
															checked={OfficerInsuranceOptIn}
															onChange={() =>
																this.toggleInsuranceOptIn()
															}
														/>
														{lang.t(
															"Automatically Opt-In All Officers to Insurance",
														)}
													</label>
												</div>
											</div>
										</div>
									</div>
								</If>
								{/* Payments & Invoicing Settings */}
								<If condition={user.isLEA() || user.isCoordinator()}>
									<div
										id="paymentsettings"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.paymentInvoicing}
										>
											<h3 className="panel-title">
												{lang.t("Payments & Invoice Settings")}
											</h3>
											<small className="text-muted">
												{lang.t(
													"Set/Update your fees for clients requesting to hire your officers_",
												)}
											</small>
										</div>
										<div className="panel-body container-fluid">
											<If condition={user.isLEA()}>
												<div className="standard-padding row">
													<div className="col-xs-12 form-group">
														<label htmlFor="transfer-payments">
															<input
																type="checkbox"
																name="transfer-payments"
																id="transfer-payments"
																checked={
																	TransferPaymentToJurisdiction
																}
																disabled={
																	!user.IsRKPay ||
																	!agencyInfo.BillingContactId
																}
																onChange={this.handlePaymentInvoiceChange(
																	"TransferPaymentToJurisdiction",
																)}
															/>
															{lang.t(
																"Transfer officer payments to agency",
															)}
															<Tooltip
																content={lang.t(
																	"The full amount of the invoice will be paid to the agency instead of being distributed to the police officers_",
																)}
															>
																<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
															</Tooltip>
														</label>
														<If condition={!user.IsRKPay}>
															<a
																href="/my-account#directdeposit"
																className="require-rkpay-link"
															>
																{lang.t(
																	"Requires deposit information",
																)}
															</a>
														</If>
													</div>
												</div>
												<div className="standard-padding row">
													<div className="col-xs-12 form-group">
														<label htmlFor="transfer-coordination-fees-to-agency">
															<input
																id="transfer-coordination-fees-to-agency"
																name="transfer-coordination-fees-to-agency"
																type="checkbox"
																disabled={!user.IsRKPay}
																checked={
																	TransferCoordinatorPaymentToJurisdiction
																}
																onChange={this.handlePaymentInvoiceChange(
																	"TransferCoordinatorPaymentToJurisdiction",
																)}
															/>
															{lang.t(
																"Transfer coordination fees to agency",
															)}
															<Tooltip
																content={lang.t(
																	"All coordination fees will be paid to the agency instead of being distributed to individual coordinator_",
																)}
															>
																<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
															</Tooltip>
														</label>
														<If condition={!user.IsRKPay}>
															<a
																href="/my-account#directdeposit"
																className="require-rkpay-link"
															>
																{lang.t(
																	"Requires deposit information",
																)}
															</a>
														</If>
													</div>
												</div>
											</If>
											<div className="standard-padding row">
												<div className="col-xs-12 form-group">
													<label htmlFor="organization-review-invoices">
														<input
															type="checkbox"
															name="organization-review-invoices"
															id="organization-review-invoices"
															checked={
																IsOfficerInvoiceApprovalRequired
															}
															onChange={this.handleOrganizationPaymentInvoiceChange(
																"IsOfficerInvoiceApprovalRequired",
															)}
														/>
														{lang.t(
															"Review officer invoices prior to client payment",
														)}
														<Tooltip
															content={lang.t(
																"Check this box if you would like to review and approve all invoices prior to them being sent to the client_",
															)}
														>
															<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</label>
												</div>
											</div>
											<div className="row">
												<button
													type="button"
													className="btn manage-invoice-btn"
													onClick={() => this.openInvoiceRulesModal()}
												>
													<span>{lang.t("Manage Invoicing Rules")}</span>
												</button>
											</div>
											<If condition={user.isLEA()}>
												<div className="row settings-title">
													<div className="col-xs-8">
														<h4 className="panel-title">
															{lang.t("General Fees")}
														</h4>
														<div
															className="custom-select col-xs-6"
															style={{
																border: "none",
																padding: 0,
																paddingTop: "15px",
															}}
														>
															<OrganizationDepositAccountSelect
																id="generalFeeAccountSelect"
																name="generalFeeAccountSelect"
																orgDepositAccounts={
																	orgDepositAccounts
																}
																orgFeeTypeId={
																	ORGANIZATION_FEE_TYPES.GENERAL_FEES
																}
																isLoading={
																	isLoadingOrganizationDepositAccounts
																}
																onEdit={this.onEditDepositAccount}
																onChange={
																	this
																		.handleSetOrganizationFeeToDepositAccount
																}
																selectedValue={
																	generalFeeDepositAccountId
																}
															/>
														</div>
													</div>
													<div className="col-xs-4 text-right">
														<button
															type="button"
															className="btn btn-link"
															title={lang.t("New General Fee")}
															onClick={() =>
																this.handleGeneralFeeAdd()
															}
															style={{ marginTop: "10px" }}
														>
															<span className="visible-xs">{`+ ${lang.t("New")}`}</span>
															<span className="hidden-xs">{`+ ${lang.t("New General Fee")}`}</span>
														</button>
													</div>
												</div>
											</If>
											<div className="standard-padding settings-panel">
												<If condition={fees.JurisdictionFees.length === 0}>
													<div className="row">
														<div className="col-xs-12 text-muted text-center">
															{lang.t("No fees added")}
														</div>
													</div>
												</If>
												<For
													each="fee"
													of={fees.JurisdictionFees}
													index="index"
												>
													<div
														className="row"
														key={
															fee.Id
																? `jurisdiction-fee_${fee.Id}`
																: `new-jurisdiction-fee_${index}`
														}
													>
														<div className="col-xs-5 col-sm-6 col-md-7 form-group">
															<input
																id={`jurisdiction-fee${index}`}
																name={`jurisdiction-fee${index}`}
																placeholder={lang.t("Description")}
																maxLength="50"
																className="form-control"
																value={fee.Description}
																onChange={this.handleGeneralFeeChange(
																	index,
																	"Description",
																)}
															/>
														</div>
														<div className="fee-rate form-group col-xs-5 col-sm-5 col-md-4">
															<input
																className="rate-input form-control"
																type="tel"
																min="1"
																placeholder="Rate"
																value={fee.Rate}
																onChange={this.handleGeneralFeeChange(
																	index,
																	"Rate",
																)}
															/>
															<select
																className="custom-select rate-type-input form-control"
																value={fee.JurisdictionFeeType}
																onChange={this.handleGeneralFeeChange(
																	index,
																	"JurisdictionFeeType",
																)}
															>
																<For
																	each="option"
																	of={JURISDICTION_FEE_TYPES}
																>
																	<option
																		key={`rate-type_${option.value}`}
																		value={option.value}
																	>
																		{option.label}
																	</option>
																</For>
															</select>
														</div>
														<div className="col-xs-2 col-sm-1 text-center">
															<Tooltip content={lang.t("Delete Fee")}>
																<button
																	type="button"
																	className="btn btn-link"
																	onClick={() =>
																		this.handleGeneralFeeDelete(
																			index,
																		)
																	}
																>
																	<i className="rkf rkf-trash text-danger" />
																</button>
															</Tooltip>
														</div>
													</div>
												</For>
											</div>
											<div className="standard-padding row">
												<div className="col-xs-11 form-group">
													<label htmlFor="invoice-disclaimer">
														{lang.t("Invoice")} {lang.t("Disclaimer")}
														<Tooltip
															content={lang.t(
																"This information will be shown to clients so they understand payment conditions",
															)}
														>
															<i className="hidden-xs rkf rkf-question-solid tooltip-icon" />
														</Tooltip>
													</label>
													<textarea
														id="invoice-disclaimer"
														name="invoice-disclaimer"
														className="form-control"
														rows={3}
														value={InvoiceDisclaimer}
														placeholder={lang.t(
															"e_g_ Net 15 for all invoices",
														)}
														onChange={this.handlePaymentInvoiceChange(
															"InvoiceDisclaimer",
														)}
													/>
												</div>
											</div>
											<If condition={PayCodesEnabled}>
												<div className="row settings-title">
													<h4 className="panel-title col-xs-10 col-sm-8">
														{lang.t("Pay Codes")}
													</h4>
													<div className="col-xs-2 col-sm-4 text-right">
														<button
															type="button"
															className="btn btn-link"
															title={lang.t("Add a New Pay Code")}
															onClick={() =>
																this.togglePaycodesModal()
															}
														>
															<span className="visible-xs">{`+ ${lang.t("New")}`}</span>
															<span className="hidden-xs">{`+ ${lang.t("Add a New Pay Code")}`}</span>
														</button>
													</div>
												</div>
												<div className="row">
													<div className="col-xs-12 form-group mandatory-radio">
														<h4 className="panel-title">
															{lang.t("Are pay codes mandatory_")}
														</h4>
														<YesNoRadioButton
															id="paycodes-enabled"
															name="paycodes-enabled"
															label=""
															checked={IsPayCodeMandatory}
															handleChange={
																this.handleEnablePaycodesChange
															}
														/>
													</div>
												</div>
												<div className="row paycode-section">
													<PayCodesTable
														paycodes={paycodes}
														user={user}
														editPaycode={id =>
															this.togglePaycodesModal(id)
														}
														deletePaycodes={pc =>
															this.deletePaycodes(pc)
														}
													/>
												</div>
											</If>
										</div>
									</div>
								</If>
								<If condition={user.isLEA()}>
									{/* Assets / Equipment */}
									<div
										id="assets"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.assetsEquipment}
										>
											<h3 className="panel-title">
												{lang.t("Assets / Equipment")}
											</h3>
											<small className="text-muted">
												{lang.t("Add vehicle fees and additional assets")}
											</small>
										</div>
										<div className="panel-body container-fluid">
											<div className="row settings-title">
												<div className="col-xs-8">
													<h4 className="panel-title">
														{lang.t("Additional Assets")}
													</h4>
													<div
														className="custom-select col-xs-6"
														style={{
															border: "none",
															padding: 0,
															paddingTop: "15px",
														}}
													>
														<OrganizationDepositAccountSelect
															id="equipmentFeeAccountSelect"
															name="equipmentFeeAccountSelect"
															orgDepositAccounts={orgDepositAccounts}
															orgFeeTypeId={
																ORGANIZATION_FEE_TYPES.EQUIPMENT_FEES
															}
															isLoading={
																isLoadingOrganizationDepositAccounts
															}
															onEdit={this.onEditDepositAccount}
															onChange={
																this
																	.handleSetOrganizationFeeToDepositAccount
															}
															selectedValue={
																equipmentFeeDepositAccountId
															}
														/>
													</div>
												</div>
												<div className="col-xs-4 text-right">
													<button
														type="button"
														className="btn btn-link"
														title={lang.t("New Asset")}
														onClick={() => this.handleAssetAdd()}
														style={{ marginTop: "10px" }}
													>
														<span className="visible-xs">{`+ ${lang.t("New")}`}</span>
														<span className="hidden-xs">{`+ ${lang.t("New Asset")}`}</span>
													</button>
												</div>
											</div>
											<div className="container-fluid settings-panel">
												<If
													condition={fees.JurisdictionAssets.length === 0}
												>
													<div className="row">
														<div className="col-xs-12 text-muted text-center">
															{lang.t("No assets defined_")}
														</div>
													</div>
												</If>
												<For
													each="asset"
													of={fees.JurisdictionAssets}
													index="index"
												>
													<div
														className="row"
														key={
															asset.Id
																? `jurisdiction-asset${asset.Id}`
																: `new-jurisdiction-asset_${index}`
														}
													>
														<div className="col-xs-5 col-sm-6 col-md-7 form-group">
															<input
																id={`jurisdiction-asset${index}`}
																name={`jurisdiction-asset${index}`}
																placeholder={lang.t("Description")}
																maxLength="50"
																className="form-control"
																value={asset.Description}
																onChange={this.handleAssetChange(
																	index,
																	"Description",
																)}
															/>
														</div>
														<div className="fee-rate form-group col-xs-5 col-sm-5 col-md-4">
															<input
																className="rate-input form-control"
																type="tel"
																min="1"
																placeholder="Rate"
																value={asset.Rate}
																onChange={this.handleAssetChange(
																	index,
																	"Rate",
																)}
															/>
															<div
																className="custom-select rate-type-input form-control"
																style={{ border: "none" }}
															>
																<ReactSelect
																	id="assetFeeSelect"
																	name="asseteFeeSelect"
																	options={JURISDICTION_FEE_TYPES.map(
																		option => ({
																			label: option.label,
																			value: option.value,
																		}),
																	)}
																	value={
																		asset.JurisdictionFeeType
																	}
																	onChange={this.handleAssetChange(
																		index,
																		"JurisdictionFeeType",
																	)}
																/>
															</div>
														</div>
														<div className="col-xs-2 col-sm-1 text-right">
															<Tooltip
																content={lang.t("Delete Asset")}
																placement="top"
															>
																<button
																	type="button"
																	className="btn btn-link"
																	onClick={() =>
																		this.handleAssetDelete(
																			index,
																		)
																	}
																>
																	<i className="rkf rkf-trash text-danger" />
																</button>
															</Tooltip>
														</div>
													</div>
												</For>
											</div>
											<div className="row settings-title">
												<div className="col-xs-8">
													<h4 className="panel-title">
														{lang.t("Vehicle Fees")}
													</h4>
													<div
														className="custom-select col-xs-6"
														style={{
															border: "none",
															padding: 0,
															paddingTop: "15px",
														}}
													>
														<OrganizationDepositAccountSelect
															id="vehicleFeeAccountSelect"
															name="vehicleFeeAccountSelect"
															orgDepositAccounts={orgDepositAccounts}
															orgFeeTypeId={
																ORGANIZATION_FEE_TYPES.VEHICLE_FEES
															}
															isLoading={
																isLoadingOrganizationDepositAccounts
															}
															onEdit={this.onEditDepositAccount}
															onChange={
																this
																	.handleSetOrganizationFeeToDepositAccount
															}
															selectedValue={
																vehicleFeeDepositAccountId
															}
														/>
													</div>
												</div>
												<div className="col-xs-4 text-right">
													<button
														type="button"
														className="btn btn-link"
														title={lang.t("New Vehicle Fee")}
														onClick={() => this.handleVehicleFeeAdd()}
														style={{ marginTop: "10px" }}
													>
														<span className="visible-xs">{`+ ${lang.t("New")}`}</span>
														<span className="hidden-xs">{`+ ${lang.t("New Vehicle Fee")}`}</span>
													</button>
												</div>
											</div>
											<div className="container-fluid settings-panel">
												<If
													condition={
														fees.JurisdictionVehicleFees.length === 0
													}
												>
													<div className="row">
														<div className="col-xs-12 text-muted text-center">
															{lang.t("No vehicle fees")}
														</div>
													</div>
												</If>
												<For
													each="vehicle"
													of={fees.JurisdictionVehicleFees}
													index="index"
												>
													<div
														className="row"
														key={
															vehicle.Id
																? `vehicle-fee${vehicle.Id}`
																: `new-vehicle-fee_${index / fees.JurisdictionVehicleFees.length}`
														}
													>
														<div className="col-xs-5 col-sm-6 col-md-7 form-group">
															<div
																className="custom-select form-control"
																style={{
																	border: "none",
																	padding: 0,
																	paddingTop: "2px",
																}}
															>
																<ReactSelect
																	id={`vehicle-options${index}`}
																	name={`vehicle-options${index}`}
																	options={vehicleTypes
																		.filter(
																			item =>
																				!fees.JurisdictionVehicleFees.some(
																					f =>
																						f.VehicleTypeId.toString() ===
																						item.Id.toString(),
																				) ||
																				vehicle.VehicleTypeId.toString() ===
																					item.Id.toString(),
																		)
																		.map(option => ({
																			label: option.Name,
																			value: option.Id,
																		}))}
																	value={vehicle.VehicleTypeId}
																	onChange={this.handleVehicleFeeChange(
																		index,
																		"VehicleTypeId",
																	)}
																/>
															</div>
														</div>
														<div className="fee-rate form-group col-xs-5 col-sm-5 col-md-4">
															<input
																className="rate-input form-control"
																type="tel"
																min="1"
																placeholder="Rate"
																value={vehicle.Rate}
																onChange={this.handleVehicleFeeChange(
																	index,
																	"Rate",
																)}
															/>
															<div
																className="custom-select rate-type-input form-control"
																style={{ border: "none" }}
															>
																<ReactSelect
																	id="vehicleFeeSelect"
																	name="vehicleFeeSelect"
																	options={JURISDICTION_FEE_TYPES.map(
																		option => ({
																			label: option.label,
																			value: option.value,
																		}),
																	)}
																	value={
																		vehicle.JurisdictionFeeType
																	}
																	onChange={this.handleVehicleFeeChange(
																		index,
																		"JurisdictionFeeType",
																	)}
																/>
															</div>
														</div>
														<div className="col-xs-2 col-sm-1 text-right">
															<Tooltip content={lang.t("Delete Fee")}>
																<button
																	type="button"
																	className="btn btn-link"
																	onClick={() =>
																		this.handleVehicleFeeDelete(
																			index,
																		)
																	}
																>
																	<i className="rkf rkf-trash text-danger" />
																</button>
															</Tooltip>
														</div>
													</div>
												</For>
											</div>
											<div className="row settings-title">
												<h4 className="panel-title col-xs-12">
													{lang.t("Vehicle Management")}
												</h4>
											</div>
											<div className="col-xs-6 text-left">
												<button
													type="button"
													className="btn btn-primary margin-top-10 margin-bottom-15"
													title={lang.t("Manage Vehicles")}
													onClick={() => this.openManageVehiclesModal()}
												>
													<span>{`${lang.t("Manage Vehicles")}`}</span>
												</button>
											</div>
											<div className="col-xs-12 form-group">
												<label htmlFor="only-authorized-clients-vehicles">
													<input
														type="checkbox"
														name="only-authorized-clients-vehicles"
														id="only-authorized-clients-vehicles"
														checked={
															OnlyAuthorizedClientsAreAllowedToUseVehicles
														}
														onChange={this.handleOnlyAuthorizedClientsAreAllowedToUseVehicles(
															"OnlyAuthorizedClientsAreAllowedToUseVehicles",
														)}
													/>
													{lang.t(
														"Only authorized clients are allowed to use vehicles",
													)}
												</label>
											</div>
											<If condition={user.isInvoicingV3()}>
												<div className="col-xs-12 form-group">
													<label htmlFor="require-vehicle-invoicing">
														<input
															type="checkbox"
															name="require-vehicle-invoicing"
															id="require-vehicle-invoicing"
															checked={RequireInvoicingForVehicles}
															onChange={this.handleRequireInvoicingForVehicles(
																"RequireInvoicingForVehicles",
															)}
														/>
														{lang.t("Require invoicing for vehicles")}
													</label>
												</div>
											</If>
											<div className="col-xs-12 form-group">
												<label htmlFor="require-vehicle-number">
													<input
														type="checkbox"
														name="require-vehicle-number"
														id="require-vehicle-number"
														checked={RequireVehicleNumber}
														onChange={this.handleVehicleNumberReqChange(
															"RequireVehicleNumber",
														)}
													/>
													{lang.t(
														"Require vehicle number when clocking in",
													)}
												</label>
											</div>
											<div className="col-xs-12 form-group">
												<label htmlFor="require-vehicle-miles">
													<input
														type="checkbox"
														name="require-vehicle-miles"
														id="require-vehicle-miles"
														checked={RequireVehicleMiles}
														onChange={this.handleVehicleMilesReqChange(
															"RequireVehicleMiles",
														)}
													/>
													{lang.t(
														"Require vehicle miles when clocking in and out of a job",
													)}
												</label>
											</div>
										</div>
									</div>
									{/* Payment Methods */}
									<If condition={user?.Organization?.StripeSubscriptionEnabled}>
										<div
											id="subscriptions"
											className="panel panel-default"
										>
											<div
												className="panel-heading"
												ref={this.sectionRefs.subscriptions}
											>
												<div className="row">
													<div className="col-xs-6 col-sm-8">
														<h3 className="panel-title">
															{lang.t("Subscriptions")}
														</h3>
														<small className="text-muted">
															{lang.t("Manage subscriptions")}
														</small>
													</div>
													<If
														condition={
															(billingHistory || []).length > 0
														}
													>
														<div className="col-xs-6 col-sm-4 text-right">
															<button
																type="button"
																id="view-billing-history"
																className="btn btn-link"
																onClick={() =>
																	this.toggleBillingHistoryModal()
																}
															>
																{lang.t("View Billing History")}
															</button>
														</div>
													</If>
												</div>
											</div>
											<div className="panel-body container-fluid">
												<div className="row settings-title">
													<h4 className="panel-title col-xs-10 col-sm-8 ">
														{lang.t("Payment Methods")}
													</h4>
													<div className="col-xs-2 col-sm-4 text-right">
														<button
															type="button"
															className="btn btn-link"
															title={lang.t("Add Payment Method")}
															onClick={this.openAddPaymentMethodModal}
														>
															<span className="visible-xs">{`+ ${lang.t("Add")}`}</span>
															<span className="hidden-xs">{`+ ${lang.t("Add Payment Method")}`}</span>
														</button>
													</div>
												</div>
												<div
													id="payment-methods-list"
													className="container-fluid settings-panel"
												>
													<Choose>
														<When
															condition={
																paymentMethods.data.length === 0
															}
														>
															<div className="row">
																<div className="col-xs-12 text-center text-muted">
																	{lang.t(
																		"There are no payment methods associated with this account",
																	)}
																</div>
															</div>
														</When>
														<Otherwise>
															<For
																each="item"
																of={bankAccounts}
															>
																<div
																	className="row"
																	key={`payment_method_${item.Id}`}
																>
																	<div className="col-xs-8 col-sm-7">
																		{`${item.Ach.BankName}: ****${item.Ach.AccountNumber}`}
																	</div>
																	<div className="col-xs-4 col-sm-3 text-right">
																		<Choose>
																			<When
																				condition={
																					item.Ach
																						.Status ===
																					BANK_ACCOUNT_STATUSES
																						.NEW.value
																				}
																			>
																				<button
																					type="button"
																					className="btn btn-link"
																					onClick={this.onBankAccountVerification(
																						item.Id,
																					)}
																				>
																					{lang.t(
																						"Verify",
																					)}
																				</button>
																			</When>
																			<Otherwise>
																				{this.getBankAccountBadge(
																					item.Id,
																					item.Ach.Status,
																				)}
																			</Otherwise>
																		</Choose>
																	</div>
																	<div className="col-xs-12 col-sm-2 text-right">
																		<button
																			type="button"
																			className="btn btn-link"
																			id={`remove-org-payment-method-${item.Id}`}
																			onClick={this.onDeletePaymentMethod(
																				item.Id,
																			)}
																		>
																			<span className="text-danger">
																				{lang.t("Remove")}
																			</span>
																		</button>
																	</div>
																</div>
															</For>

															<For
																each="item"
																of={creditCards}
															>
																<div
																	className="row"
																	key={`payment_method_${item.Id}`}
																>
																	<div className="col-xs-12 col-sm-7">
																		<div className="card-name">
																			<Image
																				src={
																					CARD_ICONS[
																						item.Card.CardType.replace(
																							" ",
																							"-",
																						).toLowerCase()
																					] ??
																					CARD_ICONS.default
																				}
																			/>
																			<span>{`${item.Card.CardType}: ****${item.Card.CardNumber}`}</span>
																		</div>
																	</div>
																	<div className="col-xs-6 col-sm-3 set-preferred-btn">
																		<Choose>
																			<When
																				condition={
																					item.DefaultInvoicePaymentMethod
																				}
																			>
																				{lang.t("Default")}
																			</When>
																			<Otherwise>
																				<button
																					type="button"
																					className="btn btn-link"
																					onClick={this.onSetPreferredMethod(
																						item.Id,
																					)}
																				>
																					{lang.t(
																						"Set as preferred",
																					)}
																				</button>
																			</Otherwise>
																		</Choose>
																	</div>
																	<div className="col-xs-6 col-sm-2 text-right">
																		<button
																			type="button"
																			className="btn btn-link"
																			id={`remove-org-payment-method-${item.Id}`}
																			onClick={this.onDeletePaymentMethod(
																				item.Id,
																			)}
																		>
																			<span className="text-danger">
																				{lang.t("Remove")}
																			</span>
																		</button>
																	</div>
																</div>
															</For>
														</Otherwise>
													</Choose>
													<Loader active={paymentMethods.loading} />
												</div>
											</div>
										</div>
									</If>
								</If>
								{/* Job Tags */}
								<If
									condition={
										user.isLEA() || user.isCoordinator() || user.isAgencyAdmin()
									}
								>
									<div
										id="jobtags"
										className="panel panel-default"
									>
										<div
											className="panel-heading"
											ref={this.sectionRefs.jobTags}
										>
											<h3 className="panel-title">{lang.t("Job Tags")}</h3>
											<small className="text-muted">
												{lang.t("Manage job tags")}
											</small>
										</div>
										<div className="panel-body container-fluid">
											<div className="row settings-title">
												<h4 className="panel-title col-xs-10">
													{lang.t("Tags")}
												</h4>
												<div className="col-xs-2 text-right">
													<button
														type="button"
														className="btn btn-link"
														title={lang.t("New Job Tag")}
														onClick={() => this.handleTagAdd()}
													>
														<span className="visible-xs">{`+ ${lang.t("New")}`}</span>
														<span className="hidden-xs">{`+ ${lang.t("New Job Tag")}`}</span>
													</button>
												</div>
											</div>
											<div className="container-fluid settings-panel">
												<If condition={jobTags.length === 0}>
													<div className="row">
														<div className="col-xs-12 text-muted text-center">
															{lang.t("No job tags defined")}
														</div>
													</div>
												</If>
												<For
													each="jobTag"
													of={jobTags}
													index="index"
												>
													<div
														className="row"
														key={
															jobTag.Id
																? `jurisdiction-jobtag_${jobTag.Id}`
																: `new-jurisdiction-jobtag_${index}`
														}
													>
														<div className="col-xs-10 form-group">
															<input
																id={`jurisdiction-jobtag${index}`}
																name={`jurisdiction-jobtag${index}`}
																placeholder={lang.t("Name")}
																maxLength="50"
																className="form-control"
																value={jobTag.Name}
																onChange={this.handleTagChange(
																	index,
																	"Name",
																)}
															/>
														</div>
														<div className="col-xs-2 col-sm-1 text-right">
															<Tooltip
																content={lang.t("Delete Tag")}
																placement="top"
															>
																<button
																	type="button"
																	className="btn btn-link"
																	onClick={() =>
																		this.handleTagDelete(index)
																	}
																>
																	<i className="rkf rkf-trash text-danger" />
																</button>
															</Tooltip>
														</div>
													</div>
												</For>
											</div>
										</div>
									</div>
								</If>
								<div className="row">
									<div className="text-center">
										<ProgressButton
											className="btn btn-primary btn-big"
											state={buttonState}
											onClick={() => this.updateAgencySettings()}
										>
											{lang.t("Save Changes")}
										</ProgressButton>
									</div>
								</div>
							</Otherwise>
						</Choose>
					</div>
					<div className="hidden-xs hidden-sm col-md-4">
						<h4 ref={this.settingsMenuTitle}>{lang.t("Settings Menu")}</h4>
						<SettingsMenu
							user={user}
							activeSection={activeSection}
							scrollToSection={this.scrollToSection}
						/>
					</div>
				</div>
				{/* Modals */}
				<AgencyRulesModal
					show={showAgencyRulesModal}
					onHide={this.toggleAgencyRulesModal}
					handleSave={this.updateAgencySettings}
					rules={agencyAssignmentRules}
					handleChange={this.handleAgencyRuleChange}
					isInternalCoordinator={user.IsInternalCoordinator}
					userData={user} // TODO: remove this when the seniority draft is no longer needed for Adventure PD only
				/>
				<AssignmentRulesModal
					show={showAssignmentRulesModal}
					closeModal={this.closeAssignmentRulesModal}
					assignmentRuleId={assignmentRuleId}
					officerGroups={officerGroups}
					successCallback={this.getAssignmentRules}
					userData={user} // TODO: remove this when the seniority draft is no longer needed for Adventure PD only
				/>
				<ManageAssignmentsModal
					show={showManageAssignmentsModal}
					onHide={this.closeManageAssignmentsModal}
					assignmentRules={assignmentRules}
					staggeredRules={staggeredRules}
					handleRuleDelete={this.handleRuleDelete}
					handleRuleEdit={this.openAssignmentRulesModal}
					handleStaggeredRuleEdit={this.openStaggeredRulesModal}
					handleStaggeredRuleDelete={this.handleStaggeredRuleDelete}
				/>
				<StaggeredRuleModal
					show={showStaggeredRulesModal}
					onHide={this.closeStaggeredRulesModal}
					staggeredRuleId={staggeredRuleId}
					handleRuleDelete={this.handleRuleDelete}
					handleRuleEdit={this.openAssignmentRulesModal}
					successCallback={this.getStaggeredRules}
					assignmentRules={assignmentRulesDetailed}
					user={user}
				/>
				<ManageVehiclesModal
					show={showManageVehiclesModal}
					onHide={this.closeManageVehiclesModal}
					user={user}
				/>
				<InvoicingRulesModal
					show={showInvoicingRulesModal}
					closeModal={this.closeInvoicingRulesModal}
					invoiceRules={invoiceRules}
					clients={clients}
					paycodes={jobPaycodes}
					ranks={ranks}
					onCreate={this.createInvoiceRule}
					onUpdate={this.updateInvoiceRule}
					onDelete={this.deleteInvoiceRule}
					onRuleBulkUpdate={this.invoicingRuleBulkUpdate}
					onBulkCreate={this.invoicingRuleBulkCreate}
					userData={user}
					payCodesEnabled={PayCodesEnabled}
				/>
				<ConfirmationModal ref={this.confirmationModal} />
				<ConfirmationModal ref={this.confirmationModal2} />
				<ConfirmationModal ref={this.deleteOfficerAcknowledgeConfirmationModal} />
				<EditImageModal
					show={showEditImageModal}
					closeModal={this.closeEditImageModal}
					successCallback={this.handleImageUpload}
					imageToEdit={imageToEdit}
				/>
				<BillingHistoryModal
					show={showBillingHistoryModal}
					onHide={this.toggleBillingHistoryModal}
					billingHistory={billingHistory || []}
					TimeZoneId={TimeZoneId}
					leaName={user.Organization.Name}
				/>
				<PaycodesModal
					show={showPaycodesModal}
					onHide={this.togglePaycodesModal}
					onSave={this.savePaycode}
					user={user}
					paycode={currentPaycode}
				/>
				<AddPaymentMethodModal
					user={user}
					onSubmit={this.savePaymentMethod}
					ref={this.addPaymentMethodModal}
				/>
				<OrganizationEmailModal
					user={user}
					ref={this.organizationEmailModal}
					callback={this.organizationEmailCallback}
				/>

				{/* callback reloads the list because the API doesn't return the updated bank status */}
				<BankVerificationModal
					ref={this.bankVerificationModal}
					organizationId={user.Organization.Id}
					callback={this.getPaymentMethods}
				/>

				<DirectDepositAccountModal
					show={showDirectDepositModal}
					onHide={() => this.setState({ showDirectDepositModal: false })}
					user={user}
					isOrganizationDepositAccount
					callback={this.saveDepositAccountCallback}
					data={organizationDepositAccount}
				/>

				<If condition={showPreview}>
					<div className="preview-landing-page">
						<div className="close-preview">
							<button
								type="button"
								onClick={this.closePreview}
							>
								<i className="glyphicon glyphicon-eye-close" />{" "}
								{lang.t("Close Preview")}
							</button>
						</div>

						<LandingPagePreview
							organizationLogoUrl={profilePicUrl}
							nameForDisplay={nameForDisplay}
							customPolicies={customPolicies}
						/>
					</div>
				</If>
			</div>
		);
	}
}

const mapDispatchToProps = dispatch => ({
	receiveUser: bindActionCreators(Actions, dispatch).receiveUser,
});

AgencyAccount.propTypes = {
	user: PropTypes.object,
	router: PropTypes.object.isRequired,
	route: PropTypes.object.isRequired,
	receiveUser: PropTypes.func.isRequired,
	flags: PropTypes.object.isRequired,
};

AgencyAccount.defaultProps = {
	user: {},
};

export default withLDConsumer()(connect(null, mapDispatchToProps)(AgencyAccount));
